<template>
  <div style="height:100vh;">

    <!-- Password Modal -->
    <b-modal id="modal_password" title="กรุณาใส่รหัสผ่านเพื่อเข้าใช้งาน" hide-header-close hide-footer centered
      no-close-on-backdrop no-close-on-esc static v-model="showPasswordModal">
      <form class="text-center" @submit.prevent="checkPassword">
        <input v-model.lazy="passwordInput" type="password" name="password"
          autocomplete="current-password" class="form-control" placeholder="รหัสผ่าน" />
        <button type="submit" class="btn btn-primary mt-3">ยืนยัน</button>
        <div v-if="wrongPassword" class="text-danger mt-2">รหัสผ่านไม่ถูกต้อง</div>
      </form>
    </b-modal>

    <!-- ==================== PDF GENERATORS ==================== -->
    <!-- Report 3 - รายการจัดสินค้า -->
    <vue-html2pdf v-bind="pdfConfigReport3" ref="Report3"
      @progress="genPDFProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)">
      <section slot="pdf-content" style="font-size:0.9em;">
        <div class="row pl-4 pr-4">
          <div class="col-12 pl-4 pr-4">
            <h5 class="font-weight-bold text-center mb-3">รายการจัดสินค้า{{ todayDateX() }}</h5>
          </div>

          <!-- Header Row -->
          <div class="row w-100 mb-2">
            <div class="col-4 text-center font-weight-bold">ชื่อสินค้า</div>
            <div class="col-2 text-center font-weight-bold">นับเช้า</div>
            <div class="col-1 pl-0 pr-0 text-center font-weight-bold">ขายออก</div>
            <div class="col-1 pl-0 pr-0 text-center font-weight-bold">เหลือ</div>
            <div class="col-2 text-center font-weight-bold">นับเย็น</div>
            <div class="col-2 pl-0 text-center font-weight-bold">หมายเหตุ</div>
          </div>

          <!-- Stock Rows -->
          <div class="row w-100" v-for="(i, id) in random_stocks" :key="id" style="margin-bottom:2px;">
            <div class="col-4 text-truncate">
              <strong>{{ id + 1 }}.</strong>&nbsp;&nbsp;
              <span :style="i.TODAY_SOR_QTY > 0 ? 'text-decoration:underline;' : ''">{{ i.STKDES }}</span>
            </div>
            <div class="col-2 text-right">
              <template v-if="isToday(i.counted_at)">
                <div class="w-100 text-center font-weight-bold">
                  {{ atomDisplay(i.COUNT_ATOM, i.CFACTOR) }}
                </div>
              </template>
              <template v-else><div class="cell-empty">&nbsp;</div></template>
            </div>
            <div class="col-1 pl-1 pr-1 text-center">
              {{ atomDisplay(i.TODAY_SELL_ATOM_QTY + (i.ATOM_ORDQTY - i.ATOM_ORDQTY_DONE), i.CFACTOR) }}
            </div>
            <div class="col-1 pl-1 pr-1 text-center">
              <template v-if="isToday(i.counted_at)">
                {{ atomDisplay(i.COUNT_ATOM - i.ATOM_ORDQTY, i.CFACTOR) }}
              </template>
              <template v-else><div class="cell-empty">&nbsp;</div></template>
            </div>
            <div class="col-2 text-right">
              <template v-if="isToday(i.counted_at_last) && isToday(i.counted_at)">
                <div class="w-100 text-center font-weight-bold">
                  {{ atomDisplay(i.COUNT_ATOM_LAST, i.CFACTOR) }}
                </div>
              </template>
              <template v-else><div class="cell-empty">&nbsp;</div></template>
            </div>
            <div class="col-2 pl-0 text-center">
              <template v-if="isToday(i.counted_at_last) && isToday(i.counted_at)">
                <span class="font-weight-bold">
                  {{ getCountLastRemark(i) }}
                </span>
                <span v-show="(i.COUNT_ATOM_LAST - (i.COUNT_ATOM - i.ATOM_ORDQTY) != 0)">
                  {{ getValueFromAtom(i.COUNT_ATOM_LAST - (i.COUNT_ATOM - i.ATOM_ORDQTY), i.CFACTOR).CONCAT }}
                  {{ i.PQUCOD }}
                </span>
              </template>
              <template v-else><div class="cell-empty">&nbsp;</div></template>
            </div>
          </div>

          <!-- Truck Info -->
          <div class="row w-100 mt-2 pl-2 pr-2">
            <div class="col-3 pl-1 pr-1 pt-1 pb-0" v-for="(truck, truckKey) in random_stocks_trucks" :key="truckKey">
              <div class="truck-box">
                <div class="row pl-3 pr-3 pt-0 pb-0">
                  <div class="col-6 p-0 pb-1 bg-dark text-center text-light">
                    <span class="font-weight-bold" style="font-size:1em;">{{ truckKey }}</span>
                  </div>
                  <div class="col-6 p-0 pb-1 text-right font-weight-bold">
                    {{ truck.total_value.toLocaleString(undefined, { minimumFractionDigits: 0 }) }}฿
                  </div>
                </div>
                <div class="row pl-3 pr-3 pt-0 pb-0" style="font-size:0.8em;">
                  <div class="col-6 p-1">
                    <div class="text-truncate" v-for="(cus, k) in truck.cus_name.filter((a, b) => b < 6)" :key="k">
                      {{ k + 1 }}. {{ cus }}
                    </div>
                  </div>
                  <div class="col-6 p-1">
                    <div class="text-truncate" v-for="(cus, k) in truck.cus_name.filter((a, b) => b >= 6)" :key="k">
                      <span v-show="(k + 7) <= 12">
                        <template v-if="truck.cus_name.length > 10 && (k + 7) == 12">
                          ...และอีก {{ truck.cus_name.length - 11 }} ราย
                        </template>
                        <template v-else-if="(k + 7) <= 12">{{ k + 7 }}. {{ cus }}</template>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Footer boxes -->
          <div class="row w-100 mt-2 pl-2 pr-2">
            <div class="col-1 pl-1 pr-1">
              <span class="footer-label"><strong>ซ้อเบิก</strong></span>
              <div class="footer-box">
                <span class="footer-value">{{ hasSorQty }}</span>
              </div>
            </div>
            <div class="col-2 pl-1 pr-1">
              <span class="footer-label"><strong>มูลค่าสินค้าขาด</strong></span>
              <div class="footer-box">
                <span class="font-weight-bold" style="font-size:1em;">
                  <template v-if="random_stocks_diff_value">
                    {{ random_stocks_diff_value.toLocaleString(undefined, { minimumFractionDigits: 0 }) }}฿
                  </template>
                  <template v-else>-</template>
                </span>
              </div>
            </div>
            <div class="col-3 pl-1 pr-1">
              <span class="footer-label">ผู้รับผิดชอบ <strong>นับเช้า</strong>
                {{ today_sells.atom_qty }} : {{ today_sells.volumn - today_sells.cost }}</span>
              <div class="footer-box-empty"></div>
            </div>
            <div class="col-3 pl-1 pr-1">
              <span class="footer-label">ผู้รับผิดชอบ <strong>คีย์ข้อมูล</strong></span>
              <div class="footer-box-empty"></div>
            </div>
            <div class="col-3 pl-1 pr-1">
              <span class="footer-label">ผู้รับผิดชอบ <strong>นับเย็น</strong></span>
              <div class="footer-box-empty"></div>
            </div>
          </div>
        </div>
      </section>
    </vue-html2pdf>

    <!-- Report 2 - สินค้าแยกประเภท -->
    <vue-html2pdf v-bind="pdfConfigReport2" ref="Report2"
      @progress="genPDFProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)">
      <section slot="pdf-content">
        <!-- Each stock group section -->
        <template v-for="(group, gIdx) in report2Groups">
          <div v-if="group.pageBreakBefore" :key="'pb-'+gIdx" class="html2pdf__page-break"/>
          <div class="row pl-4 pr-4" :key="'grp-'+gIdx">
            <div class="col-12 pl-4 pr-4">
              <h6 class="font-weight-bold text-center mb-1">{{ group.title }} {{ todayDateX() }}</h6>
              <table class="table table-sm table-borderless no-padding m-0 p-0" style="font-size:0.75em;color:black;">
                <tbody>
                  <tr v-for="(items, supplierId) in stocks_by_STKGRP(group.code)" :key="supplierId">
                    <td>
                      <section v-for="(n, k) in items" :key="k" class="pdf-item m-0 p-0">
                        <div class="d-flex p-0 m-0">
                          <div class="w-100 pl-1 stock-grp-name" :style="k === 0 && 'border-top:1px solid #999;'">
                            <strong>{{ n.STKDES }}</strong>
                          </div>
                          <div class="stock-grp-sell" :style="k === 0 && 'border-top:1px solid #999;'">
                            ขาย : {{ n.AVG_SELL }} {{ n.PQUCOD }}/{{ freqLabel(n.order_frequency) }}
                          </div>
                          <div class="stock-grp-bar" :style="k === 0 && 'border-top:1px solid #111;'">
                            <span v-if="!n.NOT_COUNT" class="stock-grp-bar-text"
                              :style="!n.count_expired ? 'font-weight:bold' : 'font-weight:normal;'">
                              {{ n.LOCBAL }}
                            </span>
                            <div class="stock-grp-bar-bg">
                              <div style="height:100%;background:#bbb !important;"
                                :style="n.PERCENT > 100 ? 'width:100%' : n.PERCENT <= 0 ? 'width:0px' : 'width:' + n.PERCENT + '%'">
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="n.seq == 30 && n.length > 30" class="html2pdf__page-break"/>
                      </section>
                      <br style="content: ''; margin: 2em; display: block; font-size: 30%;"/>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </template>
      </section>
    </vue-html2pdf>

    <!-- Report 1 - Summary -->
    <vue-html2pdf v-bind="pdfConfigReport1" ref="Report1"
      @progress="genPDFProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)">
      <section slot="pdf-content">
        <div class="row m-2 ml-3" style="height:778px;">
          <!-- Left Column -->
          <div class="col-6 pl-3 pr-3 pt-0 pb-0" style="border-right:1px solid #ddd;height:778px;">
            <div class="row" style="height:778px;">
              <!-- Summary Stats -->
              <div class="col-12 p-2 pl-2 pr-2" style="border-bottom:1px solid #ddd;height:50%;overflow:hidden;">
                <h6 class="font-weight-bold text-center">
                  <img src="../assets/bss2008.png" class="d-inline-block mr-1" style="height:40px;margin-top:2px;">
                  {{ todayDateX() }}
                </h6>
                <table class="table table-sm table-borderless no-padding p-0 mt-2" style="font-size:0.9em;">
                  <tbody>
                    <tr v-for="(stat, sIdx) in summaryStats" :key="sIdx"
                      :class="{ 'font-weight-bold': stat.bold }">
                      <td v-if="stat.spacer" colspan="3" style="font-size:0.5em;">&nbsp;</td>
                      <template v-else>
                        <td :class="{ 'font-weight-bold': stat.bold }">{{ stat.label }}</td>
                        <td class="text-right" :class="{ 'font-weight-bold': stat.bold }">{{ stat.value }}</td>
                        <td class="text-right" :class="{ 'font-weight-bold': stat.bold }">รายการ</td>
                      </template>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Warning stocks -->
              <div class="col-12 p-2" style="height:50%;overflow:hidden;">
                <h6 class="font-weight-bold text-center mb-1">
                  สินค้าใกล้หมดไม่มี PO {{ stocks_warning.length }} รายการ
                </h6>
                <table class="table table-sm table-borderless no-padding m-0 p-0" style="font-size:0.7em;">
                  <tbody>
                    <tr v-for="(item, id) in stocks_warning.slice(0, 20)" :key="id">
                      <td class="text-truncate">
                        <div class="p-0 m-0 d-flex align-item-start">
                          <span class="d-inline-block text-right p-0 m-0 mr-1" style="width:15px;">
                            <strong>{{ id + 1 }}.</strong>
                          </span>
                          <span class="truncate-170">{{ item.STKDES }}</span>
                        </div>
                      </td>
                      <td class="text-right">{{ item.LOCBAL }}</td>
                      <td class="text-right">{{ item.PQUCOD }}</td>
                    </tr>
                    <tr v-if="stocks_warning.length >= 20">
                      <td class="text-center" colspan="3" style="font-style: italic;">
                        ... และอื่นๆอีก {{ stocks_warning.length - 20 }} รายการ
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Right Column -->
          <div class="col-6 pl-3 pr-3 pt-0 pb-0" style="height:778px;">
            <div class="row">
              <!-- Diff stocks -->
              <div class="col-12 p-2 pb-3" style="max-height:389px;border-bottom:1px solid #ddd;overflow:hidden;">
                <h6 class="font-weight-bold text-center mb-1">
                  สต็อกขาดและเกิน {{ stocks_today_counted_peterDiff.length }} รายการ
                </h6>
                <table v-if="stocks_today_counted_peterDiff.length > 0"
                  class="table table-sm table-borderless no-padding m-0 p-0" style="font-size:0.7em;">
                  <tbody>
                    <tr v-for="(item, id) in stocks_today_counted_peterDiff.slice(0, 20)" :key="id">
                      <td class="text-truncate">
                        <div class="p-0 m-0 d-flex align-item-start">
                          <span class="d-inline-block text-right p-0 m-0 mr-1" style="width:15px;">
                            <strong>{{ id + 1 }}.</strong>
                          </span>
                          <span class="truncate-170">
                            <span v-if="item.FIRST_TIME_COUNT" style="color:#aaa;">[ตั้งต้น] </span>
                            {{ item.STKDES }}
                          </span>
                        </div>
                      </td>
                      <td class="text-right">{{ getValueFromAtom(item.peter_DIFF, item.CFACTOR).BIG }}</td>
                      <td class="text-right">{{ item.PQUCOD }}</td>
                    </tr>
                    <tr v-if="stocks_today_counted_peterDiff.length >= 20">
                      <td class="text-center" colspan="3" style="font-style: italic;">
                        ... และอื่นๆอีก {{ stocks_today_counted_peterDiff.length - 20 }} รายการ
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- PO stocks -->
              <div class="col-12 p-2" style="overflow:hidden;">
                <h6 class="font-weight-bold text-center mb-1">สินค้าค้างรับ {{ stocks_is_po.length }} รายการ</h6>
                <table class="table table-sm table-borderless no-padding m-0 p-0" style="font-size:0.7em;">
                  <tbody>
                    <tr v-for="(item, id) in stocks_is_po.slice(0, poDisplayCount)" :key="id">
                      <td class="text-truncate">
                        <div class="p-0 m-0 d-flex align-item-start">
                          <span class="d-inline-block text-right p-0 m-0 mr-1" style="width:15px;">
                            <strong>{{ id + 1 }}.</strong>
                          </span>
                          <span class="truncate-120">{{ item.STKDES }}</span>
                        </div>
                      </td>
                      <td class="text-right">{{ dayAgo(item.LASTEST_PODAT) }}</td>
                    </tr>
                    <tr v-if="stocks_is_po.length > poDisplayCount">
                      <td class="text-center" colspan="3" style="font-style: italic;">
                        ... และอื่นๆอีก {{ stocks_is_po.length - poDisplayCount }} รายการ
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </vue-html2pdf>

    <!-- ใบนำขาย (sales sheet ต่อลูกค้า) -->
    <vue-html2pdf v-bind="pdfConfigSalesSheet" ref="ReportSalesSheet"
      @progress="genPDFProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)">
      <section slot="pdf-content">
        <div v-if="customerModalResource" style="font-family:'Sarabun',sans-serif; color:#000;">
          <div v-for="(pageRows, pageIdx) in salesSheetPages" :key="pageIdx">
            <!-- page break ก่อนทุกหน้ายกเว้นหน้าแรก -->
            <div v-if="pageIdx > 0" class="html2pdf__page-break"></div>

            <div style="padding:16px 20px;">
              <!-- Header (ทุกหน้า เพื่อให้แต่ละหน้าอ่านได้ครบ) -->
              <div style="display:flex; justify-content:space-between; align-items:baseline; border-bottom:2px solid #000; padding-bottom:6px; margin-bottom:4px;">
                <span style="font-size:20px; font-weight:bold;">ใบนำขาย</span>
                <span style="font-size:13px;">{{ formatDateTH(today) }} · หน้า {{ pageIdx + 1 }}/{{ salesSheetPages.length }}</span>
              </div>
              <div style="display:flex; align-items:baseline; font-size:14px; margin-bottom:10px; white-space:nowrap; overflow:hidden;">
                <span style="font-weight:bold; flex-shrink:0;">{{ customerModalResource.CUSNAM }}</span>
                <span v-if="customerModalResource.CUS_GROUP_ID != null" style="margin-left:14px; flex-shrink:0;">กลุ่ม {{ customerModalResource.CUS_GROUP_ID }}</span>
                <span v-if="customerModalResource.CUS_SLMCOD" style="margin-left:14px; flex-shrink:0;">เซล {{ customerModalResource.CUS_SLMCOD }}</span>
                <span v-if="customerModalResource.CUS_TELNUM" style="margin-left:14px; flex-shrink:0;">โทร {{ customerModalResource.CUS_TELNUM }}</span>
                <span v-if="customerModalResource.CUS_ADDRESS" style="margin-left:14px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; color:#555;">{{ customerModalResource.CUS_ADDRESS }}</span>
              </div>

              <!-- Product table (เฉพาะแถวของหน้านี้) -->
              <table style="width:100%; border-collapse:collapse; font-size:13px;">
                <thead>
                  <tr style="background:#f0f0f0;">
                    <th style="border:1px solid #999; padding:5px 6px; width:32px; text-align:center;">#</th>
                    <th style="border:1px solid #999; padding:5px 8px; width:80px; text-align:left;">รหัส</th>
                    <th style="border:1px solid #999; padding:5px 8px; text-align:left;">รายการสินค้า</th>
                    <th style="border:1px solid #999; padding:5px 8px; width:80px; text-align:right;">ราคา</th>
                    <th style="border:1px solid #999; padding:5px 8px; width:75px; text-align:center;">แนะนำสั่ง</th>
                    <th style="border:1px solid #999; padding:5px 8px; width:170px; text-align:center;">จำนวนสั่ง</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(p, i) in pageRows" :key="i">
                    <td style="border:1px solid #999; padding:4px 6px; text-align:center;">{{ pageRowNumber(pageIdx, i) }}</td>
                    <td style="border:1px solid #999; padding:4px 8px;">{{ p.code }}</td>
                    <td style="border:1px solid #999; padding:4px 8px;">{{ p.name }}</td>
                    <td style="border:1px solid #999; padding:4px 8px; text-align:right;">{{ p.sell_price ? numberFormat(p.sell_price) : '' }}</td>
                    <td style="border:1px solid #999; padding:4px 8px; text-align:center; color:#888;">{{ p.suggest_qty ? p.suggest_qty + ' ' + p.unit : '' }}</td>
                    <td style="border:1px solid #999; padding:4px 8px;">&nbsp;</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </vue-html2pdf>

    <div v-if="genPDF" class="loading-overlay">
      <span class="text-danger loading-icon"><b-icon icon="file-earmark-text-fill"/></span>
      <div class="loading-text">กำลังสร้างรายงาน...</div>
    </div>

    <div v-if="!onLine" class="loading-overlay">
      <img src="../assets/offline.gif">
      <div class="loading-text">กำลังเชื่อมต่อ...</div>
    </div>

    <div v-if="mainLoading && onLine" class="loading-overlay">
      <img src="../assets/loading.gif">
      <div class="pl-1 pr-1 h4 font-weight-bold">กำลังโหลดข้อมูล</div>
      <div class="row m-0 p-0" style="border:1px solid #ddd;border-radius:0.25em;">
        <div class="bg-success text-dark" :class="['col-' + loadingClass]">
          {{ Math.floor(loadingClass * (100 / 12)) }}%
        </div>
      </div>
      <div class="text-center" style="font-size:0.8em;color:#aaa;">&nbsp;{{ fileName }}</div>
    </div>

    <!-- ==================== MAIN CONTENT ==================== -->
    <div v-if="!mainLoading && onLine && !genPDF">

      <!-- ===== UNIFIED STOCK DETAIL MODAL ===== -->
      <!-- Replaces modal_count_1 AND modal_count_2 (were ~500 lines each, nearly identical) -->
      <b-modal id="modal_stock_detail" ref="modal_stock_detail"
        modal-class="peter-modal" body-class="pt-0 pb-0"
        header-class="p-0 m-0 pl-1 pr-1" footer-class="p-0 m-0 pl-3 pr-3"
        no-close-on-backdrop centered no-fade>
        <template #modal-header>
          <div class="w-100 text-truncate" style="padding-left:1px;">
            <b-badge variant="info" class="pl-2 pr-2 mr-1 pt-1 pb-1">
              <span style="font-size:1.3em;">{{ currentStock.STKCOD }}</span>
            </b-badge>&nbsp;&nbsp;{{ currentStock.STKDES }}
          </div>
        </template>

        <template #default>
          <div class="row pl-0 pr-0">
            <!-- Product Info Card -->
            <div class="col-12 p-1">
              <div class="card" :class="currentStock.BACKGROUND_CLASS" style="border:1px solid black;">
                <div class="card-body pt-2 pb-3 px-3" style="position:relative">
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-8">
                          <h4 class="card-title text-truncate mb-0 font-weight-bold pt-1" style="color:#2B2301">
                            {{ currentStock.STKDES }}
                          </h4>
                          <h6 class="text-truncate" style="color:#888;font-size:0.9em;">
                            {{ currentStock.SUPNAM_SUPPLIER || "ไม่มีข้อมูล" }}
                          </h6>
                        </div>
                        <div class="col-4 pl-0 pr-3 d-flex flex-column justify-content-center">
                          <!-- Barcode Section -->
                          <template v-if="!addBarcodeTrigger && (currentStock.barcode != null || currentStock.unique_code != null)">
                            <div v-if="currentStock.barcode != null" @click="addBarcodeTrigger = true">
                              <VueBarcode :value="currentStock.barcode" format="CODE128" background="none"/>
                            </div>
                            <div v-else-if="currentStock.barcode == null && currentStock.unique_code != null" @click="addBarcodeTrigger = true">
                              <VueBarcode :value="currentStock.unique_code" format="CODE128" background="none" height="20"/>
                            </div>
                          </template>
                          <template v-if="addBarcodeTrigger || (currentStock.barcode == null && currentStock.unique_code == null)">
                            <div v-if="barcodeStateTrigger == null && uniqueCodeStateTrigger == null" class="p-0 text-right h3 m-0">
                              <b-icon class="text-dark mr-1" icon="file-spreadsheet"
                                @click.prevent="addBarcodeTrigger=true;addUniqueCode(modalResource)"/>
                              <b-icon class="text-dark mr-0" icon="upc-scan"
                                :class="{'mr-2': currentStock.barcode != null || currentStock.unique_code != null}"
                                @click="addBarcodeTrigger=true;addBarcode(modalResource)"/>
                              <b-icon v-show="currentStock.barcode != null || currentStock.unique_code != null"
                                class="text-dark" icon="x-circle-fill" @click="addBarcodeTrigger=false"/>
                            </div>
                            <div v-else-if="barcodeStateTrigger != null && uniqueCodeStateTrigger == null"
                              class="p-0 text-right h2 m-0"
                              @click.prevent="barcodeStateTrigger=null;addBarcodeTrigger=false;countScan=0"
                              style="position:relative">
                              <span class="p-0 m-0 pr-1 text-danger scan-label">
                                {{ (countScan == 0) ? 'สแกน ' : 'ครั้งที่ ' + countScan + '/3' }}
                              </span>
                              <b-icon icon="upc-scan" animation="throb" variant="danger" scale="1"/>
                            </div>
                            <div v-else-if="barcodeStateTrigger == null && uniqueCodeStateTrigger != null"
                              class="p-0 text-right h2 m-0" style="position:relative">
                              <input v-if="modalResource != null" v-model="stocks[modalResource].unique_code" type="number" pattern="[0-9]*" inputmode="numeric"
                                class="unique-code-input"
                                @focus="$event.target.select()"
                                @blur="save(modalResource);uniqueCodeStateTrigger=null;addBarcodeTrigger=false;" autofocus/>
                            </div>
                          </template>
                        </div>
                      </div>
                      <!-- Unit info row -->
                      <div class="row">
                        <div class="col-6 d-flex flex-row mb-1 p-0 pl-3">
                          <div class="unit-badge bg-danger text-light">1 {{ currentStock.PQUCOD }}</div>
                          <div class="unit-badge-x">X</div>
                          <div class="unit-badge" style="background:#FFBF00;">
                            {{ currentStock.CFACTOR }} {{ currentStock.QUCOD }}
                          </div>
                        </div>
                        <div class="col-6 mb-1 d-flex flex-column justify-content-center p-0 pl-3 pr-2">
                          <div class="pl-1 pr-0 w-100">
                            <div class="row p-0 text-center mr-2 percent-bar">
                              <div class="percent-bar-label">ระดับสต็อก {{ currentStock.PERCENT }}%</div>
                              <div class="pl-2 text-left" style="border-radius:0.25rem;"
                                :class="currentStock.PERCENT_CLASS">&nbsp;</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Big/Small unit display -->
                    <div class="col-12 mt-2">
                      <div class="row">
                        <div class="col-6 p-0 pr-1 pl-3 text-center">
                          <div class="bg-danger p-0 pt-1 d-flex flex-column" style="border-radius:0.25rem;">
                            <div>หน่วยใหญ่ ({{ currentStock.PQUCOD }})</div>
                            <div class="w-100 pb-3 text-center align-self-center font-weight-bold"
                              :class="stockCountTextClass">
                              <span class="big-unit-text">
                                {{ getValueFromAtom(currentStock.ATOM_LOCBAL + currentStock.express_DIFF, currentStock.CFACTOR).BIG }}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="col-6 p-0 pr-3 pl-1 text-center">
                          <div class="p-0 pt-1 d-flex flex-column" style="border-radius:0.25rem;background:#FFBF00;">
                            <div>หน่วยย่อย ({{ currentStock.QUCOD }})</div>
                            <div class="w-100 pb-3 text-center align-self-center font-weight-bold"
                              :class="stockCountTextClass">
                              <span class="big-unit-text">
                                {{ getValueFromAtom(currentStock.ATOM_LOCBAL + currentStock.express_DIFF, currentStock.CFACTOR).SMALL }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- TABS -->
            <div class="col-12 p-1">
              <b-tabs content-class="mt-0 border-tab" nav-class="h5"
                active-nav-item-class="font-weight-bold" fill no-fade>

                <!-- Tab: สต็อก -->
                <b-tab title="สต็อก" :active="productTab == 0" @click="productTab=0">
                  <div style="min-height:167px;">
                    <div class="row p-3">
                      <template v-if="!currentStock.stocksHistoryTrigger">
                        <div class="col-12 pl-0 pr-0 pt-4 pb-4 text-center d-flex flex-column item-align-center justify-content-center" style="min-height:140px;">
                          <div>กำลังโหลดข้อมูล...</div>
                        </div>
                      </template>
                      <template v-else-if="currentStock.history">
                        <div class="col-12">
                          <!-- Express Stock Info -->
                          <div class="row pl-1 pr-1 pb-1">
                            <div class="col-12 pt-1 pb-1 pl-2 pr-2 express-stock-box">
                              <div class="row">
                                <div class="col-3 pr-0 font-weight-bold text-nowrap">&nbsp;</div>
                                <div class="col-3 pl-0 pr-0 font-weight-bold text-right">
                                  {{ isModalType2 ? 'สต็อก' : 'เอ็กเพรส' }}
                                </div>
                                <div class="col-3 pl-0 pr-2 font-weight-bold text-right">
                                  {{ isModalType2 ? 'เอ็กเพรส' : 'สต็อก' }}
                                </div>
                                <div class="col-3 pl-0 pr-2 font-weight-bold text-right">ส่วนต่าง</div>
                              </div>
                              <div class="row">
                                <div class="col-3 pl-3 pr-0 text-nowrap font-weight-bold">สต็อกล่าสุด</div>
                                <div class="col-3 pl-0 pr-0 text-right">
                                  {{ isModalType2
                                    ? atomDisplay(currentStock.ATOM_LOCBAL + currentStock.express_DIFF, currentStock.CFACTOR)
                                    : atomDisplay(currentStock.ATOM_LOCBAL, currentStock.CFACTOR) }}
                                </div>
                                <div class="col-3 pl-0 pr-2 text-right">
                                  {{ isModalType2
                                    ? atomDisplay(currentStock.ATOM_LOCBAL, currentStock.CFACTOR)
                                    : atomDisplay(currentStock.ATOM_LOCBAL + currentStock.express_DIFF, currentStock.CFACTOR) }}
                                </div>
                                <div class="col-3 pl-0 pr-2 text-right">
                                  <b-badge :variant="expressDiffVariant">
                                    <div class="w-100 text-truncate" style="font-size:1.3em;">
                                      {{ getValueFromAtom(currentStock.express_DIFF, currentStock.CFACTOR).CONCAT }}
                                    </div>
                                  </b-badge>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- History -->
                          <div class="row pl-1 pr-1 pb-1" v-if="currentStock.history.length">
                            <div class="col-12 pt-1 pb-1 pl-2 pr-2 history-box"
                              :style="historyPageCount > 1 ? 'min-height:185px;' : ''">
                              <div class="row">
                                <div class="col-3 pr-0 font-weight-bold text-nowrap">ประวัติสต็อก</div>
                                <div class="col-3 pl-0 pr-0 font-weight-bold text-right">สต็อก</div>
                                <div class="col-3 pl-0 pr-2 font-weight-bold text-right">นับได้</div>
                                <div class="col-3 pl-0 pr-2 font-weight-bold text-right">ส่วนต่าง</div>
                              </div>
                              <template v-for="(sh, index) in filteredHistory">
                                <template v-if="isModalType2 || (index >= start_item() && index <= end_item())">
                                  <div class="row pl-1 pr-1" :key="index"
                                    :class="{'font-weight-bold': isFirstHistoryRow(sh, index)}">
                                    <div class="col-3 pl-2 pr-0 text-nowrap">
                                      <div class="history-num">{{ historyRunningNumber(index) }}</div>
                                      <template v-if="sh.is_adjust">ปรับสต็อก</template>
                                      <template v-else>{{ date(sh.counted_at) }}</template>
                                    </div>
                                    <template v-if="sh.is_adjust">
                                      <div class="col-3 pl-0 pr-0 text-right">
                                        {{ getValueFromAtom(sh.COUNT_ATOM, sh._CFACTOR).CONCAT }}
                                      </div>
                                      <div class="col-3 pl-0 pr-2 text-right">{{ sh.ADJUST_USER }}</div>
                                      <div class="col-3 pl-0 pr-2 text-right">{{ date(sh.counted_at) }}</div>
                                    </template>
                                    <template v-else>
                                      <div class="col-3 pl-0 pr-0 text-right">
                                        <template v-if="sh.peter_ATOM == null">
                                          <span style="color:#999">{{ atomDisplay(sh.COUNT_ATOM - sh.aj_diff, sh._CFACTOR) }}</span>
                                        </template>
                                        <template v-else>
                                          {{ atomDisplay(sh.peter_ATOM, sh._CFACTOR) }}
                                        </template>
                                      </div>
                                      <div class="col-3 pl-0 pr-2 text-right">
                                        {{ atomDisplay(sh.COUNT_ATOM, sh._CFACTOR) }}
                                      </div>
                                      <div class="col-3 pl-0 pr-2 text-right">
                                        {{ historyDiff(sh) }}
                                      </div>
                                    </template>
                                  </div>
                                </template>
                              </template>

                              <!-- Pagination (type1 only) -->
                              <div v-if="!isModalType2 && historyPageCount > 1"
                                style="position:absolute;bottom:4px;right:8px;">
                                <div class="row d-flex justify-content-end pl-2 pr-2">
                                  <template v-for="i in Math.min(historyPageCount, 5)">
                                    <span class="d-block text-center page-dot"
                                      :class="{'bg-warning font-weight-bold': currentPage == i, 'bg-warning-x text-not-count': currentPage != i}"
                                      :key="i" @click="currentPage=i">{{ i }}</span>
                                  </template>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Today's transactions -->
                          <div class="row pl-1 pr-1 pb-1"
                            v-if="is_has_today_transaction(modalResource) || is_today_count(modalResource)">
                            <div class="col-12 pt-1 pb-1 pl-2 pr-2 bg-success-x border-success" style="border:2px solid">
                              <div class="row">
                                <div class="col-3 pr-0 font-weight-bold text-nowrap">:: วันนี้ ::</div>
                                <div class="col-3 pl-0 pr-0 font-weight-bold text-right">สต็อก</div>
                                <div class="col-3 pl-0 pr-2 font-weight-bold text-right">นับได้</div>
                                <div class="col-3 pl-0 pr-2 font-weight-bold text-right">ส่วนต่าง</div>
                              </div>
                              <template v-for="(sh, index) in todayHistory">
                                <div class="row pl-1 pr-1" :key="index">
                                  <div class="col-3 pl-2 pr-0 text-nowrap">
                                    <div class="history-num">{{ index + 1 }}</div>
                                    <template v-if="sh.adjust_ref && sh.adjust_ref.length && sh.is_adjust">
                                      <strong><span class="text-danger">&nbsp;ปรับสต็อก</span></strong>
                                    </template>
                                    <template v-if="sh.ship_in_ref && sh.is_adjust">
                                      <strong><span class="text-danger">&nbsp;ของเข้า</span></strong>
                                    </template>
                                    <template v-if="!sh.is_adjust">
                                      <span :class="{'font-weight-bold': sh.counted_at == currentStock.counted_at}">
                                        {{ date(sh.counted_at) }}
                                      </span>
                                    </template>
                                  </div>
                                  <template v-if="sh.is_adjust">
                                    <div class="col-3 pl-0 pr-0 text-right text-danger font-weight-bold">
                                      {{ getValueFromAtom(sh.COUNT_ATOM, sh._CFACTOR).CONCAT }}
                                    </div>
                                    <div class="col-3 pl-0 pr-2 text-right text-danger font-weight-bold">
                                      {{ sh.ADJUST_USER }}
                                    </div>
                                    <div class="col-3 pl-0 pr-2 text-right text-danger font-weight-bold" style="font-size:0.8em;line-height:25px;">
                                      {{ sh.ADJUST_DOCNUM }}
                                    </div>
                                  </template>
                                  <template v-else>
                                    <div class="col-3 pl-0 pr-0 text-right font-weight-bold">
                                      <template v-if="sh.peter_ATOM == null">
                                        <span style="color:#999">{{ atomDisplay(sh.COUNT_ATOM - sh.aj_diff, sh._CFACTOR) }}</span>
                                      </template>
                                      <template v-else>{{ atomDisplay(sh.peter_ATOM, sh._CFACTOR) }}</template>
                                    </div>
                                    <div class="col-3 pl-0 pr-2 text-right font-weight-bold">
                                      {{ atomDisplay(sh.COUNT_ATOM, sh._CFACTOR) }}
                                    </div>
                                    <div class="col-3 pl-0 pr-2 text-right font-weight-bold">
                                      {{ historyDiff(sh) }}
                                    </div>
                                  </template>
                                </div>
                              </template>
                            </div>
                          </div>
                        </div>
                      </template>

                      <!-- Count Stock Display -->
                      <div class="col-12 mt-3 noselect">
                        <div class="d-flex align-items-center justify-content-center">
                          <div class="row w-100">
                            <div class="col-6 p-0 pr-1 pl-3 text-center"
                              :class="{ 'old_count_stock': !is_today_count(modalResource) || is_count_stat_change(modalResource) || currentStock.is_overrided }">
                              <div class="bg-light p-0 pt-1 d-flex flex-column" style="border-radius:0.25rem;">
                                <div>หน่วยใหญ่ ({{ currentStock.PQUCOD }})</div>
                                <div class="w-100 pb-3 text-center align-self-center font-weight-bold text-danger">
                                  <span class="big-unit-text">{{ lastCountBig }}</span>
                                </div>
                              </div>
                            </div>
                            <div class="col-6 p-0 pr-3 pl-1 text-center"
                              :class="{ 'old_count_stock': !is_today_count(modalResource) || is_count_stat_change(modalResource) || currentStock.is_overrided }">
                              <div class="p-0 pt-1 d-flex flex-column bg-light" style="border-radius:0.25rem;">
                                <div>หน่วยย่อย ({{ currentStock.QUCOD }})</div>
                                <div class="w-100 pb-3 text-center align-self-center font-weight-bold" style="color:#FFBF00">
                                  <span class="big-unit-text">{{ lastCountSmall }}</span>
                                </div>
                              </div>
                            </div>
                            <div class="col-12 mt-2 text-center">
                              <template v-if="currentStock.counted_at">
                                <span :class="{ 'text-success font-weight-bold': isToday(currentStock.counted_at) && currentStock.STAT == currentStock.COUNT_STAT }">
                                  นับสินค้าล่าสุด {{ dayAgo(currentStock.counted_at) }} {{ date(currentStock.counted_at) }}
                                </span>
                                <template v-if="isToday(currentStock.counted_at)">
                                  <span v-if="!delCountTrigger" class="action-badge bg-danger" @click="delCountTrigger=true">ลบ</span>
                                  <span v-if="delCountTrigger" class="action-badge bg-secondary" @click="delCountTrigger=false">ยกเลิก</span>
                                </template>
                                <span v-show="delCountTrigger" class="action-badge bg-warning"
                                  @click.prevent="del_count_stock(modalResource);delCountTrigger=false;">ยืนยัน</span>
                              </template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>

                <!-- Tab: ข้อมูล -->
                <b-tab title="ข้อมูล" :active="productTab == 1" @click="productTab=1">
                  <div class="p-1" style="min-height:167px;">
                    <div class="row p-2">
                      <div class="col-4">กลุ่มสินค้า</div>
                      <div class="col-4 pl-0 text-right">
                        <template v-if="currentStock.SUPNAM_SUPPLIER != 'ไม่มีข้อมูลจากประวัติ'">
                          <b-badge variant="secondary" class="w-100"
                            @click="openGroupModal('modal_group_1','SUPNAM_SUPPLIER',currentStock.SUPNAM_SUPPLIER)">
                            <div class="w-100 text-truncate" style="font-size:1.2em;">
                              {{ currentStock.SUPNAM_SUPPLIER }}
                            </div>
                          </b-badge>
                        </template>
                        <template v-else><span style="color:#ccc;">ไม่มีข้อมูล</span></template>
                      </div>
                      <div class="col-4 pl-0 text-right">
                        <template v-if="currentStock.count_code">
                          <b-badge variant="warning" class="w-100"
                            @click="openGroupModal('modal_group_1','count_code',currentStock.count_code)">
                            <span style="font-size:1.3em;">กลุ่ม#{{ currentStock.count_code }}</span>
                          </b-badge>
                        </template>
                        <template v-else><span style="color:#ccc;">ยังไม่มีกลุ่ม</span></template>
                      </div>
                      
                      <div class="col-4 font-weight-bold">มูลค่าสินค้า</div>
                      <div class="col-4 pl-0 text-right">{{ numberFormat(currentStock.LOCVAL) }}</div>
                      <div class="col-4 pl-0 text-right text-success font-weight-bold">
                        MG. {{ numberFormat(currentStock.SELLPR1 - processDiscount(currentStock._UNITPR, currentStock.LPDISC)) }}
                      </div>

                      <!-- Makro Price -->
                      <div v-if="currentStock.barcode" class="col-12 p-0 mt-1 mb-1">
                        <div class="makro-price-box">
                          <div class="d-flex align-items-center justify-content-between mb-1">
                            <div class="d-flex align-items-center">
                              <span class="makro-logo font-weight-bold">Makro</span>
                              <span class="ml-1" style="font-size:0.75em;color:#888;">เปรียบเทียบราคา</span>
                            </div>
                            <span v-if="makroLoading" style="font-size:0.75em;color:#888;">กำลังค้นหา...</span>
                            <span v-else-if="makroError" style="font-size:0.75em;color:#ccc;">เชื่อมต่อไม่ได้</span>
                            <span v-else-if="makroSearched && makroProducts.length === 0" style="font-size:0.75em;color:#ccc;">ไม่พบสินค้า</span>
                          </div>
                          <div v-if="makroProducts.length > 0">
                            <div v-for="(mp, mi) in makroProducts.slice(0, 3)" :key="mi"
                              class="makro-item d-flex align-items-center"
                              :class="{'mt-1': mi > 0}">
                              <img v-if="mp.image" :src="mp.image" class="makro-thumb" loading="lazy"/>
                              <div v-else class="makro-thumb-empty"></div>
                              <div class="flex-fill pl-2 text-truncate" style="min-width:0;">
                                <div class="text-truncate" style="font-size:0.85em;font-weight:600;line-height:1.2;">{{ mp.name }}</div>
                                <div class="d-flex align-items-baseline mt-0">
                                  <span class="makro-price font-weight-bold">฿{{ mp.price.toLocaleString() }}</span>
                                  <span v-if="mp.unitFactor > 1" style="font-size:0.65em;color:#888;margin-left:3px;">/แพ็ค{{ mp.unitFactor }}ชิ้น</span>
                                  <span v-if="mp.discount" class="makro-discount ml-1">{{ mp.discount }}</span>
                                  <span v-if="mp.originalPrice > mp.price" class="makro-original ml-1">฿{{ mp.originalPrice.toLocaleString() }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-4 pr-0">ราคาล่าสุด</div>
                      <div class="col-4 pl-0 text-right text-danger font-weight-bold">
                        ซื้อ {{ numberFormat(currentStock.LPURPR ? currentStock._UNITPR : 0, currentStock.LPDISC) }}
                      </div>
                      <div class="col-4 pl-0 text-right text-primary font-weight-bold">
                        ขาย {{ numberFormat(currentStock.SELLPR1) }}
                      </div>
                      <div class="col-4">ปริมาณขาย</div>
                      <div class="col-4 font-weight-bold text-right">{{ currentStock.AVG_SELL }} {{ currentStock.PQUCOD }}</div>
                      <div class="col-4 text-right font-weight-bold">ต่อ{{ freqLabel(currentStock.order_frequency) }}</div>
                      <div class="col-4">ขายล่าสุด</div>
                      <div class="col-4 text-right">
                        <template v-if="currentStock.TRNQTY_OUT">
                          {{ getValueFromAtom(currentStock.TRNQTY_OUT, currentStock.CFACTOR).CONCAT_NO_PLUS }} {{ currentStock.PQUCOD }}
                        </template>
                        <template v-else><span style="color:#ccc;">ไม่มีข้อมูล</span></template>
                      </div>
                      <div class="col-4 text-right">
                        <span :style="dayAgo(currentStock.LSK) == 'ไม่มีข้อมูล' ? 'color:#ccc' : ''">
                          {{ dayAgo(currentStock.LSK) }}
                        </span>
                      </div>
                      <div class="col-4 font-weight-bold pr-0">ของเข้าล่าสุด</div>
                      <div class="col-4 text-right">
                        <template v-if="currentStock.LAST_BUY_IN_ATOM">
                          <b-badge>
                            <span style="font-size:1.2em;">
                              {{ getValueFromAtom(currentStock.LAST_BUY_IN_ATOM, currentStock.CFACTOR).CONCAT_NO_PLUS }}
                              {{ currentStock.PQUCOD }}
                            </span>
                          </b-badge>
                        </template>
                        <template v-else><span style="color:#ccc;">ไม่มีข้อมูล</span></template>
                      </div>
                      <div class="col-4 text-right">
                        <span :style="dayAgo(currentStock.LLK) == 'ไม่มีข้อมูล' ? 'color:#ccc' : ''">
                          {{ dayAgo(currentStock.LLK) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </b-tab>

                <!-- Tab: ลูกค้า -->
                <b-tab title="ลูกค้า" :active="productTab == 3" @click="productTab=3">
                  <div class="p-3" style="min-height:167px;">
                    <div v-if="currentStock.AVG_SELL <= 0"
                      class="d-flex flex-column align-item-center justify-content-center" style="min-height:167px;">
                      <div class="text-center h-100">ไม่มีข้อมูล</div>
                    </div>
                    <template v-if="currentStock.AVG_SELL > 0">
                      <div class="w-100 text-center mb-1">
                        <h5 class="text-center font-weight-bold mb-2 pb-0">
                          คิดจากยอดขาย {{ currentStock.AVG_SELL }} {{ currentStock.PQUCOD }}
                          <u>{{ currentStock.order_frequency == 7 ? 'ต่อสัปดาห์' : 'ต่อเดือน' }}</u>
                        </h5>
                        <div class="row">
                          <div v-for="(ct, cti) in currentStock.CUSTYPES" class="col" style="line-height:20px;" :key="cti">
                            <div class="font-weight-bold"
                              :class="{'text-danger':ct.SORT==1,'text-primary':ct.SORT==2,'text-warning':ct.SORT==3,'text-secondary':ct.SORT==4}">
                              {{ ct.TYPES }}
                            </div>
                            <div style="font-size:1.1em;">{{ Math.floor((ct.ATOM / currentStock.TOTAL_ATOM) * 100) }}%</div>
                          </div>
                        </div>
                        <!-- legend ของ "วงกลมเลขลำดับ" หน้าชื่อลูกค้า (ตามความถี่ซื้อ: แดง ≥5 ครั้ง, เขียว 3-4, เหลือง ≤2)
                             — คนละระบบสีกับ "สีชื่อลูกค้า" ที่บอกช่องทางขาย (เซล/หน้าร้าน/เงินสด) -->
                        <span class="cus-legend-text text-muted mr-1">วงกลมหน้าชื่อ:</span>
                        <div class="cus-legend bg-danger"/><span class="cus-legend-text">ลูกค้าประจำ</span>&nbsp;
                        <div class="cus-legend bg-success"/><span class="cus-legend-text">ลูกค้าทั่วไป</span>&nbsp;
                        <div class="cus-legend bg-warning"/><span class="cus-legend-text">ลูกค้าขาจร</span>
                      </div>
                      <div v-for="(cus, i) in currentStock.CUSTOMERS" :key="i"
                        class="d-flex justify-content-between w-100 customer-product-row rounded"
                        :style="{ cursor: isClickableCustomer(cus) ? 'pointer' : 'default' }"
                        @click="openCustomerByCuscod(cus.CUSCOD)">
                        <template v-if="i < 11">
                          <div class="flex-fill text-truncate" style="width:80%;">
                            <div v-if="i + 1 < 11" class="cus-num"
                              :class="{'bg-danger':cus.FREQ.length>=5,'bg-warning':cus.FREQ.length<=2}">
                              {{ i + 1 }}
                            </div>
                            <span class="pl-1"
                              :class="{'text-danger':cus.TYPE==1,'text-primary':cus.TYPE==2,'text-warning':cus.TYPE==3,'text-dark':cus.TYPE==4||i==10}">
                              {{ cus.CUSNAM }}
                            </span>
                          </div>
                          <div class="d-flex" style="width:130px;">
                            <div class="text-right" style="width:60px;">
                              {{ cusAtomBig(cus, currentStock) }} {{ currentStock.PQUCOD }}
                            </div>
                            <div class="text-right" style="width:50px;">
                              {{ cusAtomPercent(cus, currentStock) }}%
                            </div>
                          </div>
                        </template>
                      </div>
                    </template>
                  </div>
                </b-tab>

                <!-- Tab: ตั้งค่า -->
                <b-tab title="ตั้งค่า" :active="productTab == 2" @click="productTab=2; loadProductImage()">
                  <div class="row pl-3 pr-3" style="min-height:167px;">
                    <div class="col-6 pl-3 pt-3 pr-1 text-center">
                      <b-form-radio-group v-model="currentStock.order_frequency"
                        v-on:change="save(modalResource)"
                        :options="order_frequency_options" class="peter-radio"
                        value-field="item" text-field="name" disabled-field="notEnabled"
                        button-variant="light" buttons stacked/>

                      <!-- Weight (only for modal_count_1) -->
                      <div v-if="!isModalType2" class="text-left mt-2 w-100 p-2 weight-box"
                        :class="{'bg-warning': currentStock.weight, 'bg-white': !currentStock.weight}"
                        @click="openModalWeight(modalResource)">
                        <div class="row pl-3 pr-2">
                          <div class="col-3 text-truncate p-0 text-center">
                            <div class="weight-icon-wrap">
                              <b-icon icon="cpu-fill" class="h2"
                                :style="currentStock.weight ? '' : 'color:#DDDDDD;'"/>
                            </div>
                          </div>
                          <div class="col-9 p-0 pl-2">
                            <label class="text-dark font-weight-bold" style="margin-bottom:0;">พิกัดน้ำหนัก</label>
                            <div class="text-dark">
                              <template v-if="currentStock.weight">
                                {{ numberFormat(currentStock.weight) }} <span class="font-weight-bold">KG</span>
                              </template>
                              <template v-else><span class="text-muted">ไม่มีข้อมูล</span></template>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- รูปสินค้า (จัตุรัส 1:1 — ครอปกึ่งกลางอัตโนมัติตอนอัพโหลด) -->
                      <div class="text-left mt-2 w-100 p-2 product-image-box"
                        :class="{'bg-warning': productImage}">
                        <label class="text-dark font-weight-bold" style="margin-bottom:4px;">รูปสินค้า</label>

                        <!-- State: มีรูปแล้ว → thumbnail จัตุรัส (แตะ = ดูใหญ่, ⋯ = เปลี่ยน/ลบ) -->
                        <div v-if="productImage" class="product-image-square" @click="openProductImageModal">
                          <img :src="productImage" alt="รูปสินค้า">
                          <div class="image-menu-trigger" @click.stop="productImageMenuOpen = !productImageMenuOpen">⋯</div>
                          <div v-if="productImageMenuOpen" class="image-menu-popup" @click.stop>
                            <div class="image-menu-item" @click="productImageMenuOpen = false; triggerProductCameraCapture()">📷 ถ่ายรูปใหม่</div>
                            <div class="image-menu-item" @click="productImageMenuOpen = false; triggerProductImageUpload()">📁 เลือกรูปใหม่</div>
                            <div class="image-menu-item" @click="productImageMenuOpen = false; openAiFindImage()">🔎 AI หารูป</div>
                            <div class="image-menu-item text-danger" @click="productImageMenuOpen = false; deleteProductImage()">🗑 ลบรูป</div>
                          </div>
                          <div v-if="productImageUploading" class="image-loading-overlay">
                            <div class="spinner-border text-primary" role="status"></div>
                          </div>
                        </div>

                        <!-- State: ยังไม่มีรูป → ปุ่มถ่ายรูป / เลือกรูป + ลิงก์ AI หารูป -->
                        <div v-else class="position-relative">
                          <div class="d-flex" style="gap:8px;">
                            <div class="product-image-btn" @click="triggerProductCameraCapture">📷<div class="small font-weight-bold">ถ่ายรูป</div></div>
                            <div class="product-image-btn" @click="triggerProductImageUpload">📁<div class="small font-weight-bold">เลือกรูป</div></div>
                          </div>
                          <div class="text-center mt-2">
                            <span class="ai-find-link" @click="openAiFindImage">🔎 AI หารูปจากเน็ต</span>
                          </div>
                          <div v-if="productImageUploading || productImageLoading" class="image-loading-overlay">
                            <div class="spinner-border text-primary" role="status"></div>
                          </div>
                        </div>

                        <!-- Hidden file inputs (camera เปิดกล้องตรงบนมือถือ, desktop fallback เป็น file picker) -->
                        <input ref="productImageFileInput" type="file" accept="image/*" style="display:none" @change="handleProductImageFile">
                        <input ref="productImageCameraInput" type="file" accept="image/*" capture="environment" style="display:none" @change="handleProductImageFile">
                      </div>
                    </div>

                    <div class="col-6 p-2 pt-3 pb-2 text-center">
                      <label v-for="opt in configCheckboxes" :key="opt.id"
                        :for="opt.id" class="d-flex align-items-center text-fade p-1 mr-2 m-0"
                        :class="{'text-dark font-weight-bold': currentStock[opt.field]}">
                        <input :id="opt.id" v-model="currentStock[opt.field]"
                          :true-value="1" :false-value="0" v-on:change="save(modalResource)"
                          type="checkbox" class="m-1 largerCheckbox mr-2">
                        <b-icon :icon="opt.icon" class="h3" style="cursor:pointer;margin:0;padding:0;margin-right:8px;"/>
                        {{ opt.label }}
                      </label>
                    </div>

                    <!-- Count Schedule -->
                    <div class="col-12 p-2" style="background:#f9f9f9">
                      <h6 class="pl-1 m-0 pl-2 font-weight-bold">ตารางนับสินค้า</h6>
                      <div class="d-flex" style="height:40px;">
                        <div v-for="(dayLabel, dayNum) in weekDays" :key="dayNum"
                          class="m-1 text-center flex-fill d-flex flex-column align-item-center justify-content-center day-picker"
                          :class="{'bg-warning font-weight-bold border-warning': currentStock.count_day == dayNum}"
                          @click="currentStock.count_day = (currentStock.count_day == dayNum) ? null : Number(dayNum); save(modalResource)">
                          {{ dayLabel }}
                        </div>
                        <div class="m-1 text-center flex-fill d-flex flex-column align-item-center justify-content-center" style="width:50px;position:relative;">
                          <div class="w-100 text-center font-weight-bold group-select-badge"
                            @click="createSameGroup(modalResource);openModal('modal_select_group_1',modalResource)">
                            <b-badge variant="warning">เลือกกลุ่มสินค้า</b-badge>
                          </div>
                          <input class="text-center font-weight-bold pt-2" type="number" pattern="[0-9]*" inputmode="numeric"
                            style="border:none;font-size:1.1em;"
                            :placeholder="(!currentStock.count_code) ? 'ไม่มี' : ''"
                            v-model="currentStock.count_code"
                            @click="$event.target.select()" @blur="save(modalResource)"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </template>

        <!-- Modal Footer -->
        <template #modal-footer>
          <div class="row w-100">
            <div class="col-6 p-2">
              <b-button block @click.prevent="resetBarcodeState();openModalCal(modalResource)"
                :variant="!is_so_ready(modalResource) ? 'danger' : 'success'">
                <div style="font-size:1.4em;font-weight:bold;" :style="currentStock.STAT ? 'line-height:5px;' : ''">
                  <b-icon icon="box-seam" style="position:relative;margin:0;padding:0;top:-4px !important;padding-right:5px;"/>
                  นับสต็อก
                  <div class="text-light text-center w-100 font-weight-normal" style="font-size:0.5em;">
                    {{ currentStock.STAT ? (!is_so_ready(modalResource) ? "จัดสินค้าวันนี้ยังไม่เสร็จ" : "จัดสินค้าเสร็จแล้ว") : "" }}
                  </div>
                </div>
              </b-button>
            </div>
            <div class="col-6 p-2">
              <b-button v-if="!count_stock_tricker" block variant="warning"
                @click="resetBarcodeState();orderTrigger=false;closeModal('modal_stock_detail')">
                <span class="font-weight-bold" style="font-size:1.4em;">ปิด</span>
              </b-button>
            </div>
          </div>
        </template>
      </b-modal>

      <!-- ===== Modal Image ===== -->
      <b-modal id="modal_image" modal-class="peter-modal" body-class="p-0 pt-0 pb-0 mt-0"
        footer-class="p-0 m-0 pl-3 pr-3" no-fade no-close-on-backdrop centered>
        <template #modal-header>&nbsp;</template>
        <template #default>
          <div class="col-12 pl-1 pr-1 pt-0 pb-0 text-center">
            <div ref="imgContainer"></div>
          </div>
        </template>
        <template #modal-footer>
          <div class="row w-100 mt-1">
            <div class="col-12 p-2">
              <b-button block variant="warning" @click.prevent="closeModal('modal_image');">
                <span style="font-size:1.4em;font-weight:bold;">ปิด</span>
              </b-button>
            </div>
          </div>
        </template>
      </b-modal>

      <!-- ===== Customer Detail Modal (empty for now) ===== -->
      <b-modal id="modal_customer" ref="modal_customer" modal-class="peter-modal"
        body-class="p-2" footer-class="p-0 m-0 pl-2 pr-2" no-fade no-close-on-backdrop centered>
        <template #modal-header>&nbsp;</template>
        <template #default>
          <!-- Same card design as the list, bound to selected customer -->
          <div v-if="customerModalResource">
            <div class="rounded p-3"
                 :style="{ border: '1px solid ' + customerCardBorderColor(customerModalResource), backgroundColor: customerCardColor(customerModalResource) }">
              <div class="d-flex justify-content-between align-items-center">
                <div class="font-weight-bold text-truncate flex-grow-1 mr-2" :title="customerModalResource.CUSNAM" style="font-size:1.2em;">{{ customerModalResource.CUSNAM }}</div>
                <div class="d-flex align-items-center text-nowrap" style="gap:4px;">
                  <small v-if="customerModalResource.CUS_GROUP_ID != null" class="px-2 rounded text-dark font-weight-bold" style="background-color:#FFD760; font-size:0.9em;">กลุ่ม {{ customerModalResource.CUS_GROUP_ID }}</small>
                  <small v-if="customerModalResource.CUS_SLMCOD" class="px-1 rounded text-white" style="background-color:#6c757d; font-size:0.9em;">เซล {{ customerModalResource.CUS_SLMCOD }}</small>
                </div>
              </div>
              <div style="margin-top:-6px;"><small class="text-muted">{{ customerModalResource.CUSCOD }} {{ extractDistrictProvince(customerModalResource.CUS_ADDRESS).province }} {{ extractDistrictProvince(customerModalResource.CUS_ADDRESS).district }}</small></div>
              <div class="small mt-1" v-if="customerModalResource.CUS_TELNUM">📞 {{ customerModalResource.CUS_TELNUM }}</div>
              <div class="d-flex justify-content-between mt-1">
                <span class="text-muted">ขายเฉลี่ยต่อเดือน</span>
                <span class="font-weight-bold">{{ numberFormat(customerModalResource.AVG_SELL_PER_MONTH || 0) }}</span>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <span class="text-muted">ยอดขายเดือนนี้</span>
                <div class="d-flex align-items-center" style="gap:8px;">
                  <div v-if="customerModalResource.AVG_SELL_PER_MONTH > 0"
                       style="width:80px; height:18px; background:rgba(0,0,0,0.18); border-radius:4px; overflow:hidden; position:relative;">
                    <!-- Fill -->
                    <div :style="{ width: Math.min(salesProgressPercent(customerModalResource), 100) + '%', backgroundColor: salesProgressColor(customerModalResource), height: '100%', transition: 'width 0.3s ease' }"></div>
                    <!-- % text overlaid in center (always visible regardless of fill width) -->
                    <div class="position-absolute d-flex align-items-center justify-content-center"
                         style="top:0; left:0; width:100%; height:100%; font-size:0.72em; font-weight:bold; color:#fff; pointer-events:none; line-height:1;">
                      {{ salesProgressPercent(customerModalResource) }}%
                    </div>
                  </div>
                  <span class="font-weight-bold">{{ numberFormat(customerModalResource.SALES_THIS_MONTH || 0) }}</span>
                </div>
              </div>
              <div class="d-flex justify-content-between">
                <span class="text-muted">หนี้คงค้าง</span>
                <span :class="(customerModalResource.CUS_BALANCE > 0) ? 'text-danger' : 'text-success'">
                  {{ numberFormat(customerModalResource.CUS_BALANCE || 0) }}
                </span>
              </div>
              <div v-if="customerModalResource.MAX_OVERDUE_DAYS > 0" class="d-flex justify-content-between">
                <span class="text-muted">บิลค้างมากสุด</span>
                <span class="font-weight-bold text-danger">{{ customerModalResource.MAX_OVERDUE_DAYS }} วัน</span>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <span class="text-muted">เซลเข้าเยี่ยมเดือนนี้</span>
                <span v-html="visitDotsHtml(customerModalResource.VISITS_THIS_MONTH || 0)"></span>
              </div>
            
            </div>

            <!-- ===== 4 blank tabs (initial template - fill in as needed) ===== -->
            <b-tabs content-class="mt-0 border-tab" nav-class="h5"
              active-nav-item-class="font-weight-bold" fill no-fade class="mt-3">

              <!-- Tab 1 -->
              <b-tab title="ประวัติ" :active="customerTab == 0" @click="customerTab=0; loadCustomerProducts()">
                <div style="min-height:167px;" class="p-3">
                  <!-- Visit summary header + print button -->
                  <div class="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom px-2">
                    <div class="d-flex align-items-center" style="gap:6px;">
                      <span class="small text-muted">เซลเข้าเยี่ยมใน 6 เดือน</span>
                      <span class="font-weight-bold">{{ customerModalResource.TOTAL_VISITS || 0 }} ครั้ง</span>
                    </div>
                    <b-button size="sm" variant="outline-success" class="text-nowrap"
                              @click="printSalesSheet">
                      🖨 พิมพ์ใบนำขาย
                    </b-button>
                  </div>

                  <!-- Loading (PRODUCTS lazy-load แยกจาก list ลูกค้า) -->
                  <div v-if="customerProductsLoading" class="text-center text-muted py-4">
                    กำลังโหลด...
                  </div>

                  <!-- Empty -->
                  <div v-else-if="!customerProducts.length" class="text-center text-muted py-4">
                    ไม่มีประวัติการซื้อใน 6 เดือน
                  </div>

                  <ul v-else class="list-unstyled mb-0">
                    <li v-for="(p, i) in displayedProducts" :key="i"
                        @click="openModalFind('modal_count_2', p.id)"
                        class="py-1 px-2 rounded customer-product-row"
                        style="cursor:pointer;">
                      <div class="d-flex justify-content-between">
                        <span :style="{ color: productStatusColor(p.status) }">
                          <strong>{{ i + 1 }}.</strong> {{ p.name }}
                        </span>
                        <span>{{ p.avg_qty }} {{ p.unit }}</span>
                      </div>
                    </li>
                  </ul>

                  <!-- ดูเพิ่มเติม -->
                  <div v-if="!showAllCustomerProducts && customerProducts.length > 20"
                       @click="showAllCustomerProducts = true"
                       class="text-center mt-2 py-2 small text-primary border-top"
                       style="cursor:pointer; user-select:none;">
                    ดูเพิ่มเติม ({{ customerProducts.length - 20 }} รายการ)
                  </div>
                </div>
              </b-tab>

              <!-- Tab 2 -->
              <b-tab title="แนะนำ" :active="customerTab == 1" @click="customerTab=1; loadSuggestions()">
                <div style="min-height:167px;" class="p-3">
                  <!-- Loading -->
                  <div v-if="suggestionsLoading" class="text-center text-muted py-4">
                    กำลังโหลด...
                  </div>

                  <!-- Empty -->
                  <div v-else-if="!suggestions.length" class="text-center text-muted py-4">
                    ยังไม่มีคำแนะนำ
                  </div>

                  <!-- Cross-sell list: products other shops buy but this one doesn't -->
                  <ul v-else class="list-unstyled mb-0">
                    <li v-for="(s, i) in displayedSuggestions" :key="i"
                        @click="openModalFind('modal_count_2', s.id)"
                        class="py-1 px-2 rounded customer-product-row"
                        style="cursor:pointer;">
                      <div class="d-flex justify-content-between align-items-center">
                        <span class="flex-grow-1 mr-2">
                          <strong>{{ i + 1 }}.</strong> {{ s.name }}
                        </span>
                        <small class="px-2 rounded text-white text-nowrap"
                               style="background-color:#6c8eb6; font-size:0.75em;">
                          {{ s.buyer_count }} ร้าน
                        </small>
                      </div>
                    </li>
                  </ul>

                  <!-- ดูเพิ่มเติม -->
                  <div v-if="!showAllSuggestions && suggestions.length > 10"
                       @click="showAllSuggestions = true"
                       class="text-center mt-2 py-2 small text-primary border-top"
                       style="cursor:pointer; user-select:none;">
                    ดูเพิ่มเติม ({{ suggestions.length - 10 }} รายการ)
                  </div>
                </div>
              </b-tab>

              <!-- Tab 3 -->
              <b-tab title="หนี้" :active="customerTab == 2" @click="customerTab=2; loadDebts()">
                <div style="min-height:167px;" class="p-3">
                  <!-- Skeleton loading - mirrors summary box + 3 invoice rows -->
                  <div v-if="debtsLoading">
                    <!-- Skeleton: summary box -->
                    <div class="mb-3 p-2 rounded" style="background-color: #f8f9fa; border: 1px solid #dee2e6;">
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="skeleton-box" style="width:100px; height:14px;"></div>
                        <div class="skeleton-box" style="width:90px; height:18px;"></div>
                      </div>
                      <div class="d-flex justify-content-between mt-2">
                        <div class="skeleton-box" style="width:80px; height:11px;"></div>
                        <div class="skeleton-box" style="width:60px; height:11px;"></div>
                      </div>
                    </div>

                    <!-- Skeleton: 3 invoice rows -->
                    <div v-for="n in 3" :key="n" class="py-2 px-2 mb-1 rounded">
                      <div class="d-flex justify-content-between align-items-center mb-1">
                        <div class="skeleton-box" :style="{ width: (90 + n * 10) + 'px', height: '16px' }"></div>
                        <div class="skeleton-box" style="width:80px; height:16px;"></div>
                      </div>
                      <div class="skeleton-box mb-1" style="width:200px; height:11px;"></div>
                      <div class="skeleton-box" :style="{ width: (100 + n * 15) + 'px', height: '11px' }"></div>
                    </div>
                  </div>

                  <!-- Empty -->
                  <div v-else-if="!debts || !debts.invoices.length" class="text-center text-muted py-4">
                    ไม่มีรายการบิล
                  </div>

                  <template v-else>
                    <!-- Summary -->
                    <div class="mb-3 p-2 rounded" style="background-color: #f8f9fa; border: 1px solid #dee2e6;">
                      <div class="d-flex justify-content-between align-items-center">
                        <span class="text-muted small">ยอดค้างทั้งหมด</span>
                        <span class="font-weight-bold" :class="debts.summary.total_balance > 0 ? 'text-danger' : 'text-success'">
                          {{ numberFormat(debts.summary.total_balance) }}
                        </span>
                      </div>
                      <div class="d-flex justify-content-between small mt-1">
                        <span class="text-muted">เครดิต {{ debts.summary.paytrm_days }} วัน</span>
                        <span class="text-muted">ค้าง {{ debts.summary.unpaid_count }} ใบ</span>
                      </div>
                    </div>

                    <!-- Invoice list -->
                    <ul class="list-unstyled mb-0">
                      <li v-for="(inv, i) in displayedDebts" :key="i"
                          @click="openInvoiceModal(inv.docnum)"
                          class="py-2 px-2 mb-1 rounded customer-product-row"
                          style="cursor:pointer;">
                        <div class="d-flex justify-content-between align-items-start">
                          <span :style="{ color: debtStatusColor(inv.status) }">
                            <strong>{{ inv.docnum }}</strong>
                          </span>
                          <span class="font-weight-bold" :style="{ color: debtStatusColor(inv.status) }">
                            {{ numberFormat(isPartialPayment(inv) ? inv.outstanding : inv.amount) }}
                          </span>
                        </div>
                        <div class="small text-muted">
                          วันที่ออกบิล {{ formatDateTH(inv.docdat) }} ({{ relativeDays(inv.docdat) }})
                        </div>
                        <!-- โชว์รายละเอียดการจ่ายเฉพาะกรณีจ่ายบางส่วน -->
                        <div v-if="isPartialPayment(inv)" class="small text-muted">
                          <span class="text-danger fw-bold font-weight-bold">ยอดบิล {{ numberFormat(inv.amount) }}</span> · จ่ายแล้ว {{ numberFormat(inv.amount - inv.outstanding) }}
                        </div>
                        <div class="small" :style="{ color: debtStatusColor(inv.status) }">
                          <template v-if="inv.status === 'overdue'">เกินกำหนด {{ inv.days_from_due }} วัน</template>
                          <template v-else-if="inv.status === 'unpaid'">ครบกำหนดใน {{ inv.days_from_due }} วัน</template>
                          <template v-else>ชำระแล้ว</template>
                        </div>
                      </li>
                    </ul>

                    <!-- ดูเพิ่มเติม -->
                    <div v-if="!showAllDebts && debts.invoices.length > 5"
                         @click="showAllDebts = true"
                         class="text-center mt-2 py-2 small text-primary border-top"
                         style="cursor:pointer; user-select:none;">
                      ดูเพิ่มเติม ({{ debts.invoices.length - 5 }} รายการ)
                    </div>
                  </template>
                </div>
              </b-tab>

              <!-- Tab 4 -->
              <b-tab title="ข้อมูล" :active="customerTab == 3" @click="customerTab=3; loadCustomerInfo()">
                <div style="min-height:167px;" class="p-3">
                   <div class="row px-2">
                    <div class="col-5 p-0 d-flex align-items-center justify-content-center">
                      <div class="customer-image-container w-100">
                        <img :src="(customerInfo && customerInfo.image) ? customerInfo.image : 'img/shop.png'"
                             class="customer-image"
                             :style="{ cursor: (customerInfo && customerInfo.image) ? 'pointer' : 'default' }"
                             @click="openCustomerImageModal" />

                        <!-- State 1: no image yet → bottom strip with 2 buttons -->
                        <div v-if="!customerInfo || !customerInfo.image" class="image-buttons-strip">
                          <div class="image-action-btn" @click="triggerImageUpload" title="อัพโหลดรูป">📁</div>
                          <div class="image-action-btn" @click="triggerCameraCapture" title="ถ่ายรูป">📷</div>
                        </div>

                        <!-- State 2: has image → floating ⋯ menu -->
                        <template v-else>
                          <div class="image-menu-trigger" @click.stop="imageMenuOpen = !imageMenuOpen">⋯</div>
                          <div v-if="imageMenuOpen" class="image-menu-popup" @click.stop>
                            <div class="image-menu-item" @click="imageMenuOpen = false; triggerCameraCapture()">📷 ถ่ายรูปใหม่</div>
                            <div class="image-menu-item" @click="imageMenuOpen = false; triggerImageUpload()">📁 เลือกรูปใหม่</div>
                            <div class="image-menu-item text-danger" @click="imageMenuOpen = false; deleteCustomerImage()">🗑 ลบรูป</div>
                          </div>
                        </template>

                        <!-- Uploading overlay (covers everything while saving) -->
                        <div v-if="imageUploading" class="image-loading-overlay">
                          <div class="spinner-border text-primary" role="status"></div>
                        </div>
                      </div>

                      <!-- Hidden file inputs (triggered via refs) -->
                      <input ref="imageFileInput" type="file" accept="image/*" style="display:none" @change="handleImageFile">
                      <input ref="imageCameraInput" type="file" accept="image/*" capture="environment" style="display:none" @change="handleImageFile">
                    </div>
                    <div class="col-7 pr-0 d-flex flex-column justify-content-center">
                       <div class="border p-1 px-2 rounded rounded-2">
                          <span class="font-weight-bold">ประเภทร้านค้า</span>
                          <div class="row m-0">
                            <div class="col-6 p-1">
                              <div class="p-1 text-center rounded customer-type-box"
                                   :style="customerTypeStyle(1)"
                                   @click="selectCustomerType(1)">ค้าส่ง</div>
                            </div>
                            <div class="col-6 p-1">
                              <div class="p-1 text-center rounded customer-type-box"
                                   :style="customerTypeStyle(2)"
                                   @click="selectCustomerType(2)">ปลีก-ส่ง</div>
                            </div>
                            <div class="col-6 p-1">
                              <div class="p-1 text-center rounded customer-type-box"
                                   :style="customerTypeStyle(3)"
                                   @click="selectCustomerType(3)">ค้าปลีก</div>
                            </div>
                            <div class="col-6 p-1">
                              <div class="p-1 text-center rounded customer-type-box"
                                   :style="customerTypeStyle(4)"
                                   @click="selectCustomerType(4)">ทำขนม</div>
                            </div>
                          </div>
                       </div>
                       <div class="border p-2 px-2 rounded rounded-2 mt-2">
                          <span class="font-weight-bold">พิกัดร้านค้า</span>

                          <!-- State 1: ยังไม่มีพิกัด -->
                          <div v-if="!customerInfo || !customerInfo.lat || !customerInfo.lng" class="mt-1">
                            <div class="p-2 text-center rounded customer-type-box" style="background:#FFD760;"
                                 @click="openMapModal">
                              กำหนดพิกัด
                            </div>
                          </div>

                          <!-- State 2: มีพิกัดแล้ว -->
                          <div v-else class="mt-1">
                            <div class="small text-muted mb-2" style="font-size:0.7em;">📍 {{ Number(customerInfo.lat).toFixed(6) }}, {{ Number(customerInfo.lng).toFixed(6) }}</div>
                            <div class="row m-0">
                              <div class="col-6 p-1 pl-0">
                                <div class="p-2 text-center rounded customer-type-box" style="background:#FFD760;"
                                     @click="openMapModal">ดู/แก้ไข</div>
                              </div>
                              <div class="col-6 p-1 pr-0">
                                <div class="p-2 text-center rounded customer-type-box" style="background:#C2EF80;"
                                     @click="openNavigation">นำทาง</div>
                              </div>
                            </div>
                          </div>
                       </div>
                        <div class="p-2 px-2 rounded rounded-2 mt-2 border" style="background:#eee">
                          <div class="d-flex align-items-center justify-content-between mb-1">
                            <span class="font-weight-bold">จัดกลุ่ม</span>
                            <span class="bg-warning p-1 rounded rounded-2 font-weight-bold"
                                  style="cursor:pointer;"
                                  @click="openCustomerGroupModal">เลือก</span>
                          </div>
                          <input class="text-center font-weight-bold pt-1 w-100"
                                 type="number" pattern="[0-9]*" inputmode="numeric"
                                 style="border:none;font-size:1.1em;background:#fff;border-radius:4px;"
                                 :placeholder="(!customerInfo || customerInfo.group_id == null) ? 'ไม่มี' : ''"
                                 :value="customerInfo ? customerInfo.group_id : ''"
                                 @click="$event.target.select()"
                                 @blur="onCustomerGroupInputBlur($event.target.value)" />
                        </div>
                    </div>

                    


                   </div>
                </div>
              </b-tab>

            </b-tabs>
          </div>
        </template>
        <template #modal-footer>
          <div class="row w-100 mt-1">
            <div class="col-12 p-2">
              <b-button block variant="warning" @click.prevent="closeModal('modal_customer');">
                <span style="font-size:1.4em;font-weight:bold;">ปิด</span>
              </b-button>
            </div>
          </div>
        </template>
      </b-modal>

      <!-- ========== CUSTOMER IMAGE LIGHTBOX (เปิดทับ modal_customer) ========== -->
      <b-modal id="modal_customer_image" ref="modal_customer_image"
               modal-class="peter-modal" size="lg"
               hide-header hide-footer no-fade centered
               body-class="p-0">
        <div class="customer-image-lightbox">
          <button type="button" class="lightbox-close" @click="$bvModal.hide('modal_customer_image')" aria-label="Close">✕</button>
          <img :src="customerImageModalSrc" class="lightbox-image" />
        </div>
      </b-modal>

      <!-- ========== PRODUCT IMAGE LIGHTBOX (เปิดทับ modal_stock_detail) ========== -->
      <b-modal id="modal_product_image" ref="modal_product_image"
               modal-class="peter-modal" size="lg"
               hide-header hide-footer no-fade centered
               body-class="p-0">
        <div class="customer-image-lightbox" @click="$bvModal.hide('modal_product_image')">
          <button type="button" class="lightbox-close" @click="$bvModal.hide('modal_product_image')" aria-label="Close">✕</button>
          <img :src="productImage" class="lightbox-image" @click.stop />
        </div>
        <div class="text-center small text-muted py-2" style="cursor:pointer;" @click="$bvModal.hide('modal_product_image')">
          {{ currentStock.STKCOD }} · {{ currentStock.STKDES }} — แตะเพื่อปิด
        </div>
      </b-modal>

      <!-- ========== CARD IMAGE LIGHTBOX (เปิดรูปสินค้าจากการ์ดในลิสต์) ========== -->
      <b-modal id="modal_card_image" ref="modal_card_image"
               modal-class="peter-modal" size="lg"
               hide-header hide-footer no-fade centered body-class="p-0">
        <div class="customer-image-lightbox" @click="$bvModal.hide('modal_card_image')">
          <button type="button" class="lightbox-close" @click="$bvModal.hide('modal_card_image')" aria-label="Close">✕</button>
          <img :src="cardImageSrc" class="lightbox-image" @click.stop />
        </div>
      </b-modal>

      <!-- ========== AI FIND IMAGE (เปิดทับ modal_stock_detail) ========== -->
      <b-modal id="modal_ai_find_image" ref="modal_ai_find_image"
               modal-class="peter-modal" hide-footer no-fade centered body-class="p-2">
        <template #modal-header>
          <div class="w-100 d-flex justify-content-between align-items-center">
            <span class="font-weight-bold">🔎 AI หารูปสินค้า</span>
            <button type="button" class="lightbox-close" style="position:static;background:#ccc;color:#333;"
              @click="$bvModal.hide('modal_ai_find_image')" aria-label="Close">✕</button>
          </div>
        </template>

        <div>
          <div class="small text-muted mb-2 text-truncate">{{ aiImageFor }} · {{ aiImageName }}</div>

          <!-- Loading -->
          <div v-if="aiImagesLoading" class="text-center py-5">
            <div class="spinner-border text-primary" role="status"></div>
            <div class="small text-muted mt-2">AI กำลังค้นหารูป...</div>
          </div>

          <!-- Empty -->
          <div v-else-if="!aiImages.length" class="text-center py-5 text-muted">
            ไม่พบรูปที่ตรง — ลองกด "หาใหม่"
          </div>

          <!-- Grid (แตะรูปเพื่อใช้เป็นรูปสินค้า) -->
          <div v-else class="row m-0">
            <div v-for="(im, i) in aiImages" :key="i" class="col-4 p-1">
              <div class="ai-img-cell" :class="{ 'ai-img-busy': aiSelecting }" @click="selectAiImage(im)">
                <img :src="im.thumbnail || im.url" loading="lazy" alt="ผลค้นหา" />
              </div>
            </div>
          </div>

          <div v-if="aiSelecting" class="text-center small text-muted mt-1">กำลังบันทึกรูป...</div>

          <b-button block variant="outline-secondary" class="mt-2"
            :disabled="aiImagesLoading || aiSelecting" @click="retryAiImages">
            🔄 หาใหม่
          </b-button>
        </div>
      </b-modal>

      <!-- ========== CUSTOMER MAP MODAL (เปิดทับ modal_customer) ========== -->
      <b-modal id="modal_customer_map" ref="modal_customer_map"
               modal-class="peter-modal" size="lg" hide-header no-fade centered
               body-class="p-3" :no-close-on-backdrop="true">

        <!-- Search bar - custom implementation (replaces deprecated gmap-autocomplete) -->
        <div class="map-modal-search">
          <input type="text"
                 ref="placeSearchInput"
                 class="form-control"
                 placeholder="ค้นหาสถานที่ เช่น 'เขมราฐ อุบลราชธานี'"
                 @input="onPlaceSearchInput($event.target.value)" />
          <!-- Predictions dropdown -->
          <div v-if="placeSearchResults.length > 0" class="map-search-dropdown">
            <div v-for="r in placeSearchResults" :key="r.place_id"
                 class="map-search-item"
                 @click="selectPlacePrediction(r)">
              <div class="small font-weight-bold">{{ r.structured_formatting.main_text }}</div>
              <div class="small text-muted">{{ r.structured_formatting.secondary_text }}</div>
            </div>
          </div>
          <div v-else-if="placeSearchQuery && placeSearchQuery.length >= 2 && !placeSearchLoading" class="map-search-dropdown">
            <div class="map-search-item text-muted small">ไม่พบสถานที่</div>
          </div>
        </div>

        <!-- Map container with fixed center pin overlay -->
        <div class="map-modal-container">
          <gmap-map
            ref="customerMap"
            :center="mapCenter"
            :zoom="mapZoom"
            :options="{
              disableDefaultUI: true,
              zoomControl: true,
              gestureHandling: 'greedy',
              mapTypeControl: false,
              streetViewControl: false,
              fullscreenControl: false
            }"
            @center_changed="onMapCenterChanged"
            style="width: 100%; height: 100%;">
          </gmap-map>
          <!-- Fixed center pin (overlay, not part of map) -->
          <div class="map-center-pin">📍</div>
          <!-- Hint -->
          <div class="map-hint">เลื่อนแผนที่ให้หมุดตรงตำแหน่งร้าน</div>
        </div>

        <template #modal-footer>
          <div class="w-100">
            <div class="row m-0">
              <div class="col-6 p-1 pl-0">
                <b-button block variant="outline-primary" @click="useCurrentLocation" :disabled="locatingUser">
                  <span v-if="locatingUser">⏳ กำลังหา...</span>
                  <span v-else>ใช้ตำแหน่งนี้</span>
                </b-button>
              </div>
              <div class="col-6 p-1 pr-0">
                <b-button block variant="warning" @click="saveMapLocation" :disabled="savingMap">
                  <span v-if="savingMap">⏳ บันทึก...</span>
                  <span v-else class="font-weight-bold">บันทึก</span>
                </b-button>
              </div>
            </div>
            <div class="row m-0 mt-1">
              <div class="col-12 p-1 px-0">
                <b-button block variant="danger" @click="$bvModal.hide('modal_customer_map')">ยกเลิก</b-button>
              </div>
            </div>
          </div>
        </template>
      </b-modal>

      <!-- ========== CUSTOMER GROUP SELECT MODAL (เปิดทับ modal_customer) ========== -->
      <!-- Mirror ของ modal_select_group_1 ที่ใช้กับสินค้า -->
      <b-modal id="modal_select_group_customer" ref="modal_select_group_customer" modal-class="peter-modal"
        body-class="pt-0 pb-0" header-class="p-0 m-0 pl-1 pr-1"
        footer-class="p-0 m-0 pl-3 pr-3" no-close-on-backdrop centered no-fade>
        <template #modal-header>
          <div class="w-100 text-center h5 font-weight-bold">ตัวช่วยเลือกกลุ่มร้านค้า</div>
        </template>
        <template #default>
          <div class="row">
            <div class="col-12 pt-2 text-left">
              <!-- Customer name + CUSCOD badge -->
              <div v-if="customerModalResource" class="w-100 text-truncate" style="padding-left:1px;">
                <b-badge variant="info" class="pl-2 pr-2 pt-1 pb-1">
                  <span style="font-size:1.3em;">{{ customerModalResource.CUSCOD }}</span>
                </b-badge>&nbsp;&nbsp; {{ customerModalResource.CUSNAM }}
              </div>

              <!-- Loading -->
              <div v-if="groupContextLoading" class="mt-3 text-center text-muted py-3">
                กำลังโหลด...
              </div>

              <div v-else-if="groupContext" class="row pl-0 pr-0 mt-2">
                <!-- Current group (blue badge) — กดเพื่อ confirm ใช้กลุ่มเดิม -->
                <div v-if="groupContext.current_group" class="col-12 pl-3 pr-3 px-0 d-flex justify-content-between">
                  <div>กลุ่มร้านค้าเดิม</div>
                  <div @click="assignCustomerGroup(groupContext.current_group)" style="cursor:pointer;">
                    <b-badge variant="primary" class="pl-2 pr-2 mr-1 pt-1 pb-1" style="width:60px;">
                      <span style="font-size:1.5em;">{{ groupContext.current_group }}</span>
                    </b-badge>
                  </div>
                </div>

                <!-- Suggested group (yellow badge) — เลขว่างที่เล็กที่สุด -->
                <div class="col-12 pl-3 pr-3 px-0 mt-1 d-flex justify-content-between">
                  <div>กลุ่มร้านค้าที่ว่างอยู่</div>
                  <div @click="assignCustomerGroup(computedSuggestGroup)" style="cursor:pointer;">
                    <b-badge variant="warning" class="pl-2 pr-2 mr-1 pt-1 pb-1" style="width:60px;">
                      <span style="font-size:1.5em;">{{ computedSuggestGroup }}</span>
                    </b-badge>
                  </div>
                </div>

                <!-- Amphoe section title -->
                <div class="col-12 pl-3 pr-3 px-0 mt-2 text-left text-truncate">
                  <strong>ลูกค้าใน{{ groupContext.amphoe || 'อำเภอนี้' }}</strong>
                </div>

                <!-- Same-amphoe customers with their groups -->
                <div v-for="(item, i) in groupContext.same_amphoe_customers" :key="i"
                     class="col-12 pl-3 pr-3 px-0 d-flex justify-content-between"
                     :class="{'mt-0': i==0, 'mt-1': i!=0}">
                  <div class="d-fill text-truncate">{{ item.cusnam }}</div>
                  <div @click="assignCustomerGroup(item.group_id)" style="cursor:pointer;">
                    <b-badge variant="secondary" class="pl-2 pr-2 mr-1 pt-1 pb-1" style="width:60px;">
                      <span style="font-size:1.5em;">{{ item.group_id }}</span>
                    </b-badge>
                  </div>
                </div>

                <div v-if="groupContext.same_amphoe_customers.length == 0" class="col-12 pl-3 pr-3 px-0 mt-1 text-muted">
                  ยังไม่มีลูกค้าจัดกลุ่มในอำเภอนี้
                </div>
              </div>
            </div>
          </div>
        </template>
        <template #modal-footer>
          <div class="row w-100">
            <div class="col-6 p-2">
              <!-- ปุ่มล้างกลุ่ม — แสดงเฉพาะเมื่อมี current_group -->
              <b-button v-if="groupContext && groupContext.current_group"
                        block variant="outline-danger"
                        @click.prevent="clearCustomerGroup">
                <span class="font-weight-bold" style="font-size:1.4em;">ล้างกลุ่ม</span>
              </b-button>
            </div>
            <div class="col-6 p-2">
              <b-button block variant="warning" @click.prevent="closeModal('modal_select_group_customer');">
                <span class="font-weight-bold" style="font-size:1.4em;">ปิด</span>
              </b-button>
            </div>
          </div>
        </template>
      </b-modal>

      <!-- ========== INVOICE DETAIL MODAL (เปิดทับ modal_customer) ========== -->
      <b-modal id="modal_invoice" ref="modal_invoice" modal-class="peter-modal"
        :body-bg-variant="'white'" :footer-bg-variant="'light'"
        hide-header size="md" no-fade>
        <template #default>
          <!-- Skeleton loading - mirrors real layout -->
          <div v-if="invoiceLoading">
            <!-- Skeleton: Header card -->
            <div class="rounded p-3 mb-3" style="border:1px solid #dee2e6;">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <div class="skeleton-box" style="width:120px; height:20px;"></div>
                <div class="skeleton-box" style="width:90px; height:16px;"></div>
              </div>
              <div class="d-flex justify-content-between mb-1">
                <div class="skeleton-box" style="width:80px; height:12px;"></div>
                <div class="skeleton-box" style="width:140px; height:12px;"></div>
              </div>
              <div class="d-flex justify-content-between">
                <div class="skeleton-box" style="width:50px; height:12px;"></div>
                <div class="skeleton-box" style="width:180px; height:12px;"></div>
              </div>
            </div>

            <!-- Skeleton: Items card -->
            <div class="rounded mb-3" style="border:1px solid #dee2e6; overflow:hidden;">
              <div class="px-3 py-2" style="background-color:#f8f9fa; border-bottom:1px solid #dee2e6;">
                <div class="skeleton-box" style="width:140px; height:14px;"></div>
              </div>
              <div v-for="n in 3" :key="n" class="px-3 py-2"
                   :style="{ borderBottom: n < 3 ? '1px solid #f0f0f0' : 'none' }">
                <div class="d-flex justify-content-between mb-1">
                  <div class="skeleton-box" :style="{ width: (60 + n * 30) + 'px', height: '14px' }"></div>
                  <div class="skeleton-box" style="width:70px; height:14px;"></div>
                </div>
                <div class="skeleton-box" style="width:120px; height:11px;"></div>
              </div>
            </div>

            <!-- Skeleton: Summary card -->
            <div class="rounded p-3" style="border:1px solid #dee2e6; background-color:#f8f9fa;">
              <div class="d-flex justify-content-between mb-2">
                <div class="skeleton-box" style="width:90px; height:12px;"></div>
                <div class="skeleton-box" style="width:70px; height:12px;"></div>
              </div>
              <div class="d-flex justify-content-between mb-2">
                <div class="skeleton-box" style="width:60px; height:12px;"></div>
                <div class="skeleton-box" style="width:60px; height:12px;"></div>
              </div>
              <div class="d-flex justify-content-between pt-2" style="border-top:1px solid #dee2e6;">
                <div class="skeleton-box" style="width:80px; height:18px;"></div>
                <div class="skeleton-box" style="width:100px; height:20px;"></div>
              </div>
            </div>
          </div>

          <!-- Empty / error -->
          <div v-else-if="!invoice" class="text-center text-muted py-4">
            ไม่พบข้อมูลบิล
          </div>

          <div v-else>
            <!-- ===== Header info card ===== -->
            <div class="rounded p-3 mb-3" style="border:1px solid #dee2e6;">
              <div class="d-flex justify-content-between align-items-start mb-2">
                <span class="font-weight-bold" style="font-size:1.05em;">{{ invoice.docnum }}</span>
                <span v-if="invoice.is_vat" class="px-2 rounded text-white text-nowrap" style="background-color:#6c8eb6; font-size:0.7em; align-self:center;">ใบกำกับภาษี (VAT)</span>
                <span v-else class="px-2 rounded text-white text-nowrap" style="background-color:#888; font-size:0.7em; align-self:center;">ใบส่งของ</span>
              </div>
              <div class="d-flex justify-content-between small">
                <span class="text-muted">วันที่ออกบิล</span>
                <span>{{ formatDateTH(invoice.docdat) }} <span class="text-muted">({{ relativeDays(invoice.docdat) }})</span></span>
              </div>
              <div class="d-flex justify-content-between small">
                <span class="text-muted text-nowrap mr-2">ลูกค้า</span>
                <span class="text-right">
                  {{ invoice.customer_cod }}
                  <span v-if="invoice.customer_name"> · {{ invoice.customer_name }}</span>
                </span>
              </div>
            </div>

            <!-- ===== Line items card ===== -->
            <div class="rounded mb-3" style="border:1px solid #dee2e6; overflow:hidden;">
              <div class="px-3 py-2 small font-weight-bold" style="background-color:#f8f9fa; border-bottom:1px solid #dee2e6;">
                รายการสินค้า ({{ invoice.items.length }} รายการ)
              </div>
              <ul class="list-unstyled mb-0">
                <li v-for="(it, i) in invoice.items" :key="i"
                    class="px-3 py-2"
                    :style="{ borderBottom: i < invoice.items.length - 1 ? '1px solid #f0f0f0' : 'none' }">
                  <div class="d-flex justify-content-between">
                    <span class="flex-grow-1 mr-2">
                      <strong>{{ i + 1 }}.</strong> {{ it.name }}
                    </span>
                    <span class="font-weight-bold text-nowrap">
                      {{ numberFormat(it.line_total) }}
                    </span>
                  </div>
                  <div class="small text-muted">
                    {{ it.qty }} {{ it.unit }} × {{ numberFormat(it.unit_price) }}
                    <span v-if="it.discount > 0"> · ลด {{ numberFormat(it.discount) }}</span>
                  </div>
                </li>
              </ul>
            </div>

            <!-- ===== Summary card ===== -->
            <div class="rounded p-3" style="border:1px solid #dee2e6; background-color:#f8f9fa;">
              <div v-if="invoice.is_vat" class="d-flex justify-content-between small mb-1">
                <span class="text-muted">มูลค่าก่อน VAT</span>
                <span>{{ numberFormat(invoice.summary.subtotal) }}</span>
              </div>
              <div v-if="invoice.summary.discount > 0" class="d-flex justify-content-between small mb-1">
                <span class="text-muted">ส่วนลดรวม</span>
                <span class="text-danger">-{{ numberFormat(invoice.summary.discount) }}</span>
              </div>
              <div v-if="invoice.is_vat" class="d-flex justify-content-between small mb-1">
                <span class="text-muted">VAT 7%</span>
                <span>{{ numberFormat(invoice.summary.vat_amount) }}</span>
              </div>
              <div class="d-flex justify-content-between mt-2 pt-2" style="border-top:1px solid #dee2e6;">
                <span class="font-weight-bold">รวมทั้งสิ้น</span>
                <span class="font-weight-bold" style="font-size:1.2em;">{{ numberFormat(invoice.summary.grand_total) }}</span>
              </div>
            </div>
          </div>
        </template>

        <template #modal-footer>
          <div class="row w-100 mt-1">
            <div class="col-12 p-2">
              <b-button block variant="warning" @click.prevent="closeModal('modal_invoice');">
                <span style="font-size:1.4em;font-weight:bold;">ปิด</span>
              </b-button>
            </div>
          </div>
        </template>
      </b-modal>

      <!-- ===== Modal Group Stock ===== -->
      <b-modal id="modal_group_1" ref="modal_group_1" modal-class="peter-modal"
        body-class="pt-0 pb-0" header-class="p-0 m-0 pl-1 pr-1"
        footer-class="p-0 m-0 pl-3 pr-3" no-close-on-backdrop centered no-fade>
        <template #modal-header>&nbsp;</template>
        <template #default>
          <div class="row d-flex flex-column align-item-center justify-content-center" ref="imgContainer2"></div>
          <div v-show="imageDisplay" class="row">
            <div class="col-12 pt-2" ref="domImg2">
              <div class="w-100 text-truncate text-center" style="padding-left:1px;">
                <img class="d-inline-block mr-2" src="../assets/slogo.png" style="position:relative;height:30px;">
                <span class="font-weight-bold" style="font-size:1.2em;">นับสต็อกสินค้าวันที่ {{ todayDate() }}</span>
                <h6>กลุ่มสินค้า #{{ groupFilter }}</h6>
              </div>
              <div class="row pl-0 pr-0">
                <div class="col-12 p-2">
                  <div class="w-100 d-flex justify-content-between p-1" v-for="(item, i) in groupStocks" :key="i"
                    style="border:1px solid #ddd;border-bottom:0;" :style="i == groupStocks.length - 1 && 'border-bottom:1px solid #ddd;'"
                    :class="item.BACKGROUND_CLASS" @click="openModalFind('modal_count_2', item.STKCOD)">
                    <div class="text-truncate pl-1" style="width:80%;">
                      <span style="font-size:1.1em;" :class="{'font-weight-bold': item.STKCOD == currentStock.STKCOD}">
                        <b-icon v-show="isToday(item.counted_at)" icon="check-circle-fill" style="color:green;margin-right:3px;"/>
                        {{ item.STKDES }}
                      </span>
                    </div>
                    <div class="font-weight-bold text-center d-flex flex-column align-item-center justify-content-center" style="width:60px;">
                      <span class="h5 font-weight-bold m-0 p-0" :class="{'h6': item.count_expired}">
                        {{ !item.count_expired ? getValueFromAtom(item.ATOM_LOCBAL + item.express_DIFF, item.CFACTOR).BIG : 'ยังไม่นับ' }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template #modal-footer>
          <div class="row w-100">
            <div class="col-6 p-2">
              <b-button v-if="imageDisplay" block variant="secondary" @click.prevent="makeImg2()">
                <span class="font-weight-bold" style="font-size:1.4em;">
                  <b-icon icon="file-image-fill" style="position:relative;color:#ddd;margin:0;padding:0;top:-3px;"/> สร้างรูป
                </span>
              </b-button>
            </div>
            <div class="col-6 p-2">
              <b-button block variant="warning" @click.prevent="imageDisplay=false;closeModal('modal_group_1');">
                <span class="font-weight-bold" style="font-size:1.4em;">ปิด</span>
              </b-button>
            </div>
          </div>
        </template>
      </b-modal>

      <!-- ===== Modal Select Group ===== -->
      <b-modal id="modal_select_group_1" ref="modal_select_group_1" modal-class="peter-modal"
        body-class="pt-0 pb-0" header-class="p-0 m-0 pl-1 pr-1"
        footer-class="p-0 m-0 pl-3 pr-3" no-close-on-backdrop centered no-fade>
        <template #modal-header>
          <div class="w-100 text-center h5 font-weight-bold">ตัวช่วยเลือกกลุ่มสินค้า</div>
        </template>
        <template #default>
          <div class="row">
            <div class="col-12 pt-2 text-left">
              <div class="w-100 text-truncate" style="padding-left:1px;">
                <b-badge variant="info" class="pl-2 pr-2 pt-1 pb-1">
                  <span style="font-size:1.3em;">{{ currentStock.STKCOD }}</span>
                </b-badge>&nbsp;&nbsp;{{ currentStock.STKDES }}
              </div>
              <div class="row pl-0 pr-0 mt-2">
                <div v-if="currentStock.count_code" class="col-12 pl-3 pr-3 px-0 d-flex justify-content-between">
                  <div>กลุ่มสินค้าเดิม</div>
                  <div @click="save(modalResource);closeModal('modal_select_group_1')">
                    <b-badge variant="primary" class="pl-2 pr-2 mr-1 pt-1 pb-1" style="width:60px;">
                      <span style="font-size:1.5em;">{{ currentStock.count_code }}</span>
                    </b-badge>
                  </div>
                </div>
                <div class="col-12 pl-3 pr-3 px-0 mt-1 d-flex justify-content-between">
                  <div>กลุ่มสินค้าที่ว่างอยู่</div>
                  <div @click="currentStock.count_code=suggestGroup;save(modalResource);closeModal('modal_select_group_1')">
                    <b-badge variant="warning" class="pl-2 pr-2 mr-1 pt-1 pb-1" style="width:60px;">
                      <span style="font-size:1.5em;">{{ suggestGroup }}</span>
                    </b-badge>
                  </div>
                </div>
                <div class="col-12 pl-3 pr-3 px-0 mt-2 text-left text-truncate">
                  <strong>{{ currentStock.SUPNAM_SUPPLIER }}</strong>
                </div>
                <div v-for="(item, i) in sameGroup" :key="i" class="col-12 pl-3 pr-3 px-0 d-flex justify-content-between"
                  :class="{'mt-0': i==0, 'mt-1': i!=0}">
                  <div class="d-fill text-truncate">{{ item.STKDES }}</div>
                  <div @click="currentStock.count_code=item.count_code;save(modalResource);closeModal('modal_select_group_1')">
                    <b-badge variant="secondary" class="pl-2 pr-2 mr-1 pt-1 pb-1" style="width:60px;">
                      <span style="font-size:1.5em;">{{ item.count_code }}</span>
                    </b-badge>
                  </div>
                </div>
                <div v-if="sameGroup && sameGroup.length==0" class="col-12 pl-3 pr-3 px-0">ไม่เคยมีกลุ่มสินค้าของบริษัทฯนี้</div>
              </div>
            </div>
          </div>
        </template>
        <template #modal-footer>
          <div class="row w-100">
            <div class="col-6 p-2">&nbsp;</div>
            <div class="col-6 p-2">
              <b-button block variant="warning" @click.prevent="closeModal('modal_select_group_1');imageDisplay=false;">
                <span class="font-weight-bold" style="font-size:1.4em;">ปิด</span>
              </b-button>
            </div>
          </div>
        </template>
      </b-modal>

      <!-- ===== Modal Calculator (นับเช้า) ===== -->
      <b-modal id="modal_multi_1" modal-class="peter-modal" body-class="p-0 pt-0 pb-0 mt-0"
        header-class="p-0 m-0 pl-1 pr-1" footer-class="p-0 m-0 pl-3 pr-3" no-fade no-close-on-backdrop>
        <template #modal-header>
          <div class="row">
            <div class="col-12">
              <div class="text-truncate">
                <b-badge variant="info" class="p-2"><span style="font-size:1.3em;">{{ currentStock.STKCOD }}</span></b-badge>
                {{ currentStock.STKDES }}
              </div>
            </div>
            <div class="col-12 mt-1">
              <div class="pl-3 pr-3 pt-0">
                <div class="row pl-2 pr-2 pt-1 pb-1 mb-1 text-dark" style="border-radius:0.25rem;border:2px solid #ccc;position:relative;background:#ddd;">
                  <div class="col-6 text-center d-flex flex-column p-1">
                    <div class="h6 m-0 p-0 mb-1 font-weight-bold" @click="legEditTrigger=true">เรียงขาละ</div>
                    <b-form-input v-model="currentStock.leg" type="number" pattern="[0-9]*" inputmode="numeric"
                      style="height:51px;width:100%;padding:0;font-size:1.9em;text-align:center;font-weight:bold;"
                      @focus="$event.target.select()" v-if="legEditTrigger" v-click-outside="resetLegEdit"/>
                    <div v-if="!legEditTrigger" class="d-none d-flex flex-column align-item-center justify-content-center bg-info text-light"
                      style="height:50px;width:100%;font-size:2em;text-align:center;font-weight:bold;border-radius:0.2em;"
                      @click="addPal(currentStock.leg)">
                      {{ currentStock.leg || "-" }}
                    </div>
                  </div>
                  <div class="col-3 text-center d-flex flex-column p-1" @click="addSmallPal()">
                    <div class="h6 m-0 p-0 mb-1 font-weight-bold">เพิ่มกอง</div>
                    <div class="d-flex flex-column align-item-center justify-content-center" style="background:#ddd;border:1px solid #888;height:50px;width:100%;font-size:2em;text-align:center;font-weight:bold;border-radius:0.2em;">+</div>
                  </div>
                  <div class="col-3 text-center d-flex flex-column p-1" @click="addPal()">
                    <div class="h6 m-0 p-0 mb-1 font-weight-bold">เพิ่มชุบนับ</div>
                    <div class="d-flex flex-column align-item-center justify-content-center bg-success" style="border:1px solid green;height:50px;width:100%;font-size:2em;text-align:center;font-weight:bold;border-radius:0.2em;">+</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template #default>
          <div class="col-12 pl-1 pr-1 pt-0 pb-0">
            <div class="pl-3 pr-3">
              <div v-for="(cal, index) in calculator.cal.length" :key="'c'+index" class="row pl-2 pr-2 pb-1 pt-1 bg-light mb-1"
                style="border-radius:0.25rem;border:1px solid #ddd;position:relative;">
                <div class="row pl-3 pr-3">
                  <div v-if="(calculator.cal[index].leg * calculator.cal[index].floor) != 0"
                    class="d-flex flex-column justify-content-center align-item-center text-center font-weight-bold"
                    style="position:absolute;font-size:0.9em;right:0;bottom:0;padding:0 8px;min-width:90px;height:16px;background:#ddd;color:white;">
                    <span>เลทละ {{ calculator.cal[index].leg * calculator.cal[index].floor }}</span>
                  </div>
                  <div class="col-3 text-center d-flex flex-column p-1">
                    <div class="h6 m-0 p-0 font-weight-bold">เรียงขาละ</div>
                    <b-form-input v-model="calculator.cal[index].leg" type="number" pattern="[0-9]*" inputmode="numeric"
                      style="height:60px;width:100%;padding:0;font-size:2em;text-align:center;font-weight:bold;" @focus="$event.target.select()"/>
                  </div>
                  <div class="col-3 text-center d-flex flex-column p-1">
                    <div class="h6 m-0 p-0 font-weight-bold">จำนวนชั้น</div>
                    <b-form-input v-model="calculator.cal[index].floor" type="number" pattern="[0-9]*" inputmode="numeric"
                      style="height:60px;width:100%;padding:0;font-size:2em;text-align:center;font-weight:bold;" @focus="$event.target.select()"/>
                  </div>
                  <div class="col-3 text-center d-flex flex-column p-1">
                    <div class="h6 m-0 p-0 font-weight-bold">#พาเลท</div>
                    <b-form-input v-model="calculator.cal[index].pal" type="number" pattern="[0-9]*" inputmode="numeric"
                      style="height:60px;width:100%;padding:0;font-size:2em;text-align:center;font-weight:bold;" @focus="$event.target.select()"/>
                  </div>
                  <div class="col-3 text-center d-flex flex-column p-1">
                    <div class="h6 m-0 p-0 font-weight-bold">ชุดนับที่ {{ index + 1 }}</div>
                    <div v-if="delPalTrigger == index && calculator.cal.length > 1" class="p-0 bg-danger text-light"
                      style="border-radius:0.25rem;height:60px;width:100%;line-height:60px;font-size:2em;text-align:center;font-weight:bold;"
                      @click="delPal(index)" v-click-outside="resetDelPal">ลบ?</div>
                    <div v-if="delPalTrigger != index || calculator.cal.length == 1" class="p-0"
                      style="border-radius:0.25rem;height:60px;width:100%;line-height:60px;font-size:2em;text-align:center;font-weight:bold;"
                      @click="delPalTrigger = index">
                      {{ calculator.cal[index].leg * calculator.cal[index].floor * calculator.cal[index].pal }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 pl-1 pr-1 pt-0 pb-0">
            <div class="pl-3 pr-3 pt-0" v-click-outside="resetDelSmallPal">
              <div class="row pl-2 pr-2 pb-1 pt-1 bg-light mb-1" style="border-radius:0.25rem;border:1px solid #ddd;position:relative;">
                <div v-for="(cal, index) in calculator.cal_.length" :key="'s'+index" class="col-3 text-center d-flex flex-column p-1">
                  <div class="h6 m-0 p-0 font-weight-bold" @click="delSmallPalTrigger = index">กองที่ {{ index + 1 }}</div>
                  <div v-if="delSmallPalTrigger == index && calculator.cal_.length > 1" class="bg-danger text-light d-flex flex-column align-item-center justify-content-center"
                    style="border-radius:0.25rem;height:60px;width:100%;font-size:2em;text-align:center;font-weight:bold;"
                    @click="delSmallPal(index)">ลบ?</div>
                  <b-form-input v-if="delSmallPalTrigger != index || calculator.cal_.length == 1" v-model="calculator.cal_[index].big"
                    type="number" pattern="[0-9]*" inputmode="numeric"
                    style="height:60px;width:100%;padding:0;font-size:2em;text-align:center;font-weight:bold;" @focus="$event.target.select()"/>
                </div>
                <div class="col-3 text-center d-flex flex-column p-1">
                  <div class="h6 m-0 p-0 font-weight-bold text-warning">หน่วยย่อย</div>
                  <b-form-input v-model="calculator.cal_[0].small" class="text-warning" type="number" pattern="[0-9]*" inputmode="numeric"
                    style="height:60px;width:100%;padding:0;font-size:2em;text-align:center;font-weight:bold;" @focus="$event.target.select()"/>
                </div>
              </div>
            </div>
          </div>
          <!-- SO Info -->
          <div v-if="currentStock.STAT == 'N'" class="col-12 pl-1 pr-1 pt-0 pb-0">
            <div class="pl-3 pr-3 pt-0">
              <div class="row pl-2 pr-2 pb-1 pt-1" style="background:#F0E2B6;border-radius:0.25rem;border:2px solid #F6BE00;position:relative;">
                <div class="col-6 d-flex flex-column p-1">
                  <div class="h6 m-0 p-0 font-weight-bold"><u>รายการจัดสินค้าวันนี้</u></div>
                  <div class="d-flex align-item-center" style="height:40px;">
                    <input type="checkbox" id="tdj" v-model="calculator.CHECK_STAT" :true-value="1" :false-value="0"
                      class="peter-check-box m-0" style="height:35px;width:35px;">
                    <label for="tdj" class="pl-2 m-0" style="line-height:35px;">เพิ่มจำนวนนี้ ?</label>
                  </div>
                </div>
                <div class="col-3 text-center d-flex flex-column p-1">
                  <div class="h6 m-0 p-0">หน่วยใหญ่</div>
                  <div class="bg-warning d-flex flex-column align-item-center justify-content-center"
                    style="border-radius:0.25em;height:40px;width:100%;font-size:2em;text-align:center;font-weight:bold;">
                    {{ getValueFromAtom(currentStock.ATOM_ORDQTY, currentStock.CFACTOR).BIG }}
                  </div>
                </div>
                <div class="col-3 text-center d-flex flex-column p-1">
                  <div class="h6 m-0 p-0">#ลูกค้า</div>
                  <div class="bg-danger d-flex flex-column align-item-center justify-content-center text-light"
                    style="border-radius:0.25em;height:40px;width:100%;font-size:2em;text-align:center;font-weight:bold;">
                    {{ currentStock.SOCOUNT }}
                  </div>
                </div>
                <div v-show="!soCusDetail" class="col-12 p-1 text-right font-weight-bold" @click="soCusDetail=true;">ดูรายละเอียด</div>
                <div class="col-12 p-1 pr-2" v-show="soCusDetail">
                  <div class="d-flex justify-content-between w-100 m-0 p-0" v-for="(c, ci) in currentStock.SOCUS" :key="ci">
                    <div>{{ ci + 1 }}. {{ c.NAME }}</div>
                    <div>{{ getValueFromAtom(c.ATOM_QTY, currentStock.CFACTOR).BIG }} {{ currentStock.PQUCOD }}</div>
                  </div>
                </div>
                <div v-show="soCusDetail" class="col-12 p-1 text-right font-weight-bold" @click="soCusDetail=false;">ซ่อนรายละเอียด</div>
              </div>
            </div>
          </div>
          <!-- Calculator Result -->
          <div class="col-12 p-2 noselect">
            <div class="p-2 d-flex align-items-center justify-content-center">
              <div class="row w-100">
                <div class="col-6 p-0 pr-1 pl-3 text-center">
                  <div class="bg-light p-0 pt-1 d-flex flex-column" style="border-radius:0.25rem;">
                    <div>หน่วยใหญ่ ({{ currentStock.PQUCOD }})</div>
                    <div class="w-100 pb-3 text-center align-self-center font-weight-bold text-danger">
                      <span class="big-unit-text">
                        {{ calculator.cal.reduce((r, i) => r + parseInt(i.leg * i.floor * i.pal), 0) + calculator.cal_.reduce((r, i) => r + parseInt(i.big), 0) + parseInt(_calPlus(modalResource).BIG) }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-6 p-0 pr-3 pl-1 text-center">
                  <div class="p-0 pt-1 d-flex flex-column bg-light" style="border-radius:0.25rem;">
                    <div>หน่วยย่อย ({{ currentStock.QUCOD }})</div>
                    <div class="w-100 pb-3 text-center align-self-center font-weight-bold" style="color:#FFBF00">
                      <span class="big-unit-text">{{ parseInt(calculator.cal_[0].small) + _calPlus(modalResource).SMALL }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template #modal-footer>
          <div class="row w-100 mt-1">
            <div class="col-6 pl-2 pr-2 pb-0">
              <b-button block variant="light" @click="calReset()">
                <div style="font-size:1.4em;font-weight:bold;">
                  <b-icon icon="trash" style="position:relative;margin:0;padding:0;top:-4px !important;padding-right:5px;"/> ล้างค่า
                </div>
              </b-button>
            </div>
            <div class="col-6 pl-2 pr-2 pb-0">
              <b-button block variant="success" @click.prevent="save_count_stock(modalResource);">
                <div style="font-size:1.4em;font-weight:bold;">
                  <b-icon icon="check-circle" style="position:relative;margin:0;padding:0;top:-4px !important;padding-right:5px;"/> ยืนยัน
                </div>
              </b-button>
            </div>
            <div class="col-12 p-2">
              <b-button block variant="warning" @click.prevent="calReset();closeModal('modal_multi_1');">
                <span style="font-size:1.4em;font-weight:bold;">ปิด</span>
              </b-button>
            </div>
          </div>
        </template>
      </b-modal>

      <!-- ===== Modal Weight ===== -->
      <b-modal id="modal_weight" modal-class="peter-modal" body-class="p-0 pt-0 pb-0 mt-0"
        header-class="p-0 m-0 pl-1 pr-1" footer-class="p-0 m-0 pl-3 pr-3" no-close-on-backdrop centered no-fade>
        <template #modal-header>
          <div class="row pl-2 pr-2">
            <div class="col-12">
              <div class="text-truncate">
                <b-badge variant="info" class="p-2"><span style="font-size:1.3em;">{{ currentStock.STKCOD }}</span></b-badge>
                {{ currentStock.STKDES }}
              </div>
            </div>
          </div>
        </template>
        <template #default>
          <div class="row pl-2 pr-2">
            <div class="col-12 mt-1">
              <div class="pl-3 pr-3 pt-0">
                <div class="row pl-1 pr-1 pt-1 pb-1 mb-1 text-dark bg-ddd" style="border-radius:0.25rem;border:2px solid #ccc;">
                  <div class="col-12 d-flex flex-column p-1 justify-content-center align-items-center">
                    <div v-for="n in 3" :key="n" class="row w-100 d-flex align-items-center" :class="{'mt-2': n > 1}">
                      <div class="col-6"><h5 class="m-0">ชั้งครั้งที่ {{ n }}</h5></div>
                      <div class="col-6 text-right">
                        <input v-model="currentStock['weight_' + n]" type="number" pattern="[0-9]*" inputmode="numeric"
                          class="form-control w-100 text-right" style="font-size:1.1em;font-weight:bold;"
                          @focus="$event.target.select()"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 mt-1">
              <div class="pl-3 pr-3 pt-0">
                <div class="row pl-2 pr-2 pt-1 pb-1 mb-1 text-dark"
                  :class="{'border-success bg-light-green': avgWeight, 'bg-light-dark': !avgWeight}"
                  style="border-radius:0.25rem;border:2px solid #ccc;">
                  <div class="col-6 d-flex flex-column p-1 justify-content-center align-items-start">
                    <h5 class="m-0 font-weight-bold">น้ำหนักมาตรฐาน</h5>
                  </div>
                  <div class="col-6 d-flex flex-column p-1">
                    <h5 class="m-0 text-right font-weight-bold">{{ avgWeight ? numberFormat(avgWeight) + " KG" : "ใส่ให้ครบ 3 ครั้ง" }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template #modal-footer>
          <div class="row w-100 mt-1">
            <div class="col-6 pl-2 pr-2 pb-0">
              <b-button block variant="light" @click="calReset()">
                <div style="font-size:1.4em;font-weight:bold;">
                  <b-icon icon="trash" style="position:relative;margin:0;padding:0;top:-4px !important;padding-right:5px;"/> ล้างค่า
                </div>
              </b-button>
            </div>
            <div class="col-6 pl-2 pr-2 pb-0">
              <b-button block :variant="isThreeWeight ? 'success' : 'secondary'" :disabled="!isThreeWeight"
                @click.prevent="isThreeWeight && save_weight(modalResource);">
                <div style="font-size:1.4em;font-weight:bold;">
                  <b-icon icon="check-circle" style="position:relative;margin:0;padding:0;top:-4px !important;padding-right:5px;"/> ยืนยัน
                </div>
              </b-button>
            </div>
            <div class="col-12 p-2">
              <b-button block variant="warning" @click.prevent="closeModal('modal_weight');">
                <span style="font-size:1.4em;font-weight:bold;">ปิด</span>
              </b-button>
            </div>
          </div>
        </template>
      </b-modal>

      <!-- ===== Modal Calculator Last (นับเย็น) ===== -->
      <b-modal id="modal_multi_last" modal-class="peter-modal"
        header-class="p-0 m-0 pl-1 pr-1 d-block" body-class="p-0 pt-0 pb-0 mt-0"
        footer-class="p-0 m-0 pl-3 pr-3" no-fade no-close-on-backdrop>
        <template #modal-header>
          <div class="row">
            <div class="col-12">
              <div class="text-truncate">
                <b-badge variant="info" class="pl-2 pr-2 pt-1 pb-1">
                  <span style="font-size:1.3em;">{{ currentStock.STKCOD }}</span>
                </b-badge> {{ currentStock.STKDES }}
              </div>
            </div>
            <div class="col-12 mt-1">
              <div class="pl-3 pr-3 pt-0">
                <div class="row pl-2 pr-2 pt-1 pb-1 mb-1 text-dark" style="border-radius:0.25rem;border:2px solid #ccc;background:#ddd;">
                  <div class="col-6 text-center d-flex flex-column p-1">
                    <div class="h6 m-0 p-0 mb-1 font-weight-bold" @click="legEditTrigger=true">เรียงขาละ</div>
                    <b-form-input v-model="currentStock.leg" type="number" pattern="[0-9]*" inputmode="numeric"
                      style="height:51px;width:100%;padding:0;font-size:1.9em;text-align:center;font-weight:bold;"
                      @focus="$event.target.select()" v-if="legEditTrigger" v-click-outside="resetLegEdit"/>
                    <div v-if="!legEditTrigger" class="d-none d-flex flex-column align-item-center justify-content-center bg-info text-light"
                      style="height:35px;width:100%;font-size:2em;text-align:center;font-weight:bold;border-radius:0.2em;"
                      @click="addPal(currentStock.leg, true)">{{ currentStock.leg || "-" }}</div>
                  </div>
                  <div class="col-3 text-center d-flex flex-column p-1" @click="addSmallPal(true)">
                    <div class="h6 m-0 p-0 mb-1 font-weight-bold">เพิ่มกอง</div>
                    <div class="d-flex flex-column align-item-center justify-content-center" style="background:#ddd;border:1px solid #888;height:35px;width:100%;font-size:2em;text-align:center;font-weight:bold;border-radius:0.2em;">+</div>
                  </div>
                  <div class="col-3 text-center d-flex flex-column p-1" @click="addPal(null, true)">
                    <div class="h6 m-0 p-0 mb-1 font-weight-bold">เพิ่มชุบนับ</div>
                    <div class="d-flex flex-column align-item-center justify-content-center bg-success" style="border:1px solid green;height:35px;width:100%;font-size:2em;text-align:center;font-weight:bold;border-radius:0.2em;">+</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template #default>
          <div class="col-12 pl-1 pr-1 pt-0 pb-0">
            <div class="pl-3 pr-3">
              <div v-for="(cal, index) in calculator_last.cal.length" :key="'lc'+index" class="row pl-2 pr-2 pb-1 pt-1 bg-light mb-1"
                style="border-radius:0.25rem;border:1px solid #ddd;position:relative;">
                <div class="row pl-3 pr-3">
                  <div v-if="(calculator_last.cal[index].leg * calculator_last.cal[index].floor) != 0"
                    class="d-flex flex-column justify-content-center align-item-center text-center font-weight-bold"
                    style="position:absolute;font-size:0.9em;right:0;bottom:0;padding:0 8px;min-width:90px;height:16px;background:#ddd;color:white;">
                    <span>เลทละ {{ calculator_last.cal[index].leg * calculator_last.cal[index].floor }}</span>
                  </div>
                  <div class="col-3 text-center d-flex flex-column p-1">
                    <div class="h6 m-0 p-0 font-weight-bold">เรียงขาละ</div>
                    <b-form-input v-model="calculator_last.cal[index].leg" type="number" pattern="[0-9]*" inputmode="numeric"
                      style="height:47px;width:100%;padding:0;font-size:1.8em;text-align:center;font-weight:bold;" @focus="$event.target.select()"/>
                  </div>
                  <div class="col-3 text-center d-flex flex-column p-1">
                    <div class="h6 m-0 p-0 font-weight-bold">จำนวนชั้น</div>
                    <b-form-input v-model="calculator_last.cal[index].floor" type="number" pattern="[0-9]*" inputmode="numeric"
                      style="height:47px;width:100%;padding:0;font-size:1.8em;text-align:center;font-weight:bold;" @focus="$event.target.select()"/>
                  </div>
                  <div class="col-3 text-center d-flex flex-column p-1">
                    <div class="h6 m-0 p-0 font-weight-bold">#พาเลท</div>
                    <b-form-input v-model="calculator_last.cal[index].pal" type="number" pattern="[0-9]*" inputmode="numeric"
                      style="height:47px;width:100%;padding:0;font-size:1.8em;text-align:center;font-weight:bold;" @focus="$event.target.select()"/>
                  </div>
                  <div class="col-3 text-center d-flex flex-column p-1">
                    <div class="h6 m-0 p-0 font-weight-bold">ชุดนับที่ {{ index + 1 }}</div>
                    <div v-if="delPalTrigger == index && calculator_last.cal.length > 1" class="p-0 bg-danger text-light"
                      style="border-radius:0.25rem;height:47px;width:100%;line-height:47px;font-size:1.8em;text-align:center;font-weight:bold;"
                      @click="delPal(index, true)" v-click-outside="resetDelPal">ลบ?</div>
                    <div v-if="delPalTrigger != index || calculator_last.cal.length == 1" class="p-0"
                      style="border-radius:0.25rem;height:47px;width:100%;line-height:47px;font-size:1.8em;text-align:center;font-weight:bold;"
                      @click="delPalTrigger = index">
                      {{ calculator_last.cal[index].leg * calculator_last.cal[index].floor * calculator_last.cal[index].pal }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 pl-1 pr-1 pt-0 pb-0">
            <div class="pl-3 pr-3 pt-0" v-click-outside="resetDelSmallPal">
              <div class="row pl-2 pr-2 pb-1 pt-1 bg-light mb-1" style="border-radius:0.25rem;border:1px solid #ddd;">
                <div v-for="(cal, index) in calculator_last.cal_.length" :key="'ls'+index" class="col-3 text-center d-flex flex-column p-1">
                  <div class="h6 m-0 p-0 font-weight-bold" @click="delSmallPalTrigger = index">กองที่ {{ index + 1 }}</div>
                  <div v-if="delSmallPalTrigger == index && calculator_last.cal_.length > 1" class="bg-danger text-light d-flex flex-column align-item-center justify-content-center"
                    style="border-radius:0.25rem;height:47px;width:100%;font-size:1.8em;text-align:center;font-weight:bold;"
                    @click="delSmallPal(index, true)">ลบ?</div>
                  <b-form-input v-if="delSmallPalTrigger != index || calculator_last.cal_.length == 1" v-model="calculator_last.cal_[index].big"
                    type="number" pattern="[0-9]*" inputmode="numeric"
                    style="height:47px;width:100%;padding:0;font-size:1.8em;text-align:center;font-weight:bold;" @focus="$event.target.select()"/>
                </div>
                <div class="col-3 text-center d-flex flex-column p-1">
                  <div class="h6 m-0 p-0 font-weight-bold text-warning">หน่วยย่อย</div>
                  <b-form-input v-model="calculator_last.cal_[0].small" class="text-warning" type="number" pattern="[0-9]*" inputmode="numeric"
                    style="height:47px;width:100%;padding:0;font-size:1.8em;text-align:center;font-weight:bold;" @focus="$event.target.select()"/>
                </div>
              </div>
            </div>
          </div>
          <!-- Calculator Last Result -->
          <div class="col-12 p-2 noselect">
            <div class="p-2 d-flex align-items-center justify-content-center">
              <div class="row w-100">
                <div class="col-6 p-0 pr-1 pl-3 text-center">
                  <div class="bg-light p-0 pt-1 d-flex flex-column" style="border-radius:0.25rem;">
                    <div>หน่วยใหญ่ ({{ currentStock.PQUCOD }})</div>
                    <div class="w-100 pb-3 text-center align-self-center font-weight-bold text-danger">
                      <span class="big-unit-text">
                        {{ calculator_last.cal.reduce((r, i) => r + parseInt(i.leg * i.floor * i.pal), 0) + calculator_last.cal_.reduce((r, i) => r + parseInt(i.big), 0) + parseInt(_calPlus(modalResource).BIG) }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-6 p-0 pr-3 pl-1 text-center">
                  <div class="p-0 pt-1 d-flex flex-column bg-light" style="border-radius:0.25rem;">
                    <div>หน่วยย่อย ({{ currentStock.QUCOD }})</div>
                    <div class="w-100 pb-3 text-center align-self-center font-weight-bold" style="color:#FFBF00">
                      <span class="big-unit-text">{{ parseInt(calculator_last.cal_[0].small) + _calPlus(modalResource).SMALL }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template #modal-footer>
          <div class="row w-100 mt-1">
            <div class="col-6 pl-2 pr-2 pb-0">
              <b-button block variant="light" @click="calReset(true)">
                <div style="font-size:1.4em;font-weight:bold;">
                  <b-icon icon="trash" style="position:relative;margin:0;padding:0;top:-4px !important;padding-right:5px;"/> ล้างค่า
                </div>
              </b-button>
            </div>
            <div class="col-6 pl-2 pr-2 pb-0">
              <b-button block variant="success" @click.prevent="save_count_stock_last(modalResource);">
                <div style="font-size:1.4em;font-weight:bold;">
                  <b-icon icon="check-circle" style="position:relative;margin:0;padding:0;top:-4px !important;padding-right:5px;"/> ยืนยัน
                </div>
              </b-button>
            </div>
            <div class="col-12 p-2">
              <b-button block variant="warning" @click.prevent="calReset();closeModal('modal_multi_last');">
                <span style="font-size:1.4em;font-weight:bold;">ปิด</span>
              </b-button>
            </div>
          </div>
        </template>
      </b-modal>

      <!-- ===== Modal Sell Details ===== -->
      <b-modal id="modal_sell_detail" ref="modal_sell_detail" modal-class="peter-modal"
        body-class="pt-0 pb-0" header-class="p-0 m-0 pl-1 pr-1"
        footer-class="p-0 m-0 pl-3 pr-3" no-close-on-backdrop centered no-fade>
        <template #modal-header>
          <div class="w-100 text-center h5 font-weight-bold mb-0">สินค้าออกจากคลังวันนี้ ({{ currentStock.PQUCOD }})</div>
        </template>
        <template #default>
          <div class="row">
            <div class="col-12 pt-0 text-left">
              <div class="w-100 text-truncate" style="padding-left:1px;">
                <b-badge variant="info" class="pl-1 pr-1 pt-1 pb-1 mr-2">
                  <span style="font-size:1.2em;">{{ currentStock.STKCOD }}</span>
                </b-badge>
                <span class="font-weight-bold" style="font-size:1.1em;">{{ currentStock.STKDES }}</span>
              </div>
              <div class="w-100 text-truncate mt-2"><span class="font-weight-bold">รายชื่อลูกค้าตาม SO</span></div>
              <div class="row pl-2 pr-3 mt-0">
                <div v-for="(so, si) in currentStock.SOCUS" :key="si" class="col-12 pl-3 pr-3 px-0 d-flex justify-content-between">
                  <span class="text-truncate">
                    <div class="history-num">{{ si + 1 }}</div> {{ so.NAME }}
                  </span>
                  <span class="text-right" style="width:70px;">{{ atomDisplay(so.ATOM_QTY, currentStock.CFACTOR) }} {{ currentStock.PQUCOD }}</span>
                </div>
              </div>
              <div class="w-100 text-truncate mt-2"><span class="font-weight-bold" style="font-size:1.1em;">สรุปจำนวน</span></div>
              <div class="row pl-0 pr-0 mt-1">
                <div class="col-12 pl-3 pr-3 px-0 d-flex justify-content-between" v-for="(item, idx) in sellSummaryItems" :key="idx">
                  <div :style="item.bold ? 'padding-top:1px;font-size:1.1em;' : 'padding-top:1px;'">
                    <strong v-if="item.bold">{{ item.label }}</strong>
                    <template v-else>{{ item.label }}</template>
                  </div>
                  <div>
                    <b-badge :variant="item.value ? 'warning' : item.bold ? 'success' : 'light'" class="mr-1 text-dark" style="width:60px;padding:3px;">
                      <span style="font-size:1.5em;">{{ item.display }}</span>
                    </b-badge>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template #modal-footer>
          <div class="row w-100">
            <div class="col-6 p-2">&nbsp;</div>
            <div class="col-6 p-2">
              <b-button block variant="warning" @click.prevent="closeModal('modal_sell_detail');imageDisplay=false;">
                <span class="font-weight-bold" style="font-size:1.4em;">ปิด</span>
              </b-button>
            </div>
          </div>
        </template>
      </b-modal>

      <!-- ==================== MAIN CONTENT ==================== -->
      <div class="row">
        <div v-if="reportNum!=null" class="print-fab" @click="generateReport(reportNum)">
          <b-icon icon="file-earmark-text-fill"/>
        </div>

        <div class="col-12">
          <!-- ===== MAIN MENU TABS ===== -->
          <div class="col-12 p-1 pb-0 mt-2 text-center pl-2 pr-2">
            <div class="row pl-2 pr-2">
              <div class="col-3 p-1">
                <h6 class="w-100 btn main_button mb-0" :class="{'active': tab_state == 0}" style="font-size:1.1em;"
                  @click="tab_state=0;imageState=false;weekdayState=false;reportNum=1;compactView=false;applyFilters({hideFilter:0});customClick([1],['asc']);refreshEntries(100);">
                  ทั้งหมด
                  <span v-if="allProduct_count>=1" class="position-absolute start-50 translate-middle badge rounded-pill bg-secondary text-light" style="right:0;top:-5px;">{{ allProduct_count }}</span>
                </h6>
              </div>
              <div class="col-3 p-1">
                <h6 class="w-100 btn main_button mb-0 pl-0 pr-0" :class="{'active': tab_state == 3}" style="font-size:1.1em;"
                  @click.prevent="compactView=(tab_state!=3)?false:!compactView;tab_state=3;imageState=false;weekdayState=false;reportNum=null;productTab=0;groupType=false;applyFilters({hideFilter:0,percentFilter:1,notiFilter:1});customClick([12],['asc']);refreshEntries(200);">
                  ใกล้หมด
                  <span class="position-absolute start-50 translate-middle badge rounded-pill bg-danger text-light" style="right:0;top:-5px;">{{ lessStock_count }}</span>
                </h6>
              </div>
              <div class="col-3 p-1">
                <h6 class="w-100 btn main_button mb-0" :class="{'active': tab_state == 7}" style="font-size:1.1em;"
                  @click="tab_state=7;imageState=false;weekdayState=false;reportNum=null;productTab=0;groupType=false;applyFilters({soCountFilter:true});customClick([17],['desc']);refreshEntries(100);">
                  จัดวันนี้
                </h6>
              </div>
              <div class="col-3 p-1">
                <h6 class="w-100 btn main_button mb-0" :class="{'active': tab_state == 2}" style="font-size:1.1em;"
                  @click.prevent="compactView=(tab_state!=2)?false:!compactView;tab_state=2;imageState=false;weekdayState=false;reportNum=null;productTab=0;groupType=false;refreshEntries(200);applyFilters({hideFilter:0,countFilter:today});customClick([15]);">
                  นับวันนี้
                  <span v-if="countFilter_count>=1" class="position-absolute start-100 translate-middle badge rounded-pill bg-warning text-light" style="right:0;top:-5px;">{{ countFilter_count }}</span>
                </h6>
              </div>
              <div class="col-4 p-1">
                <h6 class="w-100 btn main_button mb-0" :class="{'active': tab_state == 8}" style="font-size:1.1em;"
                  @click="tab_state=8;imageState=false;weekdayState=false;reportNum=null;productTab=0;groupType=false;applyFilters({todayMustCountByReportFilter:1});customClick([18],['desc']);refreshEntries(100);">
                  นับรายงาน
                  <span v-if="todayMustCountByReport_count>=1" class="position-absolute start-100 translate-middle badge rounded-pill bg-warning text-light" style="right:0;top:-5px;">{{ todayMustCountByReport_count }}</span>
                </h6>
              </div>
              <div class="col-4 p-1">
                <h6 class="w-100 btn main_button mb-0" :class="{'active': tab_state == 9}" style="font-size:1.1em;"
                  @click="tab_state=9;imageState=false;weekdayState=false;reportNum=null;productTab=0;groupType=false;applyFilters({isSellFilter:1});customClick([18],['desc']);refreshEntries(100);">
                  ติดตาม
                  <span v-if="isSell_count>=1" class="position-absolute start-100 translate-middle badge rounded-pill bg-warning text-light" style="right:0;top:-5px;">{{ isSell_count }}</span>
                </h6>
              </div>
              <div class="col-4 p-1">
                <h6 class="w-100 btn main_button mb-0" :class="{'active': tab_state == 10}" style="font-size:1.1em;"
                  @click="tab_state=10;imageState=false;weekdayState=false;reportNum=null;productTab=0;groupType=false;applyFilters();loadCustomers();">
                  ลูกค้า
                </h6>
              </div>
            </div>
          </div>

          <!-- ===== CUSTOMER LIST (tab_state == 10) ===== -->
          <div v-if="tab_state == 10" class="px-1">
            <!-- Sub-tabs (same pattern as product ทั้งหมด sub-tabs) -->
            <div class="row pl-3 pr-3 mb-2">
              <div class="col-3 btn p-0 h-100">
                <h6 class="m-0 p-2 position-relative" style="border:1px solid #ddd;border-radius:0.25em;"
                  :class="{'btn-danger font-weight-bold border-danger': customerSubTab == 1}"
                  @click="customerSubTab = (customerSubTab == 1) ? null : 1">
                  ค้างจ่าย
                  <span v-if="overdueCustomer_count >= 1" class="position-absolute start-100 translate-middle badge rounded-pill bg-danger text-light" style="right:0;top:-5px;">{{ overdueCustomer_count }}</span>
                </h6>
              </div>
              <div class="col-3 btn p-0 h-100">
                <h6 class="m-0 p-2 position-relative" style="border:1px solid #ddd;border-radius:0.25em;"
                  :class="{'btn-danger font-weight-bold border-danger': customerSubTab == 2}"
                  @click="customerSubTab = (customerSubTab == 2) ? null : 2">
                  ยังไม่เยี่ยม
                  <span v-if="notVisitedCustomer_count >= 1" class="position-absolute start-100 translate-middle badge rounded-pill bg-danger text-light" style="right:0;top:-5px;">{{ notVisitedCustomer_count }}</span>
                </h6>
              </div>
              <div class="col-3 btn p-0 h-100">
                <h6 class="m-0 p-2" style="border:1px solid #ddd;border-radius:0.25em;"
                  :class="{'btn-danger font-weight-bold border-danger': customerSubTab == 3}"
                  @click="customerSubTab = (customerSubTab == 3) ? null : 3">
                  Tab 3
                </h6>
              </div>
              <div class="col-3 btn p-0 h-100">
                <h6 class="m-0 p-2" style="border:1px solid #ddd;border-radius:0.25em;"
                  :class="{'btn-danger font-weight-bold border-danger': customerSubTab == 4}"
                  @click="customerSubTab = (customerSubTab == 4) ? null : 4">
                  Tab 4
                </h6>
              </div>
            </div>

            <div class="sticky-top bg-white" style="z-index:10;">
              <div class="d-flex align-items-center ">
                <input :value="customerSearch" @input="onCustomerSearchInput"
                       @click="$event.target.select()"
                       type="text" class="form-control"
                       placeholder="ค้นหา ชื่อ / รหัส / เบอร์โทร / ที่อยู่" >
              </div>
            </div>
            <div class="d-flex justify-content-end"><small class="text-muted ml-2">{{ filteredCustomers.length }} ราย</small></div>

            <div v-if="customersLoading" class="text-center p-4 text-muted">กำลังโหลด...</div>

            <div v-else class="row px-2">
              <div v-for="c in pagedCustomers" :key="c.CUSCOD" class="col-md-3 col-sm-6 p-1"> 
                <div class="rounded p-3 h-100" style="cursor:pointer;"
                     :style="{ border: '1px solid ' + customerCardBorderColor(c), backgroundColor: customerCardColor(c) }"
                     @click="openCustomerModal(c)">
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="font-weight-bold text-truncate flex-grow-1 mr-2" :title="c.CUSNAM" style="font-size:1.2em;">{{ c.CUSNAM }}</div>
                    <div class="d-flex align-items-center text-nowrap" style="gap:4px;">
                      <small v-if="c.CUS_GROUP_ID != null"
                             class="px-2 rounded text-dark font-weight-bold"
                             style="background-color:#FFD760; font-size:0.9em; cursor:pointer;"
                             @click.stop="filterByCustomerGroup(c.CUS_GROUP_ID)">กลุ่ม {{ c.CUS_GROUP_ID }}</small>
                      <small v-if="c.CUS_SLMCOD" class="px-1 rounded text-white" style="background-color:#6c757d; font-size:0.9em;">เซล {{ c.CUS_SLMCOD }}</small>
                    </div>
                  </div>
                  <div style="margin-top:-6px;"><small class="text-muted">{{ c.CUSCOD }} {{ extractDistrictProvince(c.CUS_ADDRESS).province }} {{ extractDistrictProvince(c.CUS_ADDRESS).district }}</small></div>
                  <div class="small mt-1" v-if="c.CUS_TELNUM">📞 {{ c.CUS_TELNUM }}</div>
                  <div class="d-flex justify-content-between mt-1 ">
                    <span class="text-muted">ขายเฉลี่ยต่อเดือน</span>
                    <span class="font-weight-bold">{{ numberFormat(c.AVG_SELL_PER_MONTH || 0) }}</span>
                  </div>
                  <div class="d-flex justify-content-between align-items-center">
                    <span class="text-muted">ยอดขายเดือนนี้</span>
                    <div class="d-flex align-items-center" style="gap:8px;">
                      <div v-if="c.AVG_SELL_PER_MONTH > 0"
                           style="width:80px; height:18px; background:rgba(0,0,0,0.18); border-radius:4px; overflow:hidden; position:relative;">
                        <div :style="{ width: Math.min(salesProgressPercent(c), 100) + '%', backgroundColor: salesProgressColor(c), height: '100%', transition: 'width 0.3s ease' }"></div>
                        <div class="position-absolute d-flex align-items-center justify-content-center"
                             style="top:0; left:0; width:100%; height:100%; font-size:0.72em; font-weight:bold; color:#fff; pointer-events:none; line-height:1;">
                          {{ salesProgressPercent(c) }}%
                        </div>
                      </div>
                      <span class="font-weight-bold">{{ numberFormat(c.SALES_THIS_MONTH || 0) }}</span>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between  ">
                    <span class="text-muted">หนี้คงค้าง</span>
                    <span :class="(c.CUS_BALANCE > 0) ? 'text-danger' : 'text-success'">
                      {{ numberFormat(c.CUS_BALANCE || 0) }}
                    </span>
                  </div>
                  <div v-if="c.MAX_OVERDUE_DAYS > 0" class="d-flex justify-content-between ">
                    <span class="text-muted">บิลค้างมากสุด</span>
                    <span class="font-weight-bold text-danger">{{ c.MAX_OVERDUE_DAYS }} วัน</span>
                  </div>

                  <div v-if="c.LAST_PURCHASE_DATE" class="d-flex justify-content-between align-items-center">
                    <span class="text-muted">ซื้อล่าสุด</span>
                    <span class="text-muted">{{ formatDateTH(c.LAST_PURCHASE_DATE) }} ({{ daysAgo(c.LAST_PURCHASE_DATE) }} วันก่อน)</span>
                  </div>

                  <div class="d-flex justify-content-between align-items-center">
                    <span class="text-muted">เซลเข้าเยี่ยมเดือนนี้</span>
                    <span v-html="visitDotsHtml(c.VISITS_THIS_MONTH || 0)"></span>
                  </div>

                  

                   
                </div>
              </div>
              <div v-if="!filteredCustomers.length" class="col-12 text-center p-4 text-muted">
                ไม่พบลูกค้า
              </div>

              <!-- Lazy-load sentinel (infinite scroll) — IntersectionObserver จับ element นี้
                   เมื่อเลื่อนเข้ามาใกล้ → โหลดลูกค้าเพิ่มอีก 1 batch -->
              <div ref="customerLoadMore" class="col-12 text-center p-3" style="min-height:1px;">
                <small v-if="hasMoreCustomers" class="text-muted">
                  <b-spinner small type="grow"></b-spinner> กำลังโหลดเพิ่ม…
                </small>
                <small v-else-if="filteredCustomers.length" class="text-muted">
                  แสดงครบ {{ filteredCustomers.length }} ราย
                </small>
              </div>
            </div>
          </div>

          <!-- ===== DATASET ===== -->
          <dataset
            ref="productDataset"
            v-if="tab_state != 10"
            v-slot="{ ds }"
            :ds-data="stocks"
            :ds-sortby="sortBy"
            :ds-filter-fields="{
              STKDES: filters.refreshFilter, is_watch: filters.is_watchFilter,
              is_bsts: filters.is_bstsFilter, WARNING: filters.percentFilter,
              notify: filters.notiFilter, counted_at: filters.countFilter,
              user: notCountFilterFn, NEVER_SELL: filters.neverSellFilter,
              ORDERED: filters.makeOrderFilter, hide: filters.hideFilter,
              TODAY_COUNT: filters.todaycountFilter, is_po: filters.ispoFilter,
              count_expired: filters.countexpiredFilter, count_day: countdayFilterFn,
              GROUP_COUNT: filters.groupcountFilter, is_so: filters.soCountFilter,
              today_must_counted: filters.todayMustCountByReportFilter, is_sell: filters.isSellFilter
            }"
            :ds-search-in="['STKDES','STKGRP','STKCOD','unique_code','SUPNAM_SUPPLIER','SUPNAM']"
            :ds-sort-as="{ LOCBAL: sortAsLOCBAL, PERCENT: sortAsLOCBAL, LLK: sortAsDate, LSK: sortAsDate, LSS: sortAsDate, LASTEST_PODAT: sortAsDate, count_code: sortStringAsNumber }"
          >
            <!-- Sub-Menu for tab 0 -->
            <div class="col-12">
              <div v-show="tab_state==0" class="row pl-1 pr-1">
                <div class="col-3 btn p-0 h-100">
                  <h6 class="m-0 p-2" style="border:1px solid #ddd;border-radius:0.25em;"
                    :class="{'btn-danger font-weight-bold border-danger': filters.countdayFilter}"
                    @click="compactView=true;tab_state=0;subMenuSeq=0;imageState=false;weekdayState=true;reportNum=null;groupType='count_code';refreshEntries(200);applyFilters({hideFilter:0,countdayFilter:new Date().getDay()});customClick([15]);">
                    ต้องนับ
                    <span v-if="mushCount_count>=1" class="position-absolute start-50 translate-middle badge rounded-pill bg-danger text-light" style="right:0;top:-5px;">{{ mushCount_count }}</span>
                  </h6>
                </div>
                <div class="col-3 btn p-0 h-100">
                  <h6 class="m-0 p-2" style="border:1px solid #ddd;border-radius:0.25em;"
                    :class="{'btn-danger font-weight-bold border-danger': filters.is_bstsFilter}"
                    @click="compactView=(subMenuSeq!=1)?true:!compactView;tab_state=0;subMenuSeq=1;imageState=false;weekdayState=false;reportNum=2;groupType='count_code';refreshEntries(200);applyFilters({hideFilter:0,is_bstsFilter:1});customClick([15],['asc']);">
                    รับเอง
                  </h6>
                </div>
                <div class="col-3 btn p-0 h-100">
                  <h6 class="m-0 p-2" style="border:1px solid #ddd;border-radius:0.25em;"
                    :class="{'btn-danger font-weight-bold border-danger': filters.is_watchFilter}"
                    @click="compactView=(subMenuSeq!=2)?true:!compactView;tab_state=0;subMenuSeq=2;imageState=false;weekdayState=false;reportNum=null;groupType='count_code';refreshEntries(100);applyFilters({hideFilter:0,is_watchFilter:1});customClick([10],['asc']);">
                    สินค้าซ้อ
                  </h6>
                </div>
                <div class="col-3 btn p-0 h-100">
                  <h6 class="m-0 p-2" style="border:1px solid #ddd;border-radius:0.25em;"
                    :class="{'btn-danger font-weight-bold border-danger': filters.notCountFilter==null}"
                    @click="compactView=(subMenuSeq!=3)?true:!compactView;tab_state=0;subMenuSeq=3;imageState=false;weekdayState=false;reportNum=null;groupType='count_code';refreshEntries(100);applyFilters({hideFilter:'',notCountFilter:null});customClick([11],['desc']);">
                    ยังไม่นับ
                    <span v-if="notCountTab_count>=1" class="position-absolute start-50 translate-middle badge rounded-pill bg-danger text-light" style="right:0;top:-5px;">{{ notCountTab_count }}</span>
                  </h6>
                </div>
              </div>
            </div>

            <!-- Sub-Menu Weekday -->
            <div class="col-12 mt-0">
              <div v-show="weekdayState" class="row pl-1 pr-1 mb-2">
                <div v-for="d in [1,2,3,4,5,6]" :key="'wd'+d" class="col-2 btn p-0 h-100">
                  <h6 class="m-0 p-2" style="border:1px solid #eee;border-radius:0.25em;"
                    :class="{'btn-danger font-weight-bold border-danger': filters.countdayFilter==d, 'btn-warning font-weight-bold border-warning': new Date().getDay()==d}"
                    @click.prevent="compactView=(filters.countdayFilter!=d)?true:!compactView;tab_state=0;imageState=false;weekdayState=true;reportNum=null;productTab=0;groupType='count_code';refreshEntries(200);applyFilters({hideFilter:0,countdayFilter:d});customClick([15]);">
                    {{ weekDays[d] }}
                    <span v-if="filters.countdayFilter==d" style="right:0;top:-5px;"
                      class="position-absolute start-50 translate-middle badge rounded-pill text-light bg-gray font-weight-bold">{{ ds.dsRows.length }}</span>
                  </h6>
                </div>
              </div>
            </div>

            <!-- Search Bar -->
            <div class="col-12 pl-2 pr-2 pt-1 sticky-top">
              <div class="row pl-1 pr-1 mb-1">
                <div class="col-10 pl-2 pr-0">
                  <template v-if="searchSwitchMode">
                    <dataset-search ds-search-placeholder="รหัสบาโค๊ด..." :wait="500" ref="search_input"
                      class="search-input" style="border-radius:0;height:50px;font-size:1.3em;border:1px solid #ddd;"
                      type="number" pattern="[0-9]*" inputmode="numeric"/>
                  </template>
                  <template v-else>
                    <dataset-search ds-search-placeholder="ชื่อสินค้า..." :wait="500" ref="search_input"
                      class="search-input" style="border-radius:0;height:50px;font-size:1.3em;border:1px solid #ddd;"/>
                  </template>
                </div>
                <div class="col-2 pl-0 pr-2 text-center">
                  <div class="h-100 w-100 bg-primary text-center text-light d-flex flex-column align-item-center justify-content-center">
                    <div class="w-100">
                      <b-icon v-if="searchSwitchMode" class="h4 m-0" icon="textarea-t" @click.prevent="searchSwitchMode=false"/>
                      <b-icon v-else class="h4 m-0" icon="file-spreadsheet" @click.prevent="searchSwitchMode=true"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Search Result -->
            <div class="col-12 mt-1 text-right pl-1 pr-1" style="font-style:italic">
              ผลการค้นหา {{ ds.dsResultsNumber }} รายการ
              <span v-if="ds.dsPagecount > 1">: หน้า {{ ds.dsPage }}/{{ ds.dsPagecount }}</span>
            </div>

            <!-- Card Display -->
            <div class="col-12 p-0">
              <!-- Normal View -->
              <template v-if="!compactView">
                <dataset-item class="form-row mb-3">
                  <template #default="{ row, rowIndex }">
                    <!-- Today Delivery View (tab 7) -->
                    <div v-if="tab_state == 7" class="col-md-3 pl-2 pr-2 pb-2"
                      @click="openModal('modal_count_1', rowIndex)">
                      <div class="card" :class="isToday(row.counted_at) ? row.BACKGROUND_CLASS : row.BACKGROUND_CLASS + ' grayscale'"
                        :style="isToday(row.counted_at) && isToday(row.counted_at_last) && 'background:green !important;position:relative;'">
                        <div v-show="isToday(row.counted_at) && isToday(row.counted_at_last)"
                          class="last_count_result text-light text-center font-weight-bold pl-2 pr-2"
                          style="font-size:1.2em;position:absolute;top:5px;right:5px;border-radius:2rem;min-width:30px;height:30px;line-height:31px;z-index:999;"
                          :class="{'bg-success': (row.COUNT_ATOM_LAST-(row.COUNT_ATOM-row.ATOM_ORDQTY)==0), 'bg-danger': (row.COUNT_ATOM_LAST-(row.COUNT_ATOM-row.ATOM_ORDQTY)<0), 'bg-warning': (row.COUNT_ATOM_LAST-(row.COUNT_ATOM-row.ATOM_ORDQTY)>0)}">
                          {{ getCountLastRemark(row) == '✔' ? 'ตรง' : getValueFromAtom(row.COUNT_ATOM_LAST-(row.COUNT_ATOM-row.ATOM_ORDQTY), row.CFACTOR).CONCAT }}
                        </div>
                        <div class="card-body pt-2 pb-2 px-3">
                          <div class="row">
                            <div class="col-12 pb-2 mb-3 pl-2 pr-2">
                              <h5 class="pl-0 card-title text-truncate mb-0 font-weight-bold pt-0" style="color:#2B2301">{{ row.STKDES }}</h5>
                              <h6 class="text-truncate pb-0 mb-0" style="color:#888;font-size:0.9em;">มูลค่า {{ numberFormat(row.TOTAL_SO_TRNVAL) }} บาท</h6>
                            </div>
                            <div class="col-3 pl-1 pr-0">
                              <div class="p-0 d-flex flex-column" style="height:30px;border-radius:0.25rem;"
                                :class="{'bg-danger': !isToday(row.counted_at_last)||(row.COUNT_ATOM_LAST-(row.COUNT_ATOM-row.ATOM_ORDQTY)!=0), 'bg-success': (row.COUNT_ATOM_LAST-(row.COUNT_ATOM-row.ATOM_ORDQTY)==0)}">
                                <div class="w-100 text-center align-self-center font-weight-bold" :class="{'text-light': row.counted_at!=null, 'text-secondary': row.counted_at===null}" style="position:relative">
                                  <div class="text-center w-100" style="font-size:0.9em;position:absolute;margin:auto;top:-19px;">นับเช้า</div>
                                  <span style="font-size:1.3em;line-height:30px;">
                                    <template v-if="isToday(row.counted_at)"><span class="font-weight-bold" style="color:yellow !important;">{{ atomDisplay(row.COUNT_ATOM, row.CFACTOR) }}</span></template>
                                    <template v-else><span style="color:white!important;">-</span></template>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-3 pl-1 pr-0">
                              <div class="bg-success p-0 d-flex flex-column" style="height:30px;border-radius:0.25rem;" @click.stop="openModal('modal_sell_detail', rowIndex)">
                                <div class="w-100 text-center align-self-center font-weight-bold" :class="{'text-light': row.counted_at!=null, 'text-secondary': row.counted_at===null}">
                                  <div class="text-center w-100" style="font-size:0.9em;position:absolute;margin:auto;top:-19px;">ขายวันนี้</div>
                                  <span style="font-size:1.3em;line-height:30px;">{{ atomDisplay(row.TODAY_SELL_ATOM_QTY+(row.ATOM_ORDQTY-row.ATOM_ORDQTY_DONE), row.CFACTOR) }}</span>
                                </div>
                              </div>
                            </div>
                            <div class="col-3 pl-1 pr-0" v-show="isToday(row.counted_at)">
                              <div class="p-0 d-flex flex-column" style="height:30px;border-radius:0.25rem;"
                                :class="{'bg-info': !isToday(row.counted_at_last)||(row.COUNT_ATOM_LAST-(row.COUNT_ATOM-row.ATOM_ORDQTY)!=0), 'bg-success': (row.COUNT_ATOM_LAST-(row.COUNT_ATOM-row.ATOM_ORDQTY)==0)}">
                                <div class="w-100 text-center align-self-center font-weight-bold text-light">
                                  <div class="text-center w-100" style="font-size:0.9em;position:absolute;margin:auto;top:-19px;">ต้องเหลือ</div>
                                  <span style="font-size:1.3em;line-height:30px;">
                                    <template v-if="isToday(row.counted_at)">{{ atomDisplay((row.COUNT_ATOM-row.ATOM_ORDQTY)-row.TODAY_SOR_QTY, row.CFACTOR) }}</template>
                                    <template v-else>-</template>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-3 pl-1 pr-1" v-show="isToday(row.counted_at)">
                              <div class="p-0 d-flex flex-column" style="height:30px;border-radius:0.25rem;"
                                @click.stop="isToday(row.counted_at) && openModalCalLast(rowIndex)"
                                :class="{'bg-warning': !isToday(row.counted_at_last)||(row.COUNT_ATOM_LAST-(row.COUNT_ATOM-row.ATOM_ORDQTY)!=0), 'bg-success': (row.COUNT_ATOM_LAST-(row.COUNT_ATOM-row.ATOM_ORDQTY)==0)}">
                                <div class="w-100 text-center align-self-center font-weight-bold text-dark">
                                  <div class="text-center w-100" style="font-size:0.9em;position:absolute;margin:auto;top:-19px;">นับเย็น</div>
                                  <template v-if="isToday(row.counted_at_last)">
                                    <span class="font-weight-bold" style="font-size:1.3em;line-height:30px;">{{ atomDisplay(row.COUNT_ATOM_LAST, row.CFACTOR) }}</span>
                                  </template>
                                  <template v-else>-</template>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Tab 8 - StockCard -->
                    <div v-else-if="tab_state == 8" class="col-md-3 pl-2 pr-2 pb-2">
                      <StockCard :row="row" :rowIndex="rowIndex" :imageState="imageState" :tab_state="tab_state"
                        :stocks="stocks" :dayText="dayText" :today="today" :save="save" :openModal="openModal"
                        :getValueFromAtom="getValueFromAtom" :addNote="addNote" :delNote="delNote" :openStockImage="openStockImage"/>
                    </div>
                    <!-- Tab 9 - RecapStockCard -->
                    <div v-else-if="tab_state == 9" class="col-md-3 pl-2 pr-2 pb-2">
                      <RecapStockCard :row="row" :rowIndex="rowIndex" :imageState="imageState" :stocks="stocks"
                        :dayText="dayText" :today="today" :save="save" :openModal="openModal"
                        :getValueFromAtom="getValueFromAtom" :addImage="addImage" :numberFormat="numberFormat"/>
                    </div>
                    <!-- Tab 2 - Today Count -->
                    <div v-else-if="tab_state == 2" class="col-12 pl-2 pr-2" @click="openModal('modal_count_1', rowIndex)" style="margin-bottom:2px;">
                      <div class="pr-1 pl-2 pt-1 pb-1 d-flex justify-content-between" style="border:1px solid;border-radius:0.25em;"
                        :class="[row.BACKGROUND_CLASS, {'fadex2': row.GROUP_COUNT && !row.TODAY_COUNT && tab_state==2}]">
                        <div class="flex-fill text-truncate">
                          <b-icon v-show="isToday(row.counted_at)" icon="check-circle-fill" style="color:green;margin-right:3px;"/>
                          <span style="font-size:1.1em;" :class="{'font-weight-bold': rowIndex == modalResource}">{{ row.STKDES }}</span>
                        </div>
                        <div class="d-flex align-item-end justify-content-end" style="width:130px;">
                          <div class="text-center font-weight-bold mr-1" style="width:60px;border-radius:0.25em;font-size:1.1em;"
                            :class="{'bg-warning text-dark': (row.COUNT_ATOM-row.peter_ATOM)>0, 'bg-success text-light': (row.COUNT_ATOM-row.peter_ATOM)==0, 'bg-danger text-light': (row.COUNT_ATOM-row.peter_ATOM)<0}">
                            {{ (row.COUNT_ATOM-row.peter_ATOM) > 0 ? 'เกิน' : (row.COUNT_ATOM-row.peter_ATOM) == 0 ? 'ตรง' : 'ขาด' }}
                          </div>
                          <div class="bg-light text-center font-weight-bold" style="width:60px;border-radius:0.25em;font-size:1.1em;"
                            :class="{'text-warning': (row.COUNT_ATOM-row.peter_ATOM)>0, 'text-success': (row.COUNT_ATOM-row.peter_ATOM)==0, 'text-danger': (row.COUNT_ATOM-row.peter_ATOM)<0}">
                            {{ getValueFromAtom(row.COUNT_ATOM-row.peter_ATOM, row.CFACTOR).CONCAT }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Default - StockCard -->
                    <div v-else class="col-md-3 pl-2 pr-2 pb-2">
                      <StockCard :row="row" :rowIndex="rowIndex" :imageState="imageState" :tab_state="tab_state"
                        :stocks="stocks" :dayText="dayText" :today="today" :save="save" :openModal="openModal"
                        :getValueFromAtom="getValueFromAtom" :addNote="addNote" :delNote="delNote" :openStockImage="openStockImage"/>
                    </div>
                  </template>
                  <template #noDataFound>
                    <div class="col-md-12 pt-2"><p class="text-center">ไม่มีรายการสินค้า</p></div>
                  </template>
                </dataset-item>
              </template>

              <!-- Compact View -->
              <template v-if="compactView">
                <dataset-item class="form-row mb-3">
                  <template #default="{ row, rowIndex, index }">
                    <div class="col-12 pl-2" @click="openModal('modal_count_1', rowIndex)" style="margin-bottom:2px;">
                      <div class="w-100 pr-2 pl-2 pt-1 pb-1 d-flex justify-content-between align-items-center"
                        style="border:1px solid;border-radius:0.25em;"
                        :class="[row.BACKGROUND_CLASS, {'mb-3': groupType && stocks[ds.dsRows[index+1]] && stocks[ds.dsRows[index+1]][groupType] != stocks[ds.dsRows[index]][groupType], 'fadex2': row.GROUP_COUNT && !row.TODAY_COUNT && tab_state==2}]">
                        <div class="flex-fill text-truncate" style="width:65%;">
                          <b-icon icon="check-circle-fill" style="color:green;margin-right:3px;" v-show="isToday(row.counted_at)"/>
                          <span style="font-size:1.1em;" :class="{'font-weight-bold': rowIndex == modalResource}">{{ row.STKDES }}</span>
                        </div>
                        <div class="text-center font-weight-bold mr-1"
                          style="min-width:45px;font-size:0.85em;padding:1px 4px;border-radius:0.25em;"
                          :class="{'bg-danger text-light': row.PERCENT<=0, 'bg-warning text-dark': row.PERCENT>0 && row.PERCENT<=33, 'bg-success text-light': row.PERCENT>33}">
                          {{ row.PERCENT }}%
                        </div>
                        <div style="width:60px;border-radius:0.25em;font-size:1.1em;"
                          class="bg-danger text-center font-weight-bold" :class="getTextClass(row)">
                          {{ getValueFromAtom(row.ATOM_LOCBAL + row.express_DIFF, row.CFACTOR).BIG }}
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #noDataFound>
                    <div class="col-md-12 pt-2"><p class="text-center">ไม่มีรายการสินค้า</p></div>
                  </template>
                </dataset-item>
              </template>
            </div>

            <!-- Pagination Controls -->
            <div v-show="false" class="row mb-2" :data-page-count="ds.dsPagecount">
              <div class="col-md-6 mb-2 mb-md-0">
                <dataset-show ref="entries_input" :ds-show-entries="entries"
                  :ds-show-entries-lovs="[{value:5,text:5},{value:10,text:10},{value:30,text:30},{value:50,text:50},{value:100,text:100},{value:200,text:200}]"/>
              </div>
            </div>
            <div class="d-flex flex-md-row flex-column justify-content-between align-items-center mb-4 mt-0">
              <dataset-info v-show="false" class="mb-2 mb-md-0"/>
              <dataset-pager/>
            </div>
          </dataset>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Dataset from 'vue-dataset/dist/es/Dataset.js'
import DatasetItem from 'vue-dataset/dist/es/DatasetItem.js'
import DatasetInfo from 'vue-dataset/dist/es/DatasetInfo.js'
import DatasetPager from 'vue-dataset/dist/es/DatasetPager.js'
import DatasetSearch from 'vue-dataset/dist/es/DatasetSearch.js'
import DatasetShow from 'vue-dataset/dist/es/DatasetShow.js'
import StockService from "../StockService"
import VueBarcode from 'vue-barcode'
import vClickOutside from 'v-click-outside'
import domtoimage from 'dom-to-image'
import VueHtml2pdf from 'vue-html2pdf'
// StockCard/RecapStockCard เล็กมาก (~8KB) และ StockCard ใช้ตั้งแต่ tab ทั้งหมด (default) เลย
// → import ตรงๆ รวมเข้า main chunk แทน lazy chunk แยก (กัน chunk โหลดพลาด 503 ตอน deploy)
import StockCard from './StockCard.vue'
import RecapStockCard from './RecapStockCard.vue'

// ==================== CONSTANTS ====================
const EMPTY_CALCULATOR = () => ({
  cal: [{ leg: 0, floor: 0, pal: 0 }],
  cal_: [{ big: 0, small: 0 }],
  CHECK_STAT: 0
})

const WEEK_DAYS = { 1: 'จ', 2: 'อ', 3: 'พ', 4: 'พฤ', 5: 'ศ', 6: 'ส' }

const DAY_TEXT = { 1: 'จ', 2: 'อ', 3: 'พ', 4: 'พฤ', 5: 'ศ', 6: 'ส' }

const ORDER_FREQ_OPTIONS = [
  { item: 7, name: 'สั่งทุกสัปดาห์' },
  { item: 30, name: 'สั่งทุกเดือน' }
]

const CONFIG_CHECKBOXES_TYPE1 = [
  { id: 'notify', field: 'notify', icon: 'bell-fill', label: 'เตือนใกล้หมด' },
  { id: 'is_bsts', field: 'is_bsts', icon: 'house-door-fill', label: 'สินค้าไปรับเอง' },
  { id: 'is_watch', field: 'is_watch', icon: 'lightning-fill', label: 'สินค้าซ้อ' },
  { id: 'is_sell', field: 'is_sell', icon: 'award-fill', label: 'ติดตามการขาย' },
  { id: 'is_get_from_sor', field: 'is_get_from_sor', icon: 'cart-plus-fill', label: 'เบิกหน้าร้าน' },
  { id: 'hide', field: 'hide', icon: 'dash-circle-fill', label: 'ซ่อนสินค้า' }
]

const CONFIG_CHECKBOXES_TYPE2 = [
  { id: 'notify', field: 'notify', icon: 'bell-fill', label: 'เตือนใกล้หมด' },
  { id: 'is_bsts', field: 'is_bsts', icon: 'house-door-fill', label: 'สินค้าไปรับเอง' },
  { id: 'is_watch', field: 'is_watch', icon: 'lightning-fill', label: 'สินค้าซ้อ' },
  { id: 'hide', field: 'hide', icon: 'dash-circle-fill', label: 'ซ่อนสินค้า' }
]

const EMPTY_STOCK = {
  STKCOD: '', STKDES: '', SUPNAM_SUPPLIER: '', CFACTOR: 1, PQUCOD: '', QUCOD: '',
  ATOM_LOCBAL: 0, express_DIFF: 0, PERCENT: 0, PERCENT_CLASS: '', BACKGROUND_CLASS: '',
  counted_at: null, counted_at_last: null, STAT: null, COUNT_STAT: null,
  history: [], stocksHistoryTrigger: true, barcode: null, unique_code: null,
  COUNT_ATOM: 0, COUNT_ATOM_LAST: 0, AVG_SELL: 0, LOCVAL: 0, SELLPR1: 0,
  _UNITPR: 0, LPDISC: null, LPURPR: 0, TRNQTY_OUT: 0, LSK: null, LLK: null,
  LAST_BUY_IN_ATOM: 0, order_frequency: 30, CUSTYPES: [], CUSTOMERS: [],
  TOTAL_ATOM: 0, count_code: null, count_day: null, notify: 0, is_bsts: 0,
  is_watch: 0, is_sell: 0, is_get_from_sor: 0, hide: 0, weight: null,
  leg: 0, object_log: null, is_overrided: false, ATOM_ORDQTY: 0, SOCOUNT: 0,
  SOCUS: [], make_order: null, ordered_at: null, is_po: 0, WARNING: 0,
  weight_1: null, weight_2: null, weight_3: null, BIG_LOCBAL: 0, SMALL_LOCBAL: 0,
  TODAY_SELL_ATOM_QTY: 0, ATOM_ORDQTY_DONE: 0, TODAY_SOR_QTY: 0, COUNT_BIG_LOCBAL: 0,
  COUNT_SMALL_LOCBAL: 0, peter_DIFF: 0, peter_ATOM: null, TOTAL_SO_TRNVAL: 0,
  TODAY_CASH_SELL: 0, is_so: false, makeOrderTrigger: false, noted: null,
  is_noted: null, image_data: null, today_must_counted: 0, LSELLPR: 0,
  STKGRP: '', SUPNAM: '', SELL_PER_DAY_BIG: 0,
  AVG_SEL_PER_DAY_ATOM: 0, LAST_BUY_PRICE: 0, LLK_DOC: null, ADJUST: [],
  is_today_adjust: false, PONUM: [], PO_ORDQTY: 0, NEVER_SELL: 0,
  ORDERED: null, TODAY_COUNT: null, count_expired: null, GROUP_COUNT: null,
  SEL_PER_MONTHX: null, LOCBAL: 0, LSS: null, TRNQTY_IN: 0, TRNQTY_SSS: 0,
  LASTEST_PODAT: null, TOTAL_SO_PRICE: 0, FIRST_TIME_COUNT: false
}

export default {
  name: 'PeterStockManagement',

  // ==================== DIRECTIVES ====================
  directives: { clickOutside: vClickOutside.directive },

  // ==================== COMPONENTS ====================
  components: {
    Dataset, DatasetItem, DatasetInfo, DatasetPager, DatasetSearch, DatasetShow,
    VueBarcode, VueHtml2pdf,
    StockCard, RecapStockCard
  },

  // ==================== SOCKETS ====================
  sockets: {
    async connect() {
      this.onLine = true
      console.log('Socket connected')
    },
    disconnect() {
      console.log('Socket disconnect')
    }
  },

  // ==================== DATA ====================
  data() {
    return {
      // Auth
      showPasswordModal: false,
      passwordInput: '',
      wrongPassword: false,
      correctPassword: 'dontknoww',

      // UI State
      maxPerPage: 5,
      currentPage: 1,
      soCusDetail: false,
      suggestGroup: null,
      sameGroup: null,
      groupFilter: null,
      groupField: null,
      groupType: 'count_code',
      dayText: DAY_TEXT,
      weekDays: WEEK_DAYS,
      today: new Date().toJSON().slice(0, 10),
      tableView: false,
      compactView: false,
      subMenu_today_delivery_details: false,
      genPDF: false,
      reportNum: 1,
      imageDisplay: false,
      entries: 100,
      weekdayState: false,
      imageState: false,
      readyState: false,
      makeOrderTrigger: false,
      orderTrigger: false,
      productTab: 0,
      fileName: "กรุณารอซักครู่...",
      onLine: false,
      loadingClass: 0,
      mainLoading: true,
      searchSwitchMode: false,

      // Modal State
      modalResource: null,
      activeStockModalId: 'modal_count_1', // Tracks which modal variant is active
      countScan: 0,
      addBarcodeTrigger: false,
      barcodeStateTrigger: null,
      uniqueCodeStateTrigger: null,
      currentBarcode: null,
      barCode_key: null,
      delCountTrigger: false,
      delPalTrigger: null,
      legEditTrigger: false,
      delSmallPalTrigger: null,

      // Calculator
      calculator: EMPTY_CALCULATOR(),
      calculator_last: EMPTY_CALCULATOR(),

      // Makro
      makroProducts: [],
      makroLoading: false,
      makroSearched: false,
      makroError: false,

      // Filters
      subMenuSeq: null,
      filters: {
        hideFilter: 0, countexpiredFilter: '', countdayFilter: '',
        ispoFilter: '', todaycountFilter: '', makeOrderFilter: '',
        neverSellFilter: '', refreshFilter: '', is_watchFilter: '',
        is_bstsFilter: '', percentFilter: '', notiFilter: '',
        countFilter: '', notCountFilter: '', groupcountFilter: '',
        soCountFilter: '', todayMustCountByReportFilter: '', isSellFilter: ''
      },

      // Config
      order_frequency_options: ORDER_FREQ_OPTIONS,
      count_stock_tricker: false,
      tab_state: 0,
      tab_tricker: 2,
      tricker_sss: false,

      // Data
      stocks: [],
      customers: [],
      customersLoading: false,
      customerSearch: '',
      customerSubTab: null,    // null = ไม่มี filter, 1=ค้างจ่าย, 2=ยังไม่เยี่ยม, 3/4=reserved
      customerVisibleCount: 24,  // จำนวนลูกค้าที่แสดงตอนนี้ (lazy load / infinite scroll)
      customerBatchSize: 24,     // โหลดเพิ่มทีละกี่ราย เมื่อ scroll ถึงท้าย list
      customerModalResource: null,
      customerTab: 0,
      customerProducts: [],          // สินค้าที่ลูกค้าเคยซื้อ (lazy load ตอนเปิด modal — ไม่มากับ getCustomers แล้ว)
      customerProductsLoading: false,
      showAllCustomerProducts: false,
      suggestions: [],
      suggestionsLoading: false,
      showAllSuggestions: false,
      debts: null,
      debtsLoading: false,
      showAllDebts: false,
      invoice: null,
      invoiceLoading: false,
      invoiceModalDocnum: '',
      customerInfo: null,
      customerInfoLoading: false,
      imageMenuOpen: false,
      imageUploading: false,
      productImage: null,            // data URL รูปสินค้าของ product ใน modal (null = ไม่มีรูป)
      productImageFor: null,         // STKCOD ที่ productImage โหลดมา (กัน fetch ซ้ำ + กันรูปข้ามสินค้า)
      productImageLoading: false,    // กำลังโหลดรูปจาก server
      productImageUploading: false,  // กำลังครอป + อัพโหลด
      productImageMenuOpen: false,   // เมนู ⋯ เปลี่ยน/ลบ เปิดอยู่
      // AI find image (หารูปจากเน็ต)
      aiImages: [],                  // ผลค้นหา [{url, thumbnail, source, width, height}]
      aiImagesLoading: false,        // กำลังค้นหา
      aiSelecting: false,            // กำลัง proxy+crop+save รูปที่เลือก
      aiImagePage: 1,                // หน้า Serper (หาใหม่ = page+1)
      aiImageFor: null,              // STKCOD ที่กำลังหารูป
      aiImageName: '',               // ชื่อสินค้าที่ใช้ค้นหา
      cardImageSrc: '',              // src รูปสินค้าที่เปิดจากการ์ด (lightbox)
      customerImageModalSrc: '',
      // Map modal state
      mapCenter: { lat: 15.2369, lng: 104.8521 },   // default = อุบลฯ
      mapZoom: 8,
      mapCurrentCenter: { lat: 15.2369, lng: 104.8521 },   // อัพเดทแบบ live ตอน user เลื่อนแผนที่
      locatingUser: false,
      savingMap: false,
      // Group select modal state
      groupContext: null,
      groupContextLoading: false,
      // Places search state
      placeSearchQuery: '',
      placeSearchResults: [],
      placeSearchLoading: false,
      error: "",
      toset: "desc",

      // Table columns
      cols: [
        { name: 'หมวด', field: 'STKGRP', sort: '', style: { width: '100px', display: 'none' } },
        { name: 'รหัสสินค้า', field: 'STKCOD', sort: '', style: { width: '120px' } },
        { name: 'ชื่อสินค้า', field: 'STKDES', sort: '' },
        { name: 'ระดับสต็อค', field: 'PERCENT', sort: '', style: { width: '180px' } },
        { name: 'สต็อก', field: 'LOCBAL', sort: '', style: { width: '140px' } },
        { name: 'ของเข้าล่าสุด', field: 'LLK', sort: '', style: { width: '140px' } },
        { name: 'ขายล่าสุด', field: 'LSK', sort: '', style: { width: '140px' } },
        { name: 'ซ้อเบิกล่าสุด', field: 'LSS', sort: '', style: { width: '140px' } },
        { name: 'สั่ง', field: 'ORDERED', sort: '', style: { display: 'none', width: '140px' } },
        { name: 'SUPNAM', field: 'SUPNAM', sort: '', style: { display: 'none', width: '140px' } },
        { name: 'SUPPLIER10', field: 'SUPPLIER', sort: '', style: { display: 'none', width: '140px' } },
        { name: 'ขายต่อวัน', field: 'SELL_PER_DAY_BIG', sort: '', style: { display: 'none', width: '140px' } },
        { name: 'is_po', field: 'is_po', sort: '', style: { display: 'none', width: '140px' } },
        { name: 'WARNING', field: 'WARNING', sort: '', style: { display: 'none', width: '140px' } },
        { name: 'LASTEST_PODAT', field: 'LASTEST_PODAT', sort: '', style: { display: 'none', width: '140px' } },
        { name: 'count_code', field: 'count_code', sort: '', style: { display: 'none', width: '140px' } },
        { name: 'total_so_price', field: 'TOTAL_SO_PRICE', sort: '', style: { display: 'none', width: '140px' } },
        { name: 'total_so_tranval', field: 'TOTAL_SO_TRNVAL', sort: '', style: { display: 'none', width: '140px' } },
        { name: 'today_must_counted', field: 'today_must_counted', sort: '', style: { display: 'none', width: '140px' } },
      ]
    }
  },

  // ==================== WATCH ====================
  watch: {
    // Reset list expansion when switching tabs — users come back to a clean top-10 view
    customerTab() {
      this.showAllCustomerProducts = false
      this.showAllSuggestions = false
      this.showAllDebts = false
    },

    // เมื่อ search / sub-tab เปลี่ยน → reset lazy load กลับไปชุดแรก + scroll ขึ้นบน
    // (กันกรณี user เลื่อนลงลึกแล้ว filter เหลือน้อย จะเห็นรายการว่าง)
    customerSearch() { this.resetCustomerLazyLoad() },
    customerSubTab() { this.resetCustomerLazyLoad() },

    // เข้า/ออก tab ลูกค้า → setup/teardown IntersectionObserver สำหรับ infinite scroll
    tab_state(val) {
      if (val === 10) {
        this.$nextTick(() => this.setupCustomerObserver())
      } else {
        this.teardownCustomerObserver()
      }
    },

    // โหลดลูกค้าเสร็จ (customersLoading: true→false) → sentinel ถูก render แล้ว ค่อย observe
    customersLoading(val) {
      if (!val && this.tab_state === 10) {
        this.$nextTick(() => this.setupCustomerObserver())
      }
    }
  },

  // ==================== COMPUTED ====================
  computed: {
    // Filtered customer list for tab_state == 10
    // เลขกลุ่มที่ว่างน้อยที่สุด (mirror logic ของ product group: หาเลขที่หายไปในลำดับ)
    // ตัวอย่าง: used = [1, 2, 3, 5] → suggest = 4
    //          used = [1, 2, 3]    → suggest = 4
    //          used = []           → suggest = 1
    computedSuggestGroup() {
      if (!this.groupContext) return 1
      const used = this.groupContext.used_groups || []
      if (used.length === 0) return 1
      const max = Math.max(...used) + 1
      const available = Array.from({ length: max }, (_, i) => i + 1).filter(i => !used.includes(i))
      return Math.min(...available)
    },

    filteredCustomers() {
      const q = (this.customerSearch || '').toLowerCase().trim()
      let list = this.customers

      // Special pattern: "g" prefix = filter by group_id
      //   "g"   → ลูกค้าที่มีกลุ่ม (any group)
      //   "g4"  → เฉพาะลูกค้ากลุ่ม 4
      //   "g23" → เฉพาะลูกค้ากลุ่ม 23
      const groupMatch = q.match(/^g(\d+)?$/)
      if (groupMatch) {
        if (groupMatch[1] === undefined) {
          // แค่ "g" → ลูกค้าทุกคนที่มีกลุ่ม
          list = list.filter(c => c.CUS_GROUP_ID != null)
        } else {
          const targetGroup = parseInt(groupMatch[1], 10)
          list = list.filter(c => Number(c.CUS_GROUP_ID) === targetGroup)
        }
      } else if (q) {
        // Normal text search
        list = list.filter(c => (c._search || '').includes(q))
      }

      // Sub-tab filter (apply on top of search)
      //   1 = ค้างจ่าย    (HAS_OVERDUE - มีบิลเลยกำหนดเกิน 30 วัน)
      //   2 = ยังไม่เยี่ยม (ACTIVE + VISITS_THIS_MONTH === 0 - active แต่ยังไม่ได้เยี่ยมเดือนนี้)
      //   3, 4 = reserved (ยังไม่ filter อะไร — รอผู้ใช้ตัดสินใจ)
      if (this.customerSubTab === 1) {
        list = list.filter(c => c.HAS_OVERDUE)
      } else if (this.customerSubTab === 2) {
        list = list.filter(c => c.ACTIVE && !c.VISITS_THIS_MONTH)
      }

      // Sort by LAST_PURCHASE_DATE desc (ลูกค้าที่ซื้อล่าสุดอยู่บน)
      // ลูกค้า inactive (ไม่มีวันที่ซื้อ) ลงไปท้ายสุด
      return [...list].sort((a, b) => {
        const aDate = a.LAST_PURCHASE_DATE || ''
        const bDate = b.LAST_PURCHASE_DATE || ''
        if (aDate === bDate) return 0
        if (!aDate) return 1     // a ไม่มีวัน → a ลงล่าง
        if (!bDate) return -1    // b ไม่มีวัน → b ลงล่าง
        return bDate.localeCompare(aDate)   // ISO date string เปรียบเทียบตรงๆ ได้
      })
    },

    // ลูกค้าที่แสดงตอนนี้ (lazy load — slice จากต้น list ถึง customerVisibleCount)
    // เลื่อนถึงท้าย list → customerVisibleCount เพิ่มทีละ batch ผ่าน IntersectionObserver
    pagedCustomers() {
      return this.filteredCustomers.slice(0, this.customerVisibleCount)
    },

    // ยังมีลูกค้าให้โหลดเพิ่มอีกไหม (ใช้คุม sentinel / ข้อความท้าย list)
    hasMoreCustomers() {
      return this.customerVisibleCount < this.filteredCustomers.length
    },

    // Products shown in customer modal tab1 - paginated to 10 unless "ดูเพิ่มเติม" was clicked
    // Sort order: green (staples) first, then everything else - both groups sorted by total_value desc
    // รายการสินค้าสำหรับใบนำขาย — ทุกตัวที่ลูกค้าเคยซื้อ (green-first, then value desc)
    // เติม sell_price จาก stocks (match ด้วย STKCOD = product.id)
    salesSheetProducts() {
      const list = this.customerProducts
      if (!list || !list.length) return []

      // build price map: STKCOD → SELLPR1 (ทำครั้งเดียว)
      const priceMap = {}
      for (const s of this.stocks) {
        if (s && s.STKCOD) priceMap[s.STKCOD] = s.SELLPR1
      }

      // เรียงตามรหัสสินค้า (p.id = STKCOD) แบบ ascending
      const sorted = [...list].sort((a, b) =>
        String(a.id).localeCompare(String(b.id))
      )

      return sorted.map(p => ({
        code: p.id,
        name: p.name,
        unit: p.unit,
        sell_price: priceMap[p.id] || 0,
        suggest_qty: p.avg_qty || 0   // ค่าเฉลี่ยที่เคยซื้อต่อครั้ง (big units) → ใช้แนะนำการสั่ง
      }))
    },

    // แบ่งสินค้าเป็นหน้าๆ ละ N รายการ เพื่อ render 1 ตาราง/หน้า + page-break ชัดเจน
    // แบ่งสินค้าเป็นหน้าๆ — ทุกหน้ามี header เหมือนกัน เลยใส่จำนวนเท่ากันทุกหน้า
    salesSheetPages() {
      const all = this.salesSheetProducts
      const ROWS_PER_PAGE = 34   // จำนวนแถวต่อหน้า (ทุกหน้าเท่ากัน)
      const pages = []
      for (let i = 0; i < all.length; i += ROWS_PER_PAGE) {
        pages.push(all.slice(i, i + ROWS_PER_PAGE))
      }
      // ถ้าไม่มีสินค้าเลย ให้มีอย่างน้อย 1 หน้าว่าง (กัน v-for ไม่ render)
      if (pages.length === 0) pages.push([])
      return pages
    },

    displayedProducts() {
      const list = this.customerProducts
      if (!list || !list.length) return []
      const sorted = [...list].sort((a, b) => {
        const aGreen = a.status === 'regular' ? 1 : 0
        const bGreen = b.status === 'regular' ? 1 : 0
        if (aGreen !== bGreen) return bGreen - aGreen   // green first
        return (b.total_value || 0) - (a.total_value || 0)  // then by value desc
      })
      return this.showAllCustomerProducts ? sorted : sorted.slice(0, 10)
    },

    // Suggestions shown in แนะนำ tab - paginated to 10 unless "ดูเพิ่มเติม" was clicked
    displayedSuggestions() {
      return this.showAllSuggestions ? this.suggestions : this.suggestions.slice(0, 10)
    },

    // Invoices shown in หนี้ tab - paginated to 5 unless "ดูเพิ่มเติม" was clicked
    displayedDebts() {
      if (!this.debts || !this.debts.invoices) return []
      return this.showAllDebts ? this.debts.invoices : this.debts.invoices.slice(0, 5)
    },

    // Current stock helper - avoids repeated stocks[modalResource]
    currentStock() {
      return this.stocks[this.modalResource] || EMPTY_STOCK
    },

    isModalType2() {
      return this.activeStockModalId === 'modal_count_2'
    },

    configCheckboxes() {
      return this.isModalType2 ? CONFIG_CHECKBOXES_TYPE2 : CONFIG_CHECKBOXES_TYPE1
    },

    // PDF Configs
    pdfConfigReport3() {
      return {
        showLayout: false, floatLayout: true, enableDownload: false,
        previewModal: true, paginateElementsByHeight: 16000,
        filename: 'Report3', pdfQuality: 2, manualPagination: false,
        pdfFormat: 'a4', pdfOrientation: 'portrait', pdfContentWidth: '750px',
        htmlToPdfOptions: {
          filename: 'Report3', margin: [8, 12, 8, 8],
          jsPDF: { format: 'a4', orientation: 'portrait' },
          image: { type: 'jpeg', quality: 1 },
          html2canvas: { scale: 2, useCORS: true }
        }
      }
    },

    // ใบนำขาย — A4 portrait, preview modal (ให้ user กดพิมพ์เองจาก preview)
    pdfConfigSalesSheet() {
      const name = this.customerModalResource
        ? ('ใบนำขาย_' + (this.customerModalResource.CUSCOD || ''))
        : 'ใบนำขาย'
      return {
        showLayout: false, floatLayout: true, enableDownload: false,
        previewModal: true,
        // manualPagination: เราคุม page-break เองด้วย div.html2pdf__page-break ต่อหน้า
        // ไม่ให้ html2canvas ตัดกลางแถว
        paginateElementsByHeight: 1400,
        manualPagination: true,
        filename: name, pdfQuality: 2,
        pdfFormat: 'a4', pdfOrientation: 'portrait', pdfContentWidth: '760px',
        htmlToPdfOptions: {
          filename: name, margin: [0, 0, 0, 0],
          jsPDF: { format: 'a4', orientation: 'portrait' },
          image: { type: 'jpeg', quality: 1 },
          html2canvas: { scale: 2, useCORS: true },
          pagebreak: { mode: ['css', 'legacy'] }
        }
      }
    },

    pdfConfigReport2() {
      return {
        showLayout: false, floatLayout: true, enableDownload: true,
        previewModal: false, paginateElementsByHeight: 1400,
        filename: 'Report2', pdfQuality: 2, manualPagination: false,
        pdfFormat: 'a5', pdfOrientation: 'portrait', pdfContentWidth: '500px',
        htmlToPdfOptions: {
          filename: 'Report2', margin: [8, 8, 8, 8],
          jsPDF: { format: 'a5', orientation: 'portrait' },
          image: { type: 'jpeg', quality: 1 },
          html2canvas: { scale: 2, useCORS: true }
        }
      }
    },

    pdfConfigReport1() {
      return {
        showLayout: false, floatLayout: true, enableDownload: true,
        previewModal: false, paginateElementsByHeight: 1400,
        filename: this.today, pdfQuality: 2, manualPagination: false,
        pdfFormat: 'a5', pdfOrientation: 'portrait', pdfContentWidth: '560px'
      }
    },

    // Report 2 group definitions
    report2Groups() {
      return [
        { code: '230A', title: 'รายการสินค้าประเภทน้ำมัน', pageBreakBefore: false },
        { code: '110A', title: 'รายการสินค้าประเภทแป้ง', pageBreakBefore: true },
        { code: '210B', title: 'เฮลบลูบอย', pageBreakBefore: false },
        { code: '230C', title: 'รายการสินค้าประเภทเส้น', pageBreakBefore: false },
        { code: '220C', title: 'เกลือ', pageBreakBefore: false },
        { code: '220D', title: 'รายการสินค้าประเภทน้ำตาล', pageBreakBefore: true },
        { code: '220B', title: 'รายการสินค้าประเภทซอส', pageBreakBefore: true }
      ]
    },

    // Stock count text class (used in modal)
    stockCountTextClass() {
      const s = this.currentStock
      if (s.counted_at === null) return 'text-secondary'
      if ((s.counted_at && s.counted_at !== this.today) ||
          (s.STAT != null && s.COUNT_STAT != null && s.STAT !== s.COUNT_STAT)) return 'text-light'
      if ((s.counted_at === this.today && s.STAT === s.COUNT_STAT) ||
          (s.STAT == null && s.counted_at === this.today)) return 'text-yellow'
      return ''
    },

    expressDiffVariant() {
      const concat = this.getValueFromAtom(this.currentStock.express_DIFF, this.currentStock.CFACTOR).CONCAT
      if (concat.includes('-')) return 'danger'
      if (concat.includes('+')) return 'warning'
      return 'success'
    },

    // History filtering
    filteredHistory() {
      if (!this.currentStock.history) return []
      if (this.isModalType2) {
        return this.currentStock.history.filter(e => e.counted_at !== this.today)
      }
      return this.currentStock.history.slice().reverse()
        .filter(e => ((e.ship_in_ref == null && e.is_adjust) || e.is_adjust === false) && e.counted_at !== this.today)
    },

    todayHistory() {
      if (!this.currentStock.history) return []
      return this.currentStock.history.filter(e => e.counted_at === this.today)
    },

    historyPageCount() {
      return Math.ceil((this.currentStock.history?.length || 0) / this.maxPerPage)
    },

    lastCountBig() {
      if (!this.currentStock.history) return '-'
      const last = this.get_last_count_stock_history(this.modalResource)
      if (!last || last.COUNT_ATOM == null) return '-'
      return this.getValueFromAtom(last.COUNT_ATOM, this.currentStock.CFACTOR).BIG
    },

    lastCountSmall() {
      if (!this.currentStock.history || !this.currentStock.history.length) return '-'
      const lastH = this.currentStock.history[this.currentStock.history.length - 1]
      const val = this.getValueFromAtom(lastH.COUNT_ATOM, this.currentStock.CFACTOR).SMALL
      return val == null ? '-' : val
    },

    // Summary stats for Report 1
    summaryStats() {
      return [
        { label: 'สินค้าใกล้หมด', value: `${this.stocks_warning_today_counted.length}/${this.stocks_warning.length}` },
        { label: 'สินค้าตามรอบ', value: `${this.stocks_schedule_count}/${this.mushCount_count}` },
        { label: 'สินค้าอื่นๆ', value: this.stocks_today_counted.length - (this.stocks_warning_today_counted.length + this.stocks_schedule_count) },
        { label: 'รวมนับสินค้าวันนี้', value: this.stocks_today_counted.length, bold: true },
        { spacer: true },
        { label: 'สั่งสินค้าใกล้หมด', value: `${this.stocks_warning_today_po.length}/${this.stocks_warning.length}` },
        { label: 'สั่งสินค้าอื่นๆ', value: this.stocks_today_po.length - this.stocks_warning_today_po.length },
        { label: 'รวมเปิด PO วันนี้', value: this.stocks_today_po.length, bold: true },
        { spacer: true },
        { label: 'รับสินค้าเข้าไม่มี PO', value: this.stocks_today_in.length - this.stocks_today_in_isPo.length },
        { label: 'รับสินค้าเข้ามี PO', value: this.stocks_today_in_isPo.length },
        { label: 'รวมรับสินค้าวันนี้', value: this.stocks_today_in.length, bold: true },
        { spacer: true },
        { label: 'สินค้าค้างนับ', value: this.notCountFilter_count, bold: true }
      ]
    },

    poDisplayCount() {
      const diffLen = Math.min(this.stocks_today_counted_peterDiff.length, 20)
      const available = 40 - diffLen
      return Math.min(this.stocks_is_po.length, available)
    },

    hasSorQty() {
      return this.random_stocks.reduce((total, v) => {
        if (v.TODAY_SOR_QTY > 0) return '✔'
        if (v.TODAY_SOR_QTY === 0) return ''
        return total
      }, 0)
    },

    sellSummaryItems() {
      const s = this.currentStock
      const totalSell = s.TODAY_SELL_ATOM_QTY + (s.ATOM_ORDQTY - s.ATOM_ORDQTY_DONE)
      return [
        { label: 'จัดสินค้าตาม SO', value: s.ATOM_ORDQTY, display: this.atomDisplay(s.ATOM_ORDQTY, s.CFACTOR) },
        { label: 'ขายสด', value: s.TODAY_CASH_SELL, display: this.atomDisplay(s.TODAY_CASH_SELL, s.CFACTOR) },
        { label: 'เบิกสินค้าไปหน้าร้าน', value: s.TODAY_SOR_QTY, display: this.atomDisplay(s.TODAY_SOR_QTY, s.CFACTOR) },
        { label: 'รวมสินค้าออกจากคลังวันนี้', value: totalSell, display: this.atomDisplay(totalSell, s.CFACTOR), bold: true }
      ]
    },

    isThreeWeight() {
      const s = this.currentStock
      return [s.weight_1, s.weight_2, s.weight_3].every(w => w != null && w !== '' && w !== 0 && w !== '0')
    },

    avgWeight() {
      const s = this.currentStock
      const weights = [s.weight_1, s.weight_2, s.weight_3]
      if (weights.some(w => w == null || w === '' || w === '0' || w === 0)) return false
      const valid = weights.filter(w => w != null && w !== '' && w !== 0 && w !== '0')
      const total = valid.reduce((sum, w) => sum + parseFloat(w), 0)
      return valid.length ? parseFloat(total / valid.length) : 0.0
    },

    today_sells() {
      return this.stocks.reduce((total, v) => {
        if (v) {
          const qty = v.TODAY_SELL_ATOM_QTY + (v.ATOM_ORDQTY - v.ATOM_ORDQTY_DONE)
          total.atom_qty += qty
          total.volumn += qty * (v.SELLPR1 / v.CFACTOR)
          total.cost += qty * (v.LAST_BUY_PRICE / v.CFACTOR)
        }
        return total
      }, { atom_qty: 0, volumn: 0, cost: 0 })
    },

    random_stocks() {
      return this.stocks
        .filter(e => e.is_so)
        .sort((a, b) => b.TOTAL_SO_TRNVAL - a.TOTAL_SO_TRNVAL)
        .slice(0, 30)
    },

    random_stocks_diff_value() {
      return this.random_stocks.reduce((total, v) => {
        return total + (this.isToday(v.counted_at_last) && this.isToday(v.counted_at))
          ? ((v.COUNT_ATOM_LAST - (v.COUNT_ATOM - v.ATOM_ORDQTY)) * (v.LSELLPR / v.CFACTOR))
          : 0
      }, 0)
    },

    random_stocks_trucks() {
      const trucks = {}
      this.stocks.filter(e => e.is_so).forEach(e => {
        e.SOCUS.forEach(h => {
          if (!trucks[h.DLVBY]) trucks[h.DLVBY] = { cus_name: [h.NAME], total_value: 0 }
          if (!trucks[h.DLVBY].cus_name.includes(h.NAME)) trucks[h.DLVBY].cus_name.push(h.NAME)
          trucks[h.DLVBY].total_value += h.TRNVAL
        })
      })
      return Object.fromEntries(Object.entries(trucks).slice(0, 4))
    },

    groupStocks() {
      return (this.groupField && this.groupFilter)
        ? this.stocks.filter(item => item[this.groupField] == this.groupFilter && item.hide == 0)
        : null
    },

    stocks_warning() {
      return this.stocks
        .filter(i => i.WARNING == 1 && i.is_po == 0 && i.notify == 1 && i.hide == 0)
        .sort((a, b) => b.SELL_PER_DAY_BIG - a.SELL_PER_DAY_BIG)
    },

    stocks_today_counted() {
      return this.stocks.filter(i => i.counted_at === this.today)
    },

    stocks_today_in() {
      return this.stocks.filter(i => i.LLK && moment(i.LLK).format("YYYY-MM-DD") === this.today)
    },

    stocks_today_in_isPo() {
      return this.stocks_today_in.filter(i => i.is_po == 1)
    },

    stocks_warning_today_counted() {
      return this.stocks.filter(i => i.WARNING == 1 && i.counted_at === this.today)
    },

    stocks_schedule_count() {
      return this.stocks.filter(e => e.count_day == new Date().getDay() && e.counted_at === this.today).length
    },

    stocks_today_counted_peterDiff() {
      return this.stocks
        .filter(i => i.counted_at === this.today && i.peter_DIFF != 0)
        .sort((a, b) => a.peter_DIFF - b.peter_DIFF)
    },

    stocks_today_po() {
      return this.stocks.filter(i => i.LASTEST_PODAT === this.today)
    },

    stocks_warning_today_po() {
      return this.stocks.filter(i => i.WARNING == 1 && i.LASTEST_PODAT === this.today)
    },

    stocks_is_po() {
      return this.stocks
        .filter(i => i.is_po == 1)
        .sort((a, b) => new Date(a.LASTEST_PODAT).getTime() - new Date(b.LASTEST_PODAT).getTime())
    },

    lessStock_count() {
      return this.stocks.filter(e => e.WARNING == 1 && e.notify == 1 && e.hide == 0 && e.is_po == 0 && e.counted_at !== this.today).length
    },

    // Badge counts for ลูกค้า sub-tabs (use same data the filter uses → numbers always match)
    overdueCustomer_count() {
      return this.customers.filter(c => c.HAS_OVERDUE).length
    },

    notVisitedCustomer_count() {
      // ลูกค้าที่ active (เคยซื้อใน 6 เดือน) แต่เดือนนี้ยังไม่ได้เยี่ยม
      // ไม่นับลูกค้า inactive เลย เพราะไม่มีความหมายว่าต้องเยี่ยม
      return this.customers.filter(c => c.ACTIVE && !c.VISITS_THIS_MONTH).length
    },

    mushCount_count() {
      return this.stocks.filter(e => e.count_day == new Date().getDay() && e.counted_at !== this.today).length
    },

    // Filter predicate ของ count_day สำหรับ vue-dataset (ใช้ใน :ds-filter-fields)
    // vue-dataset เทียบค่าแบบ strict === แต่ count_day อาจเป็น string (จากการคลิกใน modal
    // ที่ v-for object key เป็น string) หรือ number (จาก MySQL) — เทียบผ่าน Number() ทั้งคู่
    // คืน '' ตอน filter ไม่ active เพื่อให้ vue-dataset ข้าม filter นี้ (ปล่อยผ่านทุกแถว)
    countdayFilterFn() {
      const f = this.filters.countdayFilter
      if (f === '' || f === null || f === undefined) return ''
      return (value) => value !== null && value !== undefined && Number(value) === Number(f)
    },

    // Filter predicate ของ field `user` (= สถานะนับ) สำหรับ tab ยังไม่นับ
    // notCountFilter === null  → tab ยังไม่นับ: โชว์ "ยังไม่นับ (user==null)" + "สินค้าซ่อน (hide==1)"
    //   (สินค้าซ่อนถูกตัดออกจาก tab อื่นด้วย hideFilter=0 จึงมารวมไว้ที่นี่ ไม่ให้หาย)
    // notCountFilter === ''    → tab อื่น: คืน '' ให้ vue-dataset ข้าม filter นี้ (ปล่อยผ่านทุกแถว)
    notCountFilterFn() {
      const f = this.filters.notCountFilter
      if (f === '' || f === undefined) return ''
      return (userVal, row) => userVal == null || row.hide == 1
    },

    countFilter_count() {
      return this.stocks.filter(e => e.counted_at === this.today).length
    },

    todayMustCountByReport_count() {
      return this.stocks.filter(e => e.today_must_counted == 1).length
    },

    isSell_count() {
      return this.stocks.filter(e => e.is_sell == 1).length
    },

    notCountFilter_count() {
      return this.stocks.filter(e => e.user == null).length
    },

    // จำนวนสินค้าที่โชว์ใน tab ทั้งหมด = สินค้าที่ไม่ได้ซ่อน (hide==0) — badge สรุปยอดรวม
    allProduct_count() {
      return this.stocks.filter(e => e.hide == 0).length
    },

    // จำนวนที่โชว์ใน tab ยังไม่นับ = ยังไม่นับ (user==null) รวมสินค้าซ่อน (hide==1) — ให้ badge ตรงกับ list
    notCountTab_count() {
      return this.stocks.filter(e => e.user == null || e.hide == 1).length
    },

    sortBy() {
      return this.cols.reduce((acc, o) => {
        if (o.sort) acc.push(o.sort === 'asc' ? o.field : '-' + o.field)
        return acc
      }, [])
    }
  },

  // ==================== LIFECYCLE ====================
  async created() {
    // Non-reactive instance var for debounce timer (not in data() to avoid Vue reactivity overhead)
    this._customerSearchTimer = null

    const queryParams = new URLSearchParams(window.location.search)
    if (queryParams.get('is_sell') === "1") this.tab_state = 9

    // โหลดครั้งแรก default อยู่ tab ทั้งหมด → ตั้งค่าเรียงให้เหมือนกดปุ่ม ทั้งหมด เลย
    // (เรียงตามรหัสสินค้า STKCOD จากน้อยไปมาก) ไม่ต้องรอ user กดปุ่มก่อนถึงจะเรียง
    if (this.tab_state === 0) this.customClick([1], ['asc'])

    this.loadingClass = 12
    this.fileName = "โหลดโปรแกรม"

    const redis_check = await StockService.refreshStocks()
    if (redis_check) {
      this.onLine = true
      this.stocks = redis_check
      this.mainLoading = false
    } else {
      this.$socket.client.emit('loadingClassCheck')
    }

    moment.locale('th')
    this.$barcodeScanner.init(this.onBarcodeScanned)
    document.addEventListener('focusin', this.focusChanged)
  },

  mounted() {
    this._customerObserver = null   // holder สำหรับ IntersectionObserver (lazy load ลูกค้า)

    const granted = localStorage.getItem('access_granted')
    if (granted !== 'true') {
      this.$nextTick(() => this.$bvModal.show('modal_password'))
    }

    this.$socket.client.on('loadingClass', res => { this.loadingClass = res })
    this.$socket.client.on('fileName', res => { this.fileName = res })
    this.$socket.client.on('refresh', async res => {
      if (res) {
        this.loadingClass = 12
        this.fileName = "โหลดโปรแกรม"
        try {
          this.stocks = await StockService.refreshStocks()
          // ไม่ wipe customers หรือ reload list — refresh signal นี้มาจาก stock update เป็นหลัก
          // ลูกค้าจะ refresh เมื่อ user navigate ออกแล้วกลับมาที่ tab_state==10 อีกครั้ง
          // หรือเมื่อมี refresh signal เฉพาะของ customer ในอนาคต
          this.mainLoading = false
        } catch (err) { console.log("Refresh Error", err) }
      } else {
        this.mainLoading = true
      }
    })
    this.$socket.client.on('refreshSoft', async result => {
      if (result) Object.assign(this.stocks[result.index], result.data)
      this.mainLoading = false
    })
  },

  updated() {
    this.readyState = true
  },

  beforeDestroy() {
    document.removeEventListener('focusin', this.focusChanged)
    this.teardownCustomerObserver()
    clearTimeout(this._pageGuardTimer)
    if (this._pageGuardStop) this._pageGuardStop()
  },

  destroyed() {
    this.$barcodeScanner.destroy()
  },

  // ==================== METHODS ====================
  methods: {
    // ---------- UTILITY HELPERS ----------
    isToday(dateStr) {
      return dateStr === this.today
    },

    atomDisplay(atom, cfactor) {
      return this.getValueFromAtom(atom, cfactor).CONCAT_NO_PLUS
    },

    getValueFromAtom(atom, cfactor) {
      const abs = Math.abs(atom)
      let big = Math.floor(abs / cfactor)
      big = atom < 0 ? big * -1 : big
      let small = abs % cfactor
      small = atom < 0 ? small * -1 : small
      const start = atom > 0 ? "+" : atom < 0 ? "-" : ""
      const concat = start + Math.abs(big) + "." + Math.abs(small)
      return { BIG: big, SMALL: small, CONCAT: concat, CONCAT_NO_PLUS: big + "." + small }
    },

    freqLabel(freq) {
      if (freq === 7) return 'สัปดาห์'
      if (freq === -1) return 'เดือน (ซ้อ)'
      return 'เดือน'
    },

    getCountLastRemark(item) {
      const diff = item.COUNT_ATOM_LAST - (item.COUNT_ATOM - item.ATOM_ORDQTY)
      if (diff === 0) return '✔'
      return diff < 0 ? 'ขาด' : 'เกิน'
    },

    historyDiff(sh) {
      if (sh.peter_ATOM == null) {
        return this.getValueFromAtom(sh.COUNT_ATOM - (sh.COUNT_ATOM - sh.aj_diff), sh._CFACTOR).CONCAT
      }
      return this.getValueFromAtom(sh.COUNT_ATOM - sh.peter_ATOM, sh._CFACTOR).CONCAT
    },

    historyRunningNumber(index) {
      if (this.isModalType2) return index + 1
      return (this.currentStock.history?.length || 0) - index
    },

    isFirstHistoryRow(sh, index) {
      if (this.isModalType2) return sh.counted_at === this.currentStock.counted_at
      return index === 0 && this.currentStock.counted_at !== this.today
    },

    cusAtomBig(cus, stock) {
      const val = this.getValueFromAtom((cus.ATOM / 180) * stock.order_frequency, stock.CFACTOR).BIG
      return val > 0 ? val : "~1"
    },

    cusAtomPercent(cus, stock) {
      const big = this.getValueFromAtom((cus.ATOM / 180) * stock.order_frequency, stock.CFACTOR).BIG
      const pct = parseInt((big / stock.AVG_SELL) * 100)
      return pct > 0 ? pct : "~1"
    },

    // ---------- DATE HELPERS ----------
    date(date) {
      if (!moment(date, "YYYYMMDD").isValid()) return "ไม่มีข้อมูล"
      return moment(date).format("DD/MM/") + (parseInt(moment(date).format("YY")) + 43)
    },

    todayDate() {
      return moment().format("DD/MM/") + (parseInt(moment().format("YY")) + 43)
    },

    todayDateX() {
      return "วัน" + moment().format("dddd") + "ที่ " + moment().format("DD MMM ") + (parseInt(moment().format("YY")) + 43)
    },

    dayAgo(date) {
      if (!moment(date, "YYYYMMDD").isValid()) return "ไม่มีข้อมูล"
      const diff = moment().diff(date, 'days')
      if (diff === 0) return ":: วันนี้ ::"
      if (diff === 1) return "เมื่อวาน"
      return moment(date, "YYYYMMDD").endOf('day').fromNow()
    },

    numberFormat(num) {
      return typeof num === 'number'
        ? num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : 'ผิดพลาด'
    },

    processDiscount(price) {
      return price
    },

    extractDistrictProvince(address) {
    if (!address || typeof address !== 'string') {
        return { district: null, province: null };
    }

    // อ.<district>  → stop at next " จ." / " <postcode>" / end
    const dMatch = address.match(/อ\.\s*(\S.*?)(?=\s+จ\.|\s+\d{5}|\s*$)/);

    // จ.<province>  → stop at " <postcode>" / end
    const pMatch = address.match(/จ\.\s*(\S.*?)(?=\s+\d{5}|\s*$)/);

    return {
        district: dMatch ? dMatch[1].trim() : null,
        province: pMatch ? pMatch[1].trim() : null
    };
},

    // ---------- STOCK STATE HELPERS ----------
    is_today_count(i) {
      return this.stocks[i]?.counted_at === this.today
    },

    is_count_stat_change(i) {
      const s = this.stocks[i]
      return s?.STAT != null && s?.COUNT_STAT != null && s.STAT !== s.COUNT_STAT
    },

    get_last_count_stock_history(i) {
      const hist = this.stocks[i]?.history?.filter(e => !e.is_adjust)
      return hist?.[hist.length - 1]
    },

    is_has_today_transaction(i) {
      return !!this.stocks[i]?.history?.find(e => e.counted_at === this.today)
    },

    is_so_ready(i) {
      const stat = this.stocks[i]?.STAT
      return stat !== 'N'
    },

    // ---------- PAGINATION ----------
    start_item() {
      return this.currentPage === 1 ? 0 : (this.currentPage - 1) * this.maxPerPage
    },

    end_item() {
      return this.currentPage === 1 ? this.maxPerPage - 1 : this.currentPage * this.maxPerPage - 1
    },

    // ---------- UI HELPERS ----------
    resetBarcodeState() {
      this.barcodeStateTrigger = null
      this.uniqueCodeStateTrigger = null
      this.addBarcodeTrigger = false
    },

    getTextClass(row) {
      if (row.counted_at == null) return 'text-secondary'
      if (row.counted_at !== this.today) return 'text-light'
      return 'text-warning'
    },

    // ---------- PASSWORD ----------
    checkPassword() {
      if (this.passwordInput === this.correctPassword) {
        localStorage.setItem('access_granted', 'true')
        this.showPasswordModal = false
        this.wrongPassword = false
      } else {
        this.wrongPassword = true
        this.passwordInput = ''
      }
    },

    // ---------- FILTER & SORT ----------
    applyFilters(arg = '') {
      const keyArg = Object.keys(arg)
      Object.keys(this.filters).forEach(key => {
        this.filters[key] = keyArg.includes(key) ? arg[key] : ''
      })
      this.clearText()
    },

    // โหลดรายชื่อลูกค้า (lazy - โหลดครั้งเดียวจนกว่าจะมี refresh)
    async loadCustomers() {
      if (this.customers.length) return
      this.customersLoading = true
      try {
        this.customers = await StockService.getCustomers()
        // Precompute a lowercase search blob per customer so filter doesn't do toLowerCase() per keystroke
        this.customers.forEach(c => {
          c._search = [c.CUSCOD, c.CUSNAM, c.CUS_TELNUM, c.CUS_ADDRESS]
            .filter(Boolean).join(' ').toLowerCase()
        })
      } catch (err) {
        console.log('loadCustomers error', err)
        this.error = 'โหลดข้อมูลลูกค้าไม่สำเร็จ'
      } finally {
        this.customersLoading = false
      }
    },

    // เปิด Modal รายละเอียดลูกค้า
    openCustomerModal(customer) {
      this.customerModalResource = customer
      // ไม่ reset customerTab — จดจำ tab ล่าสุดที่ user เปิดไว้
      this.customerProducts = []             // reset products cache for new customer
      this.showAllCustomerProducts = false   // start collapsed each time
      this.suggestions = []                  // reset suggestions cache for new customer
      this.showAllSuggestions = false        // start collapsed each time
      this.debts = null                      // reset debts cache for new customer
      this.showAllDebts = false              // start collapsed each time
      this.customerInfo = null               // reset customer info cache for new customer
      this.imageMenuOpen = false
      this.imageUploading = false
      this.$bvModal.show('modal_customer')

      // โหลดข้อมูลของ tab ที่จำไว้ (ทุก tab lazy-load หมดแล้ว รวมถึง tab 0 ประวัติสินค้า)
      if (this.customerTab === 0) this.loadCustomerProducts()
      else if (this.customerTab === 1) this.loadSuggestions()
      else if (this.customerTab === 2) this.loadDebts()
      else if (this.customerTab === 3) this.loadCustomerInfo()
    },

    // เช็คว่า customer row นี้คลิกได้ไหม
    // - แถวรวม "...และลูกค้าอื่นๆ อีก N ราย" จะไม่มี CUSCOD ที่เป็นโค้ดจริง — คลิกไม่ได้
    // - หน้าร้านเซียวบุ่นเส่ง / cuscod ที่ไม่ตรง pattern → คลิกไม่ได้
    isClickableCustomer(cus) {
      if (!cus || !cus.CUSCOD) return false
      // CUSCOD จริงมี format เช่น "23502-0008", "12345-0001" — มี dash อยู่ตรงกลาง
      return /^\d+-\d+$/.test(cus.CUSCOD)
    },

    // เปิด customer modal จาก CUSCOD โดยมอง customer object เต็มในรายการที่โหลดแล้ว
    // ใช้จาก product modal → ลูกค้า tab → กดที่ชื่อลูกค้า
    openCustomerByCuscod(cuscod) {
      if (!cuscod || !/^\d+-\d+$/.test(cuscod)) return    // ข้าม "และลูกค้าอื่นๆ"
      // ถ้ายังไม่ได้โหลด customer list ให้โหลดก่อน
      if (!this.customers.length) {
        this.loadCustomers().then(() => this.openCustomerByCuscod(cuscod))
        return
      }
      const customer = this.customers.find(c => c.CUSCOD === cuscod)
      if (!customer) return
      // ปิด product modal ก่อน เพื่อให้ customer modal โผล่ขึ้นมาเด่นๆ
      this.$bvModal.hide('modal_count_2')
      // เปิด customer modal (จะ trigger lazy load ของ tab ที่จำไว้)
      this.openCustomerModal(customer)
    },

    // โหลดสินค้าที่ลูกค้าเคยซื้อ (lazy - PRODUCTS ไม่ได้มากับ GET /customers แล้ว เพื่อให้ list โหลดเร็ว)
    async loadCustomerProducts() {
      if (!this.customerModalResource) return
      if (this.customerProducts.length) return     // already loaded for this customer
      if (this.customerProductsLoading) return     // request in flight
      this.customerProductsLoading = true
      try {
        this.customerProducts = await StockService.getCustomerProducts(this.customerModalResource.CUSCOD)
      } catch (err) {
        console.log('loadCustomerProducts error', err)
        this.customerProducts = []
      } finally {
        this.customerProductsLoading = false
      }
    },

    // โหลดสินค้าแนะนำ (lazy - โหลดครั้งเดียวเมื่อ user คลิก tab แนะนำ)
    async loadSuggestions() {
      if (!this.customerModalResource) return
      if (this.suggestions.length) return          // already loaded for this customer
      if (this.suggestionsLoading) return          // request in flight
      this.suggestionsLoading = true
      try {
        this.suggestions = await StockService.getSuggestions(this.customerModalResource.CUSCOD, 20)
      } catch (err) {
        console.log('loadSuggestions error', err)
        this.suggestions = []
      } finally {
        this.suggestionsLoading = false
      }
    },

    // โหลดรายการบิล (lazy - โหลดครั้งเดียวเมื่อ user คลิก tab หนี้)
    async loadDebts() {
      if (!this.customerModalResource) return
      if (this.debts) return                       // already loaded for this customer
      if (this.debtsLoading) return                // request in flight
      this.debtsLoading = true
      try {
        this.debts = await StockService.getDebts(this.customerModalResource.CUSCOD)
      } catch (err) {
        console.log('loadDebts error', err)
        this.debts = null
      } finally {
        this.debtsLoading = false
      }
    },

    // โหลดข้อมูลเสริมของลูกค้า (type/image/lat/lng) - lazy ตอนเปิด tab ข้อมูล
    async loadCustomerInfo() {
      if (!this.customerModalResource) return
      if (this.customerInfo) return
      if (this.customerInfoLoading) return
      this.customerInfoLoading = true
      try {
        this.customerInfo = await StockService.getCustomerInfo(this.customerModalResource.CUSCOD)
      } catch (err) {
        console.log('loadCustomerInfo error', err)
        this.customerInfo = null
      } finally {
        this.customerInfoLoading = false
      }
    },

    // เช็คว่า typeId นี้คือประเภทที่เลือกอยู่หรือไม่
    isCustomerType(typeId) {
      if (!this.customerInfo) return false
      // type ใน DB เก็บเป็น string จาก VARCHAR — เทียบแบบ loose
      return String(this.customerInfo.type) === String(typeId)
    },

    // สไตล์ของกล่องประเภทร้านค้า — selected = เหลือง + เข้ม + ขอบดำ, unselected = เทาอ่อน
    customerTypeStyle(typeId) {
      const selected = this.isCustomerType(typeId)
      return {
        background : selected ? '#FFD760'         : '#f0f0f0',
        border     : selected ? '1px solid #000'  : '1px solid transparent',
        fontWeight : selected ? 'bold'            : 'normal'
      }
    },

    // กดเลือกประเภทร้านค้า - save ทันที (toggle = กดซ้ำ = ล้างค่า)
    async selectCustomerType(typeId) {
      if (!this.customerModalResource) return
      // ถ้ากดประเภทที่เลือกอยู่ซ้ำ → ล้างค่า (ต้องใช้ clear_fields เพราะ COALESCE ไม่ยอมให้เซ็ต NULL)
      const payload = this.isCustomerType(typeId)
        ? { clear_fields: ['type'] }
        : { type: String(typeId) }
      try {
        this.customerInfo = await StockService.saveCustomerInfo(
          this.customerModalResource.CUSCOD,
          payload
        )
      } catch (err) {
        console.log('selectCustomerType error', err)
      }
    },

    // === Image upload / camera / delete ===

    // เปิด lightbox modal แสดงรูปแบบใหญ่เต็มจอ (เฉพาะตอนมีรูปแล้วเท่านั้น)
    // ถ้า menu ⋯ เปิดอยู่ คลิกที่รูป = ปิด menu ก่อน (ไม่ pop รูป) เพื่อกัน UX ขัด
    openCustomerImageModal() {
      if (this.imageMenuOpen) { this.imageMenuOpen = false; return }
      if (!this.customerInfo || !this.customerInfo.image) return
      this.customerImageModalSrc = this.customerInfo.image
      this.$bvModal.show('modal_customer_image')
    },

    // เปิด file picker ปกติ (เลือกจาก gallery / Files)
    triggerImageUpload() {
      this.$refs.imageFileInput && this.$refs.imageFileInput.click()
    },

    // เปิดกล้องโดยตรง (มือถือ) - desktop จะ fallback ไปเป็น file picker
    triggerCameraCapture() {
      this.$refs.imageCameraInput && this.$refs.imageCameraInput.click()
    },

    // resize รูปลงเหลือ max 1024×1024 + jpeg quality 0.8 → base64 data URL
    // ลดขนาดจากรูปกล้อง 3-5 MB เหลือประมาณ 150-400 KB (เก็บใน LONGTEXT ได้สบาย)
    resizeImageToDataUrl(file, maxSize = 1024, quality = 0.8) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = e => {
          const img = new Image()
          img.onload = () => {
            let w = img.width, h = img.height
            // คงสัดส่วน, ย่อด้านที่ใหญ่กว่าให้เหลือ maxSize
            if (w > h && w > maxSize) { h = h * (maxSize / w); w = maxSize }
            else if (h > maxSize)      { w = w * (maxSize / h); h = maxSize }
            const canvas = document.createElement('canvas')
            canvas.width  = Math.round(w)
            canvas.height = Math.round(h)
            const ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
            resolve(canvas.toDataURL('image/jpeg', quality))
          }
          img.onerror = reject
          img.src = e.target.result
        }
        reader.onerror = reject
        reader.readAsDataURL(file)
      })
    },

    // handler ของ <input type="file"> ทั้ง 2 ตัว (file + camera)
    async handleImageFile(event) {
      const file = event.target.files && event.target.files[0]
      if (!file) return
      if (!this.customerModalResource) return
      this.imageUploading = true
      try {
        const dataUrl = await this.resizeImageToDataUrl(file)
        this.customerInfo = await StockService.saveCustomerInfo(
          this.customerModalResource.CUSCOD,
          { image: dataUrl }
        )
      } catch (err) {
        console.log('handleImageFile error', err)
        alert('อัพโหลดรูปไม่สำเร็จ')
      } finally {
        this.imageUploading = false
        // reset value เพื่อให้เลือก file เดิมซ้ำได้
        event.target.value = ''
      }
    },

    // ลบรูปร้านค้า (ถาม confirm ก่อน เพราะ irreversible)
    async deleteCustomerImage() {
      if (!this.customerModalResource) return
      if (!confirm('ลบรูปร้านค้านี้?')) return
      this.imageUploading = true
      try {
        this.customerInfo = await StockService.saveCustomerInfo(
          this.customerModalResource.CUSCOD,
          { clear_fields: ['image'] }
        )
      } catch (err) {
        console.log('deleteCustomerImage error', err)
      } finally {
        this.imageUploading = false
      }
    },

    // === Product image (รูปสินค้า ใน tab ตั้งค่า) ===

    // โหลดรูปสินค้าจาก _products_images (lazy — เรียกตอนเปิด tab ตั้งค่า)
    // productImageFor กัน fetch ซ้ำ: โหลดของ STKCOD นี้แล้ว = ไม่โหลดใหม่
    async loadProductImage() {
      const s = this.currentStock
      if (!s || !s.STKCOD) return
      if (this.productImageFor === s.STKCOD) return
      this.productImageFor = s.STKCOD
      this.productImage = null
      this.productImageMenuOpen = false
      this.productImageLoading = true
      try {
        const res = await StockService.getImage(s.STKCOD)
        // กัน race: ถ้า user เปิดสินค้าอื่นไประหว่างรอ response อย่า overwrite รูปของตัวใหม่
        if (this.productImageFor === s.STKCOD) {
          this.productImage = (res && res.success && res.image_data) ? res.image_data : null
        }
      } catch (err) {
        console.log('loadProductImage error', err)
        this.productImageFor = null   // เปิด tab ใหม่แล้วลองโหลดอีกครั้งได้
      } finally {
        this.productImageLoading = false
      }
    },

    triggerProductImageUpload() {
      this.$refs.productImageFileInput && this.$refs.productImageFileInput.click()
    },

    triggerProductCameraCapture() {
      this.$refs.productImageCameraInput && this.$refs.productImageCameraInput.click()
    },

    // ครอปกึ่งกลางเป็นจัตุรัส 1:1 แล้วย่อเหลือ size×size + jpeg → base64 data URL
    // ต่างจาก resizeImageToDataUrl ตรงที่ตัดขอบทิ้งให้เป็นจัตุรัสเสมอ (รูปสินค้าต้อง 1:1)
    // 640px q0.75 ≈ 30-70KB — จุดแสดงผลใหญ่สุดคือ lightbox (~500px) จึงไม่ต้องเก็บใหญ่กว่านี้
    cropSquareToDataUrl(file, size = 640, quality = 0.75) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = e => {
          const img = new Image()
          img.onload = () => {
            const side = Math.min(img.width, img.height)
            const sx = (img.width - side) / 2
            const sy = (img.height - side) / 2
            const out = Math.min(size, side)   // ไม่ upscale รูปที่เล็กกว่า size
            const canvas = document.createElement('canvas')
            canvas.width = out
            canvas.height = out
            canvas.getContext('2d').drawImage(img, sx, sy, side, side, 0, 0, out, out)
            resolve(canvas.toDataURL('image/jpeg', quality))
          }
          img.onerror = reject
          img.src = e.target.result
        }
        reader.onerror = reject
        reader.readAsDataURL(file)
      })
    },

    // handler ของ file input ทั้ง 2 ตัว (เลือกรูป + ถ่ายรูป)
    async handleProductImageFile(event) {
      const file = event.target.files && event.target.files[0]
      if (!file) return
      const index = this.modalResource
      const s = this.stocks[index]
      if (!s || !s.STKCOD) return
      this.productImageUploading = true
      try {
        const dataUrl = await this.cropSquareToDataUrl(file)
        await StockService.saveImage(index, { STKCOD: s.STKCOD, image_data: dataUrl })
        this.productImage = dataUrl
        this.productImageFor = s.STKCOD
        this.$set(this.stocks[index], 'has_image', 1)   // อัพเดทไอคอนรูปบนการ์ดทันที
      } catch (err) {
        console.log('handleProductImageFile error', err)
        alert('อัพโหลดรูปไม่สำเร็จ')
      } finally {
        this.productImageUploading = false
        this._lightboxGuardTs = Date.now()   // กัน ghost click หลัง alert ปิด
        event.target.value = ''   // reset เพื่อให้เลือก file เดิมซ้ำได้
      }
    },

    // ลบรูปสินค้า (confirm ก่อน เพราะ irreversible)
    async deleteProductImage() {
      const index = this.modalResource
      const s = this.stocks[index]
      if (!s || !s.STKCOD) return
      // _lightboxGuardTs: หลัง native dialog (confirm/alert) ปิด browser อาจยิง ghost click
      // ลงบน thumbnail ใต้ตำแหน่งที่แตะ → lightbox เด้งเอง ตั้ง timestamp ให้ openProductImageModal ignore
      if (!confirm('ลบรูปสินค้านี้?')) { this._lightboxGuardTs = Date.now(); return }
      this.productImageUploading = true
      try {
        const res = await StockService.deleteImage(index, { STKCOD: s.STKCOD })
        if (!res || !res.success) throw new Error('delete failed on server')
        this.productImage = null
        this.$set(this.stocks[index], 'has_image', 0)   // อัพเดทไอคอนรูปบนการ์ดทันที
      } catch (err) {
        console.log('deleteProductImage error', err)
        alert('ลบรูปไม่สำเร็จ')
      } finally {
        this.productImageUploading = false
        this._lightboxGuardTs = Date.now()
      }
    },

    // เปิด lightbox ดูรูปใหญ่ (ถ้าเมนู ⋯ เปิดอยู่ = ปิดเมนูก่อน ไม่ pop รูป)
    openProductImageModal() {
      if (this.productImageMenuOpen) { this.productImageMenuOpen = false; return }
      if (this.productImageUploading || this.productImageLoading) return
      if (Date.now() - (this._lightboxGuardTs || 0) < 500) return   // ghost click หลังปิด dialog
      if (!this.productImage) return
      this.$bvModal.show('modal_product_image')
    },

    // เปิด lightbox รูปสินค้าจากการ์ด (StockCard) — โหลดรูปตาม STKCOD แล้วโชว์ใหญ่
    async openStockImage(stkcod) {
      if (!stkcod) return
      try {
        const res = await StockService.getImage(stkcod)
        if (res && res.success && res.image_data) {
          this.cardImageSrc = res.image_data
          this.$bvModal.show('modal_card_image')
        }
      } catch (err) {
        console.log('openStockImage error', err)
      }
    },

    // === AI find image (หารูปสินค้าจากเน็ต) ===

    openAiFindImage() {
      const s = this.currentStock
      if (!s || !s.STKCOD) return
      this.aiImageFor = s.STKCOD
      this.aiImageName = s.STKDES || s.STKCOD
      this.aiImagePage = 1
      this.aiImages = []
      this.aiSelecting = false
      this.$bvModal.show('modal_ai_find_image')
      this.loadAiImages()
    },

    async loadAiImages() {
      if (!this.aiImageFor) return
      this.aiImagesLoading = true
      try {
        const res = await StockService.findProductImages(this.aiImageFor, this.aiImageName, this.aiImagePage)
        this.aiImages = (res && res.images) || []
      } catch (err) {
        console.log('loadAiImages error', err)
        this.aiImages = []
      } finally {
        this.aiImagesLoading = false
      }
    },

    // หาใหม่ = เลื่อนไปหน้าถัดไปของ Serper (ได้รูปชุดใหม่)
    retryAiImages() {
      this.aiImagePage += 1
      this.aiImages = []
      this.loadAiImages()
    },

    // เลือกรูป → backend proxy ดึงเป็น base64 → crop จัตุรัส → save (เหมือน upload ปกติ)
    async selectAiImage(im) {
      if (this.aiSelecting || !im || !im.url) return
      const index = this.stocks.findIndex(x => x.STKCOD === this.aiImageFor)
      if (index < 0) return
      this.aiSelecting = true
      try {
        const res = await StockService.fetchFoundImage(this.aiImageFor, im.url)
        if (!res || !res.success || !res.image_data) throw new Error('proxy fetch failed')
        const dataUrl = await this.cropSquareFromDataUrl(res.image_data)
        await StockService.saveImage(index, { STKCOD: this.aiImageFor, image_data: dataUrl })
        this.productImage = dataUrl
        this.productImageFor = this.aiImageFor
        this.$set(this.stocks[index], 'has_image', 1)   // อัพเดทไอคอนรูปบนการ์ดทันที
        this.$bvModal.hide('modal_ai_find_image')
      } catch (err) {
        console.log('selectAiImage error', err)
        alert('ใช้รูปนี้ไม่สำเร็จ ลองรูปอื่น')
      } finally {
        this.aiSelecting = false
      }
    },

    // crop จัตุรัสจาก data URL (เหมือน cropSquareToDataUrl แต่รับ data URL แทน File)
    // data: URI เป็น same-origin → canvas ไม่ taint → toDataURL ได้ (จึงต้อง proxy ผ่าน backend ก่อน)
    cropSquareFromDataUrl(dataUrl, size = 640, quality = 0.75) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => {
          const side = Math.min(img.width, img.height)
          const sx = (img.width - side) / 2
          const sy = (img.height - side) / 2
          const out = Math.min(size, side)
          const canvas = document.createElement('canvas')
          canvas.width = out
          canvas.height = out
          canvas.getContext('2d').drawImage(img, sx, sy, side, side, 0, 0, out, out)
          resolve(canvas.toDataURL('image/jpeg', quality))
        }
        img.onerror = reject
        img.src = dataUrl
      })
    },

    // === GPS / Map ===

    // เปิด map modal พร้อมตำแหน่งเริ่มต้น
    //   - ถ้ามี lat/lng เก็บอยู่แล้ว → ใช้นั้น zoom 17 (ใกล้ระดับร้านค้า)
    //   - ถ้าไม่มี → ลองขอ device GPS, fallback เป็นอุบลฯ ถ้า user ปฏิเสธ
    openMapModal() {
      // reset search state ทุกครั้งที่เปิด modal (ลูกค้าใหม่ = search ใหม่)
      this.placeSearchQuery = ''
      this.placeSearchResults = []
      this.placeSearchLoading = false
      this._lastPlaceQuery = ''
      // เคลียร์ค่าใน input (uncontrolled, ต้องผ่าน ref)
      this.$nextTick(() => {
        if (this.$refs.placeSearchInput) this.$refs.placeSearchInput.value = ''
      })

      if (this.customerInfo && this.customerInfo.lat && this.customerInfo.lng) {
        const lat = Number(this.customerInfo.lat)
        const lng = Number(this.customerInfo.lng)
        this.mapCenter = { lat, lng }
        this.mapCurrentCenter = { lat, lng }
        this.mapZoom = 17
      } else {
        // default = อุบลฯ; พยายามขอ GPS เมื่อ modal เปิดแล้ว
        this.mapCenter = { lat: 15.2369, lng: 104.8521 }
        this.mapCurrentCenter = { lat: 15.2369, lng: 104.8521 }
        this.mapZoom = 8
        // ขอ GPS หลัง modal โผล่ — ไม่ block เปิด modal
        this.$nextTick(() => this.tryAutoLocateOnOpen())
      }
      this.$bvModal.show('modal_customer_map')
    },

    // ลอง grab GPS อัตโนมัติตอนเปิด map ครั้งแรก (เฉพาะลูกค้าที่ยังไม่มีพิกัด)
    tryAutoLocateOnOpen() {
      if (!navigator.geolocation) return
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          this.mapCenter = { lat: pos.coords.latitude, lng: pos.coords.longitude }
          this.mapCurrentCenter = { ...this.mapCenter }
          this.mapZoom = 16
        },
        () => { /* user denied — เงียบไป ปล่อยให้ search/manual */ },
        { enableHighAccuracy: true, timeout: 5000 }
      )
    },

    // ปุ่ม "ใช้ตำแหน่งปัจจุบัน" — explicit user action
    useCurrentLocation() {
      if (!navigator.geolocation) {
        alert('เบราว์เซอร์นี้ไม่รองรับ GPS')
        return
      }
      this.locatingUser = true
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          this.mapCenter = { lat: pos.coords.latitude, lng: pos.coords.longitude }
          this.mapCurrentCenter = { ...this.mapCenter }
          this.mapZoom = 17
          this.locatingUser = false
        },
        (err) => {
          this.locatingUser = false
          const msg = err.code === 1
            ? 'กรุณาอนุญาตการเข้าถึง GPS ในเบราว์เซอร์'
            : 'หาตำแหน่งไม่สำเร็จ'
          alert(msg)
        },
        { enableHighAccuracy: true, timeout: 10000 }
      )
    },

    // เมื่อ user เลื่อน/ซูม map — เก็บค่า center ปัจจุบันไว้ (จะใช้ตอนกดบันทึก)
    onMapCenterChanged(latLng) {
      // gmap-map emits a LatLng object; convert to plain
      this.mapCurrentCenter = { lat: latLng.lat(), lng: latLng.lng() }
    },

    // ลำดับการ search:
    //   1. user พิมพ์ → debounce 300ms → AutocompleteService.getPlacePredictions()
    //   2. แสดง dropdown ของ predictions
    //   3. user คลิก → PlacesService.getDetails() เอา lat/lng → เลื่อน map
    //
    // ใช้ AutocompleteService + PlacesService (ของเก่ายังใช้ได้, แม้ Autocomplete widget จะ deprecate)
    // sessionToken ลด billing (predictions ฟรีถ้ามี token, จ่ายแค่ getDetails ครั้งเดียวต่อ session)
    initPlacesServices_() {
      if (!window.google || !window.google.maps || !window.google.maps.places) return false
      if (!this._placesAutocompleteService) {
        this._placesAutocompleteService = new window.google.maps.places.AutocompleteService()
      }
      if (!this._placesDetailsService) {
        // PlacesService ต้องการ DOM element ผูกไว้ — ใช้ div ว่างๆ ก็ได้
        const dummyDiv = document.createElement('div')
        this._placesDetailsService = new window.google.maps.places.PlacesService(dummyDiv)
      }
      this._placesSessionToken = new window.google.maps.places.AutocompleteSessionToken()
      return true
    },

    onPlaceSearchInput(value) {
      // เก็บ value ล่าสุดใน non-reactive ref ไว้ใช้ใน debounce callback
      this._lastPlaceQuery = value

      // ถ้า value ว่าง → เคลียร์ทันที (ไม่ต้องรอ debounce)
      if (!value) {
        clearTimeout(this._placeSearchTimer)
        if (this.placeSearchQuery !== '') this.placeSearchQuery = ''
        if (this.placeSearchResults.length) this.placeSearchResults = []
        return
      }

      // Debounce 200ms — Vue จะ re-render แค่ครั้งเดียวต่อ debounce cycle
      // ไม่ใช่ครั้งเดียวต่อ keystroke (สำคัญมาก เพราะ component นี้ใหญ่)
      clearTimeout(this._placeSearchTimer)
      this._placeSearchTimer = setTimeout(() => {
        this.placeSearchQuery = this._lastPlaceQuery
        this.fetchPlacePredictions_(this._lastPlaceQuery)
      }, 200)
    },

    fetchPlacePredictions_(query) {
      if (!query || query.length < 2) {
        this.placeSearchResults = []
        return
      }
      if (!this.initPlacesServices_()) return    // API ยังไม่โหลด — ลองอีกครั้งใน input ถัดไป

      this.placeSearchLoading = true
      this._placesAutocompleteService.getPlacePredictions({
        input: query,
        componentRestrictions: { country: 'th' },
        sessionToken: this._placesSessionToken
      }, (predictions, status) => {
        this.placeSearchLoading = false
        const OK = window.google.maps.places.PlacesServiceStatus.OK
        if (status !== OK || !predictions) {
          this.placeSearchResults = []
          return
        }
        this.placeSearchResults = predictions
      })
    },

    selectPlacePrediction(prediction) {
      if (!this._placesDetailsService) return
      this._placesDetailsService.getDetails({
        placeId: prediction.place_id,
        fields: ['geometry'],
        sessionToken: this._placesSessionToken
      }, (place, status) => {
        const OK = window.google.maps.places.PlacesServiceStatus.OK
        if (status !== OK || !place || !place.geometry || !place.geometry.location) return
        const lat = place.geometry.location.lat()
        const lng = place.geometry.location.lng()
        this.mapCenter = { lat, lng }
        this.mapCurrentCenter = { lat, lng }
        this.mapZoom = 17

        // Update input via ref (input ไม่ได้ bind reactive value แล้ว)
        if (this.$refs.placeSearchInput) {
          this.$refs.placeSearchInput.value = prediction.description
        }
        this.placeSearchQuery = prediction.description
        this.placeSearchResults = []

        // Renew session token — session นี้จบแล้ว
        this._placesSessionToken = new window.google.maps.places.AutocompleteSessionToken()
      })
    },

    // บันทึกตำแหน่งหมุด (= center ปัจจุบันของแผนที่)
    async saveMapLocation() {
      if (!this.customerModalResource) return
      this.savingMap = true
      try {
        this.customerInfo = await StockService.saveCustomerInfo(
          this.customerModalResource.CUSCOD,
          {
            lat: this.mapCurrentCenter.lat,
            lng: this.mapCurrentCenter.lng
          }
        )
        this.$bvModal.hide('modal_customer_map')
      } catch (err) {
        console.log('saveMapLocation error', err)
        alert('บันทึกพิกัดไม่สำเร็จ')
      } finally {
        this.savingMap = false
      }
    },

    // เปิด Google Maps เพื่อนำทาง (เปิดในแอป Maps ถ้ามือถือ, เปิดในเว็บ Google Maps ถ้า desktop)
    openNavigation() {
      if (!this.customerInfo || !this.customerInfo.lat || !this.customerInfo.lng) return
      const lat = Number(this.customerInfo.lat)
      const lng = Number(this.customerInfo.lng)
      const url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`
      window.open(url, '_blank')
    },

    // พิมพ์ใบนำขาย — generate PDF จากประวัติสินค้าของลูกค้ารายนี้
    printSalesSheet() {
      if (!this.customerModalResource) return
      if (this.customerProductsLoading) return   // กันพิมพ์ใบว่างตอน PRODUCTS ยังโหลดไม่เสร็จ
      this.$refs.ReportSalesSheet?.generatePdf()
    },

    // คำนวณเลขลำดับต่อเนื่องข้ามหน้า (ต้องตรงกับ ROWS_PER_PAGE ใน salesSheetPages)
    pageRowNumber(pageIdx, rowIdx) {
      const ROWS_PER_PAGE = 34
      return pageIdx * ROWS_PER_PAGE + rowIdx + 1
    },

    // === Customer group select modal ===

    // เปิด modal แล้ว fetch context (current group + used groups + same-amphoe peers)
    async openCustomerGroupModal() {
      if (!this.customerModalResource) return
      this.groupContext = null
      this.groupContextLoading = true
      this.$bvModal.show('modal_select_group_customer')
      try {
        this.groupContext = await StockService.getCustomerGroupContext(this.customerModalResource.CUSCOD)
      } catch (err) {
        console.log('openCustomerGroupModal error', err)
      } finally {
        this.groupContextLoading = false
      }
    },

    // Sync group_id ที่เพิ่ง save → local state ทันที (optimistic UI)
    // - customerModalResource.CUS_GROUP_ID = badge บน modal card
    // - this.customers[i].CUS_GROUP_ID    = badge บน list card (ตอนกลับไปดู)
    // ไม่ต้องรอ refresh จาก backend
    syncCustomerGroupToUI_(newGroupId) {
      if (!this.customerModalResource) return
      // 1. update modal card (Vue.set ไม่จำเป็นเพราะ key มีอยู่แล้ว แต่ใช้ assignment ตรงๆ ก็ reactive)
      this.$set(this.customerModalResource, 'CUS_GROUP_ID', newGroupId)
      // 2. update record ใน list array
      const idx = this.customers.findIndex(c => c.CUSCOD === this.customerModalResource.CUSCOD)
      if (idx >= 0) {
        this.$set(this.customers[idx], 'CUS_GROUP_ID', newGroupId)
      }
    },

    // กดเลข group ใดๆ → save แล้วปิด modal
    async assignCustomerGroup(groupId) {
      if (!this.customerModalResource || groupId == null) return
      try {
        this.customerInfo = await StockService.saveCustomerInfo(
          this.customerModalResource.CUSCOD,
          { group_id: Number(groupId) }
        )
        this.syncCustomerGroupToUI_(Number(groupId))
        this.$bvModal.hide('modal_select_group_customer')
      } catch (err) {
        console.log('assignCustomerGroup error', err)
      }
    },

    // ล้างกลุ่มของลูกค้ารายนี้ — ใช้ clear_fields เพราะ COALESCE ไม่ยอมเซ็ต NULL
    async clearCustomerGroup() {
      if (!this.customerModalResource) return
      if (!confirm('ล้างกลุ่มของลูกค้ารายนี้?')) return
      try {
        this.customerInfo = await StockService.saveCustomerInfo(
          this.customerModalResource.CUSCOD,
          { clear_fields: ['group_id'] }
        )
        this.syncCustomerGroupToUI_(null)
        this.$bvModal.hide('modal_select_group_customer')
      } catch (err) {
        console.log('clearCustomerGroup error', err)
      }
    },

    // User พิมพ์เลขกลุ่มตรงๆ ใน input + กด blur (focus หลุด) → save ทันที
    // - ค่าว่าง = ล้างกลุ่ม
    // - ค่าตัวเลข = assign กลุ่ม
    // - ค่าเหมือนเดิม = ไม่ทำอะไร (skip API call)
    async onCustomerGroupInputBlur(rawValue) {
      if (!this.customerModalResource) return
      const trimmed = (rawValue || '').toString().trim()
      const currentGroup = this.customerInfo ? this.customerInfo.group_id : null

      // ค่าว่าง → ล้างกลุ่ม (ถ้ามี)
      if (trimmed === '') {
        if (currentGroup == null) return    // ไม่มีอะไรเปลี่ยน
        try {
          this.customerInfo = await StockService.saveCustomerInfo(
            this.customerModalResource.CUSCOD,
            { clear_fields: ['group_id'] }
          )
          this.syncCustomerGroupToUI_(null)
        } catch (err) {
          console.log('clear group via input error', err)
        }
        return
      }

      // ค่ามี → parse + validate + save
      const newGroup = parseInt(trimmed, 10)
      if (isNaN(newGroup) || newGroup <= 0) return
      if (newGroup === currentGroup) return     // ค่าเหมือนเดิม skip

      try {
        this.customerInfo = await StockService.saveCustomerInfo(
          this.customerModalResource.CUSCOD,
          { group_id: newGroup }
        )
        this.syncCustomerGroupToUI_(newGroup)
      } catch (err) {
        console.log('save group via input error', err)
      }
    },

    // เปิด modal รายละเอียดบิล (ทับ modal_customer)
    openInvoiceModal(docnum) {
      this.invoiceModalDocnum = docnum
      this.invoice = null                  // reset cache สำหรับบิลใหม่
      this.$bvModal.show('modal_invoice')
      this.loadInvoice(docnum)
    },

    // โหลดรายละเอียดบิล (lazy)
    async loadInvoice(docnum) {
      if (!docnum) return
      if (this.invoiceLoading) return
      this.invoiceLoading = true
      try {
        this.invoice = await StockService.getInvoice(docnum)
      } catch (err) {
        console.log('loadInvoice error', err)
        this.invoice = null
      } finally {
        this.invoiceLoading = false
      }
    },

    // สีของบิลตามสถานะ
    //   overdue → 🔴 red: เกินกำหนด
    //   paid    → 🟢 green: จ่ายแล้ว
    //   unpaid  → ⚫ black (default): ยังไม่ครบกำหนด
    debtStatusColor(status) {
      if (status === 'overdue') return '#dc3545'   // red
      if (status === 'paid')    return '#28a745'   // green
      return null                                  // default black for unpaid
    },

    // บิลที่จ่ายไปบางส่วนแล้ว (ไม่ใช่จ่ายเต็มและไม่ใช่ยังไม่จ่ายเลย)
    // 0.01 tolerance เพื่อกัน floating point edge cases
    isPartialPayment(inv) {
      return inv.outstanding > 0.01 && inv.outstanding < inv.amount - 0.01
    },

    // สีพื้นหลังของการ์ดลูกค้า
    //   🟡 #FFD760 — มีบิลค้างที่เลยวันครบกำหนดเกิน 1 เดือน (HAS_OVERDUE จาก backend)
    //   🟢 #C2EF80 — Active ลูกค้า (ซื้อใน 6 เดือนล่าสุด)
    //   ⚪ #ffffff — Inactive
    customerCardColor(c) {
      if (!c) return '#ffffff'
      if (c.HAS_OVERDUE) return '#FFD760'   // overdue invoice
      if (c.ACTIVE)      return '#C2EF80'   // active
      return '#ffffff'                       // inactive
    },

    // สีขอบการ์ดลูกค้า — เข้าคู่กับสีพื้นหลัง
    //   🟠 #FFC106 — เมื่อพื้นหลังเหลือง (overdue) — โทนอำพันเข้ม
    //   🟢 green   — กรณีอื่น (default — ใช้กับทั้งเขียวและขาว)
    customerCardBorderColor(c) {
      if (c && c.HAS_OVERDUE) return '#FFC106'
      return 'green'
    },

    // วาด dots แสดง visit ของเดือนนี้
    //   เป้า = 2 visits/เดือน
    //   ⚪ = ยังไม่ visit / 🟢 = visit แล้ว
    //   ถ้า visits > 2 → เพิ่ม dot สีเขียวเข้ม (overflow)
    visitDotsHtml(visits) {
      const v = Math.max(0, visits | 0)
      const TARGET = 2
      const filled = '<span style="display:inline-block;width:12px;height:12px;border-radius:50%;background-color:#28a745;margin-left:3px;vertical-align:middle;"></span>'
      const empty  = '<span style="display:inline-block;width:12px;height:12px;border-radius:50%;background-color:transparent;border:1.5px solid #999;margin-left:3px;vertical-align:middle;"></span>'
      // overflow dot สีเข้มกว่า เพื่อแยกจาก dot ปกติ
      const extra  = '<span style="display:inline-block;width:12px;height:12px;border-radius:50%;background-color:#0d6e2e;margin-left:3px;vertical-align:middle;"></span>'

      let html = ''
      for (let i = 0; i < TARGET; i++) {
        html += i < v ? filled : empty
      }
      for (let i = TARGET; i < v; i++) {
        html += extra
      }
      return html
    },

    // เปอร์เซ็นต์ของยอดขายเดือนนี้เทียบกับค่าเฉลี่ย 6 เดือนล่าสุด
    // ตัวอย่าง: avg=100k, this_month=124k → 124%
    //          avg=100k, this_month=47k  → 47%
    salesProgressPercent(c) {
      const avg = c.AVG_SELL_PER_MONTH || 0
      const now = c.SALES_THIS_MONTH || 0
      if (avg <= 0) return 0
      return Math.round((now / avg) * 100)
    },

    // สีของ progress bar + ข้อความ % ตามระดับ
    //   < 60%   → 🔴 red    — ต่ำกว่ามาก
    //   60-90%  → 🟠 orange — ยังไม่ถึงเป้า (ใช้ orange แทน yellow ป้องกัน "สีจม" บน card สีเหลือง + ทำให้ตัวอักษรขาวอ่านได้)
    //   90-110% → 🟢 green  — ใกล้/ตรงเป้า
    //   ≥ 110%  → 🟢 deep   — เกินเป้า
    salesProgressColor(c) {
      const pct = this.salesProgressPercent(c)
      if (pct >= 110) return '#0d6e2e'
      if (pct >= 90)  return '#28a745'
      if (pct >= 60)  return '#fd7e14'
      return '#dc3545'
    },

    // สีของชื่อสินค้าในแท็บประวัติ
    //   regular → 🟢 green: สินค้าประจำของลูกค้ารายนี้ (ซื้อทุกครั้ง / 80%+)
    //   overdue → 🔴 red:   ใกล้หมดสต็อก ต้องสั่งเพิ่ม
    //   normal  → ⚫ black (default): ไม่มีอะไรพิเศษ
    productStatusColor(status) {
      if (status === 'regular') return '#28a745'   // green
      if (status === 'overdue') return '#dc3545'   // red
      return null                                  // null → default black
    },

    // Debounced customer search — input updates DOM natively, customerSearch updates 300ms after typing stops
    onCustomerSearchInput(e) {
      const v = e.target.value
      clearTimeout(this._customerSearchTimer)
      this._customerSearchTimer = setTimeout(() => {
        this.customerSearch = v
      }, 300)
    },

    // เซ็ตค่า search เป็น "gN" → trigger group filter logic ใน filteredCustomers
    // เรียกจากการคลิก กลุ่ม badge บนการ์ดลูกค้า
    // :value="customerSearch" ใน template จะ sync input ให้อัตโนมัติ
    filterByCustomerGroup(groupId) {
      if (groupId == null) return
      // cancel pending debounced typing update (กัน race condition ถ้า user เพิ่งพิมพ์)
      clearTimeout(this._customerSearchTimer)
      this.customerSearch = 'g' + groupId
    },

    // ---------- CUSTOMER LAZY LOAD (infinite scroll) ----------
    // reset กลับไปแสดงชุดแรก + เลื่อนขึ้นบนสุด (เรียกตอน search/sub-tab เปลี่ยน)
    resetCustomerLazyLoad() {
      this.customerVisibleCount = this.customerBatchSize
      this.$nextTick(() => {
        const el = this.$el && this.$el.querySelector('.sticky-top')
        if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'auto', block: 'start' })
        // หลัง reset list สั้นลง sentinel อาจอยู่ในจอเลย → re-observe ให้เช็คใหม่
        this.setupCustomerObserver()
      })
    },

    // โหลดลูกค้าเพิ่มอีก 1 batch (กันเกินจำนวนจริง)
    loadMoreCustomers() {
      if (this.customerVisibleCount >= this.filteredCustomers.length) return
      this.customerVisibleCount += this.customerBatchSize
      // DOM โตขึ้นแล้ว: ถ้า sentinel ยังอยู่ในจอ + ยังมีอีก IntersectionObserver จะไม่ fire ซ้ำเอง
      // (ไม่มี transition) → re-observe เพื่อบังคับเช็ครอบใหม่จนกว่าจะพอเต็มจอหรือหมด list
      this.$nextTick(() => {
        const sentinel = this.$refs.customerLoadMore
        if (this._customerObserver && sentinel && this.hasMoreCustomers) {
          this._customerObserver.unobserve(sentinel)
          this._customerObserver.observe(sentinel)
        }
      })
    },

    // สร้าง (หรือสร้างใหม่) IntersectionObserver ที่จับ sentinel ท้าย list
    setupCustomerObserver() {
      this.teardownCustomerObserver()
      if (typeof IntersectionObserver === 'undefined') return   // SSR / browser เก่า
      const sentinel = this.$refs.customerLoadMore
      if (!sentinel) return
      this._customerObserver = new IntersectionObserver((entries) => {
        if (entries.some(e => e.isIntersecting)) this.loadMoreCustomers()
      }, { root: null, rootMargin: '400px 0px', threshold: 0 })   // prefetch ก่อนถึงท้ายจริง 400px
      this._customerObserver.observe(sentinel)
    },

    // ปิด observer (ตอนออกจาก tab หรือ component ถูกทำลาย)
    teardownCustomerObserver() {
      if (this._customerObserver) {
        this._customerObserver.disconnect()
        this._customerObserver = null
      }
    },

    // จำนวนวันที่ผ่านมาตั้งแต่วันที่กำหนด (ใช้กับ LAST_PURCHASE_DATE)
    daysAgo(dateStr) {
      if (!dateStr) return 0
      return moment().startOf('day').diff(moment(dateStr).startOf('day'), 'days')
    },

    // Format YYYY-MM-DD → DD-MM-YYYY
    formatDateTH(dateStr) {
      if (!dateStr) return '-'
      return moment(dateStr).format('DD-MM-YYYY')
    },

    // คืนข้อความเช่น "5 วันก่อน", "อีก 3 วัน", "วันนี้"
    relativeDays(dateStr) {
      if (!dateStr) return ''
      const days = moment().startOf('day').diff(moment(dateStr).startOf('day'), 'days')
      if (days === 0) return 'วันนี้'
      if (days > 0)   return `${days} วันก่อน`
      return `อีก ${Math.abs(days)} วัน`
    },

    customClick(indices, sorts = ['asc']) {
      indices.forEach((e, idx) => {
        if (idx === 0) this.cols.forEach(o => { if (o.field !== this.cols[e].field) o.sort = '' })
        this.cols[e].sort = sorts[idx] || 'asc'
      })
    },

    click(event, i, fakeShift = null) {
      const sortEl = this.cols[i]
      this.tricker_sss = sortEl.field === "PERCENT"
      if (!event.shiftKey && !fakeShift) {
        this.cols.forEach(o => { if (o.field !== sortEl.field) o.sort = '' })
      }
      if (!sortEl.sort) this.toset = fakeShift != null ? 'asc' : 'desc'
      else if (sortEl.sort === 'desc') this.toset = event.shiftKey || fakeShift ? '' : 'asc'
      else if (sortEl.sort === 'asc') this.toset = 'desc'
      sortEl.sort = this.toset
    },

    sortAsLOCBAL(value) {
      if (value == null) return this.toset === "desc" ? -1 : 100000
      return parseFloat(value)
    },

    sortAsDate(isoDate) {
      if (typeof isoDate === 'string') isoDate = moment(isoDate).toISOString()
      return new Date(isoDate).getTime()
    },

    sortStringAsNumber(str) {
      return str != null && str !== '' ? parseInt(str) : 100000
    },

    clearText() {
      if (this.$refs.search_input) {
        this.$refs.search_input.$el.value = ""
        this.$refs.search_input.$el.dispatchEvent(new Event('input'))
        setTimeout(() => {
          const pages = this.$el.getElementsByClassName('pagination')
          if (pages[0]?.children[1]?.children[0]) {
            pages[0].children[1].children[0].dispatchEvent(new Event('click'))
          }
        }, 1)
      }
    },

    refreshEntries(entries) {
      if (this.$refs.entries_input) {
        this.$refs.entries_input.$el.children[1].value = entries
        this.$refs.entries_input.$el.children[1].dispatchEvent(new Event('change'))
      }
    },

    // ---------- STOCK GROUP (for Report 2) ----------
    stocks_by_STKGRP(STKGRP_) {
      const arr_GRP = ["230A", "110A", "220D", "230C", "220B", "210B", "220C"]
      const primary = this.stocks.filter(e => e.STKGRP === STKGRP_ && e.hide == 0 && e.is_bsts == 1 && e.notify == 1)
      const related = this.stocks.filter(item =>
        primary.find(e => e.SUPNAM_SUPPLIER === item.SUPNAM_SUPPLIER && item.is_bsts == 1 && item.notify == 1
          && e.SUPNAM_SUPPLIER !== "ไม่มีข้อมูลจากประวัติ" && !arr_GRP.includes(item.STKGRP))
      )
      const combined = [...new Set([...primary, ...related])]

      const supplier = {}
      let seq = 1
      combined.forEach(item => {
        if (!item.SUPNAM_SUPPLIER) {
          item.SUPNAM_SUPPLIER = item.SUPNAM || "ไม่มีข้อมูล"
        }
        if (!supplier[item.SUPNAM_SUPPLIER]) supplier[item.SUPNAM_SUPPLIER] = []
        supplier[item.SUPNAM_SUPPLIER].push(item)
      })

      for (const key in supplier) {
        supplier[key].sort((a, b) => a.STKCOD.localeCompare(b.STKCOD))
        supplier[key] = supplier[key].map(item => { item.seq = seq++; return item })
      }
      return supplier
    },

    // ---------- MODAL MANAGEMENT ----------
    async openModal(modalName, index) {
      if (index !== undefined) this.modalResource = index
      if (modalName === 'modal_count_1' || modalName === 'modal_count_2') {
        this.activeStockModalId = modalName
        this.$bvModal.show('modal_stock_detail')
        this.searchMakroPrice()
        // tab ตั้งค่าค้างอยู่จากการเปิดครั้งก่อน → โหลดรูปของสินค้าตัวใหม่เลย
        if (this.productTab === 2) this.loadProductImage()
      } else {
        this.$bvModal.show(modalName)
      }
    },

    closeModal(modalName) {
      if (modalName === 'modal_count_1' || modalName === 'modal_count_2' || modalName === 'modal_stock_detail') {
        this.$bvModal.hide('modal_stock_detail')
      } else {
        this.$bvModal.hide(modalName)
      }
    },

    async closeAllModal() {
      ['modal_select_group_1', 'modal_weight', 'modal_stock_detail',
       'modal_multi_1', 'modal_image'].forEach(id => this.$bvModal.hide(id))
    },

    async openModalFind(modalName, STKCOD) {
      this.modalResource = this.stocks.findIndex(e => e.STKCOD === STKCOD)
      this.activeStockModalId = modalName
      this.$bvModal.show('modal_stock_detail')
      this.searchMakroPrice()
      if (this.productTab === 2) this.loadProductImage()
    },

    async openGroupModal(modalName, field, filter) {
      this.imageDisplay = true
      this.groupFilter = filter
      this.groupField = field
      this.$bvModal.show(modalName)
    },

    openModalCal(i) {
      const s = this.stocks[i]
      if (s.object_log && s.STAT === s.COUNT_STAT) {
        this.calculator = JSON.parse(s.object_log)
      }
      if (!this.isToday(s.counted_at) ||
          (s.STAT !== s.COUNT_STAT && s.STAT != null && s.COUNT_STAT != null) ||
          s.is_overrided) {
        this.calReset()
      }
      this.openModal('modal_multi_1', i)
    },

    openModalWeight(i) {
      this.openModal('modal_weight', i)
    },

    openModalCalLast(i) {
      this.calculator_last = EMPTY_CALCULATOR()
      if (this.stocks[i].counted_at_last === this.today) {
        this.calculator_last = JSON.parse(this.stocks[i].object_log_last)
      }
      this.openModal('modal_multi_last', i)
    },

    // ---------- CALCULATOR ----------
    calReset(last = false) {
      if (last) this.calculator_last = EMPTY_CALCULATOR()
      else this.calculator = EMPTY_CALCULATOR()
    },

    addSmallPal(last = false) {
      const calc = last ? this.calculator_last : this.calculator
      calc.cal_.push({ big: 0, small: 0 })
    },

    addPal(leg = null, last = false) {
      const calc = last ? this.calculator_last : this.calculator
      if (leg != null && calc.cal.length === 1 && calc.cal[0].leg === 0) {
        calc.cal[0].leg = leg
      } else {
        calc.cal.push({ leg: leg || 0, floor: 0, pal: 0 })
      }
    },

    delSmallPal(index, last = false) {
      const calc = last ? this.calculator_last : this.calculator
      if (calc.cal_.length > 1) calc.cal_.splice(index, 1)
      this.delSmallPalTrigger = null
    },

    delPal(index, last = false) {
      const calc = last ? this.calculator_last : this.calculator
      if (calc.cal.length > 1) calc.cal.splice(index, 1)
      this.delPalTrigger = null
    },

    resetDelPal() { this.delPalTrigger = null },
    resetLegEdit() { this.legEditTrigger = false },
    resetDelSmallPal() { this.delSmallPalTrigger = null },

    _calPlus(index) {
      const s = this.stocks[index]
      const plus = s.STAT === 'N' && this.calculator.CHECK_STAT == 1 ? s.ATOM_ORDQTY : 0
      return {
        BIG: plus ? parseInt(Math.floor(plus / s.CFACTOR)) : 0,
        SMALL: plus ? parseInt(plus % s.CFACTOR) : 0,
        ATOM: plus
      }
    },

    // ---------- BARCODE ----------
    focusChanged(event) {
      if (event.target.classList.contains('search-input')) event.target.select()
    },

    addUniqueCode(index) { this.uniqueCodeStateTrigger = index },
    addBarcode(index) { this.barcodeStateTrigger = index },

    async onBarcodeScanned(barcode) {
      this.barCode_key = barcode
      if (this.barcodeStateTrigger == null) { this.findBarcode(barcode); return }
      // ตรวจดูว่า Barcode นี้เคยใช้แล้วหรือไม่?
      if (this.stocks.findIndex(o => o.barcode == barcode) != -1) {
        this.barcodeStateTrigger = null; this.addBarcodeTrigger = false; return
      }
      // Scan ครั้งแรก
      if (this.countScan == 0) { this.currentBarcode = barcode; this.countScan++; return }
      // Scan ครั้งที่สอง
      if ((this.currentBarcode = barcode) && (this.countScan < 3)) { this.countScan++ }
      // Scan ครั้งที่สาม
      if ((this.currentBarcode = barcode) && (this.countScan == 3)) {
        this.stocks[this.barcodeStateTrigger].barcode = barcode
        await this.save(this.barcodeStateTrigger)
        this.barcodeStateTrigger = null
        this.currentBarcode = null
        this.countScan = 0
        this.addBarcodeTrigger = false
      }
      // ถ้าภายใน 3 ครั้งที่ Scan Barcode ไม่เหมือนกันให้เริ่มใหม่
      if (this.currentBarcode != barcode) {
        this.barcodeStateTrigger = null; this.addBarcodeTrigger = false; this.countScan = 0; return
      }
    },

    async findBarcode(barcode) {
      let result = this.stocks.findIndex(o => o.barcode == barcode)
      if (result + 1) {
        await this.closeAllModal()
        this.openModal('modal_count_1', result)
      }
    },

    // ---------- GROUP HELPERS ----------
    createSameGroup(index) {
      this.sameGroup = this.stocks.filter(item =>
        item.SUPNAM_SUPPLIER === this.stocks[index].SUPNAM_SUPPLIER &&
        item.hide == 0 && item.count_code && item.STKCOD !== this.stocks[index].STKCOD
      )
      const usedCodes = [...new Set(
        this.stocks.filter(i => i.count_code).map(i => parseInt(i.count_code))
      )]
      const max = Math.max(...usedCodes) + 1
      const available = Array.from({ length: max }, (_, i) => i + 1).filter(i => !usedCodes.includes(i))
      this.suggestGroup = Math.min(...available)
    },

    // ---------- PDF ----------
    genPDFProgress(e) { this.genPDF = e < 100 },
    hasStartedGeneration() {},
    hasGenerated() {},

    generateReport(report = 1) {
      const refs = { 1: 'Report1', 2: 'Report2', 3: 'Report3' }
      this.$refs[refs[report]]?.generatePdf()
    },

    // ---------- IMAGE GENERATION ----------
    async makeImg2() {
      this.imageDisplay = true
      const img = new Image()
      const dom = this.$refs.domImg2
      const scale = 2
      try {
        const dataUrl = await domtoimage.toJpeg(dom, {
          bgcolor: "white",
          height: dom.offsetHeight * scale,
          width: dom.offsetWidth * scale,
          style: {
            transform: `scale(${scale})`,
            transformOrigin: "top left",
            width: dom.offsetWidth + "px",
            height: dom.offsetHeight + "px"
          }
        })
        img.src = dataUrl
        img.width = dom.offsetWidth
        this.$refs.imgContainer2?.appendChild(img)
        if (/android/i.test(navigator.userAgent)) {
          const link = document.createElement('a')
          link.download = Date.now() + '.jpeg'
          link.href = img.src
          link.click()
        }
      } catch (error) {
        console.error('Image generation failed:', error)
      }
      this.imageDisplay = false
    },

    // ---------- SAVE OPERATIONS ----------
    async save(index) {
      const originalData = { ...this.stocks[index] }
      // จำหน้า pagination ปัจจุบันไว้ก่อน mutate — vue-dataset จะเด้งไปหน้า 1 อัตโนมัติ
      // ทุกครั้งที่จำนวนแถวหลัง filter เปลี่ยน (เช่น ซ่อนสินค้า → หลุดจาก filter → จำนวนลด)
      // เด้งได้หลายรอบ: ตอน mutate (sync) + ตอน socket refreshSoft echo กลับมา (async)
      // จึงใช้ guard เฝ้า dsPage ทั้งช่วง ไม่ใช่ restore ครั้งเดียว
      const ds = this.$refs.productDataset
      const pageBefore = ds ? ds.dsPage : 1
      this.preserveDatasetPage(pageBefore)
      this.recalculateStockPercent(index)

      try {
        const params = {
          STKCOD: this.stocks[index].STKCOD,
          is_bsts: this.stocks[index].is_bsts,
          is_watch: this.stocks[index].is_watch,
          is_sell: this.stocks[index].is_sell,
          is_get_from_sor: Number(this.stocks[index].is_get_from_sor),
          notify: this.stocks[index].notify,
          hide: this.stocks[index].hide,
          order_frequency: this.stocks[index].order_frequency,
          count_code: this.stocks[index].count_code,
          count_day: this.stocks[index].count_day,
          barcode: this.stocks[index].barcode
        }
        Object.assign(this.stocks[index], params)
        const result = await StockService.saveConfig(index, params)
        if (result) this.$socket.client.emit('refreshSoft', { index, data: result })
      } catch (err) {
        Object.assign(this.stocks[index], originalData)
        console.error("Save Error", err)
      }
    },

    // กัน vue-dataset เด้งกลับหน้า 1 หลังจำนวนแถวเปลี่ยน — เฝ้า dsPage สั้นๆ (1.2s)
    // แล้วดึงกลับหน้าเดิมทุกครั้งที่โดนเด้งเป็นหน้า 1 (รองรับทั้ง reset sync ตอน mutate
    // และ reset async ตอน socket refreshSoft echo กลับมา) + clamp ถ้าจำนวนหน้าหดลง
    preserveDatasetPage(pageBefore) {
      if (!pageBefore || pageBefore <= 1) return
      if (this._pageGuardStop) this._pageGuardStop()
      this._pageGuardStop = this.$watch(
        () => { const d = this.$refs.productDataset; return d ? d.dsPage : null },
        (np) => {
          if (np !== 1) return            // เด้งเป็นหน้า 1 เท่านั้นที่ต้องแก้
          const d = this.$refs.productDataset
          if (d) d.setActive(Math.min(pageBefore, d.dsPagecount || 1))
        }
      )
      clearTimeout(this._pageGuardTimer)
      this._pageGuardTimer = setTimeout(() => {
        if (this._pageGuardStop) { this._pageGuardStop(); this._pageGuardStop = null }
      }, 1200)
    },

    recalculateStockPercent(index) {
      const s = this.stocks[index]
      const balance = (s.ATOM_LOCBAL + s.express_DIFF < 0) ? s.ATOM_LOCBAL : s.ATOM_LOCBAL + s.express_DIFF
      let pct = Math.floor((balance / (s.AVG_SEL_PER_DAY_ATOM * s.order_frequency)) * 100) || 0
      pct = isFinite(pct) ? Math.max(pct, 0) : 0
      if (!s.AVG_SEL_PER_DAY_ATOM) pct = 100
      s.PERCENT = pct

      s.WARNING = 0
      if (s.AVG_SEL_PER_DAY_ATOM && pct <= Math.floor((100 / 12) * 4)) s.WARNING = 1
      if (!s.AVG_SEL_PER_DAY_ATOM && s.ATOM_LOCBAL === 0) s.WARNING = 1

      const totalCol = 12
      let colWidth = Math.floor(pct / (100 / totalCol))
      colWidth = Math.max(1, Math.min(12, colWidth))
      let color = s.WARNING ? "bg-warning" : "bg-success"
      if (pct === 100) color = "bg-success"
      if (pct <= 0) color = "bg-danger"
      s.PERCENT_CLASS = `col-${colWidth} ${color}`
    },

    async save_count_stock(index) {
      this.closeModal('modal_multi_1')
      this.productTab = 0
      this.stocks[index].stocksHistoryTrigger = false

      const big = this.calculator.cal.reduce((r, i) => r + parseInt(i.leg * i.floor * i.pal), 0)
        + this.calculator.cal_.reduce((r, i) => r + parseInt(i.big), 0)
        + this._calPlus(index).BIG
      const small = parseInt(this.calculator.cal_[0].small) + this._calPlus(index).SMALL
      const s = this.stocks[index]
      s.COUNT_BIG_LOCBAL = parseInt(big)
      s.COUNT_SMALL_LOCBAL = parseInt(small)
      const leg = (!s.leg || s.leg == 0) ? (this.calculator.cal[0].leg != 0 ? this.calculator.cal[0].leg : 0) : this.calculator.cal[0].leg

      const params = {
        STKCOD: s.STKCOD, _CFACTOR: s.CFACTOR, leg,
        COUNT_STAT: s.STAT, COUNT_BIG_LOCBAL: s.COUNT_BIG_LOCBAL,
        COUNT_SMALL_LOCBAL: s.COUNT_SMALL_LOCBAL,
        COUNT_ATOM: (s.COUNT_BIG_LOCBAL * s.CFACTOR) + s.COUNT_SMALL_LOCBAL,
        make_order: parseInt(s.make_order),
        object_log: JSON.stringify(this.calculator),
        user: 1, counted_at: this.today
      }
      const params2 = {
        STKCOD: s.STKCOD, _CFACTOR: s.CFACTOR, START_STOCK: null,
        peter_ATOM: s.ATOM_LOCBAL + s.express_DIFF,
        express_ATOM: (s.BIG_LOCBAL * s.CFACTOR) + s.SMALL_LOCBAL,
        COUNT_ATOM: (s.COUNT_BIG_LOCBAL * s.CFACTOR) + s.COUNT_SMALL_LOCBAL,
        counted_at: this.today, ship_in_ref: s.LLK_DOC,
        adjust_ref: s.ADJUST?.length ? JSON.stringify(s.ADJUST.map(e => e.ADJUST_DOCNUM)) : null,
        is_today_adjust: s.is_today_adjust
      }

      try {
        const result = await StockService.saveStocksCount(index, params, params2)
        if (result) {
          Object.assign(s, result)
          this.$socket.client.emit('refreshSoft', { index, data: result })
        }
        s.stocksHistoryTrigger = true
      } catch (err) { console.log("Save count stock Error", err) }
    },

    async save_count_stock_last(index) {
      this.closeModal('modal_multi_last')
      this.productTab = 0
      this.stocks[index].stocksHistoryTrigger = false

      const big = this.calculator_last.cal.reduce((r, i) => r + parseInt(i.leg * i.floor * i.pal), 0)
        + this.calculator_last.cal_.reduce((r, i) => r + parseInt(i.big), 0)
        + this._calPlus(index).BIG
      const small = parseInt(this.calculator_last.cal_[0].small) + this._calPlus(index).SMALL
      const s = this.stocks[index]
      s.COUNT_BIG_LOCBAL_LAST = parseInt(big)
      s.COUNT_SMALL_LOCBAL_LAST = parseInt(small)

      const params = {
        STKCOD: s.STKCOD, _CFACTOR_LAST: s.CFACTOR,
        COUNT_BIG_LOCBAL_LAST: s.COUNT_BIG_LOCBAL_LAST,
        COUNT_SMALL_LOCBAL_LAST: s.COUNT_SMALL_LOCBAL_LAST,
        COUNT_ATOM_LAST: (s.COUNT_BIG_LOCBAL_LAST * s.CFACTOR) + s.COUNT_SMALL_LOCBAL_LAST,
        object_log_last: JSON.stringify(this.calculator_last),
        user_last: 1, counted_at_last: this.today
      }

      try {
        const result = await StockService.saveStocksCountLast(index, params)
        if (result) {
          Object.assign(s, result)
          this.$socket.client.emit('refreshSoft', { index, data: result })
        }
        s.stocksHistoryTrigger = true
      } catch (err) { console.log("Save count stock last Error", err) }
    },

    async del_count_stock(index) {
      this.stocks[index].stocksHistoryTrigger = false
      const s = this.stocks[index]
      const params = {
        STKCOD: s.STKCOD, COUNT_STAT: null, COUNT_BIG_LOCBAL: null,
        COUNT_SMALL_LOCBAL: null, COUNT_ATOM: null, make_order: s.make_order,
        object_log: null, user: s.user, counted_at: s.counted_at,
        is_today_adjust: s.is_today_adjust
      }

      try {
        const result = await StockService.deleteStocksCount(index, params)
        if (result) {
          Object.assign(s, result)
          this.$socket.client.emit('refreshSoft', { index, data: result })
        }
        s.stocksHistoryTrigger = true
      } catch (err) { console.log("Delete count stock Error", err) }
    },

    async save_make_order(index) {
      this.stocks[index].makeOrderTrigger = true
      const params = {
        STKCOD: this.stocks[index].STKCOD,
        make_order: parseInt(this.stocks[index].make_order),
        ordered_at: this.today
      }
      try {
        const result = await StockService.saveMakeOrder(index, params)
        if (result) {
          Object.assign(this.stocks[index], result)
          this.$socket.client.emit('refreshSoft', { index, data: result })
        }
        this.stocks[index].makeOrderTrigger = false
      } catch (err) { console.log("Save Make Order Error", err) }
    },

    async del_make_order(index) {
      this.stocks[index].makeOrderTrigger = true
      const params = { STKCOD: this.stocks[index].STKCOD, make_order: 0, ordered_at: null }
      try {
        const result = await StockService.deleteMakeOrder(index, params)
        if (result) {
          Object.assign(this.stocks[index], result)
          this.$socket.client.emit('refreshSoft', { index, data: result })
        }
        this.stocks[index].makeOrderTrigger = false
      } catch (err) { console.log("Delete make order Error", err) }
    },

    async save_weight(index) {
      this.closeModal('modal_weight')
      const s = this.stocks[index]
      const weights = [s.weight_1, s.weight_2, s.weight_3].filter(w => w != null).map(w => parseFloat(w))
      const avg = weights.reduce((sum, w) => sum + w, 0) / weights.length
      const params = { STKCOD: s.STKCOD, weight: avg, weight_1: s.weight_1, weight_2: s.weight_2, weight_3: s.weight_3 }
      const original = { ...s }
      Object.assign(s, params)
      try {
        const result = await StockService.saveStocksWeight(index, params)
        if (result) this.$socket.client.emit('refreshSoft', { index, data: result })
      } catch (err) {
        Object.assign(s, original)
        console.error("Error saving weight:", err)
      }
    },

    async addNote(index) {
      const original = { ...this.stocks[index] }
      const s = this.stocks[index]
      s.is_noted = s.noted ?? 0
      s.BACKGROUND_CLASS = s.is_noted ? "bg-secondary-x" : s.WARNING ? "bg-warning-x border-warning" : "bg-success-x border-success"

      try {
        const params = { STKCOD: s.STKCOD, noted: s.noted, noted_at: this.today }
        Object.assign(s, params)
        const result = await StockService.saveNote(index, params)
        if (result) this.$socket.client.emit('refreshSoft', { index, data: result })
      } catch (err) {
        Object.assign(this.stocks[index], original)
        console.error("Save Error", err)
      }
    },

    async delNote(index) {
      const original = { ...this.stocks[index] }
      const s = this.stocks[index]
      s.is_noted = null
      s.is_po = 0
      s.BACKGROUND_CLASS = s.WARNING ? "bg-warning-x border-warning" : "bg-success-x border-success"

      try {
        const params = { STKCOD: s.STKCOD, noted: null, noted_at: null }
        Object.assign(s, params)
        const result = await StockService.deleteNote(index, params)
        if (result) this.$socket.client.emit('refreshSoft', { index, data: result })
      } catch (err) {
        Object.assign(this.stocks[index], original)
        console.error("Save Error", err)
      }
    },

    async addImage(index) {
      try {
        const params = { STKCOD: this.stocks[index].STKCOD, image_data: this.stocks[index].image_data }
        Object.assign(this.stocks[index], { image_data: this.stocks[index].image_data })
        await StockService.saveImage(index, params)
      } catch (err) { console.error("Error saving image:", err) }
    },

    // ---------- MAKRO PRICE SEARCH ----------
    searchMakroPrice() {
      // Fire-and-forget: completely isolated from main app
      // If Makro API is down/slow, it only affects the Makro price box
      const TIMEOUT_MS = 5000

      this.makroProducts = []
      this.makroLoading = true
      this.makroSearched = false
      this.makroError = false

      try {
        const s = this.currentStock
        if (!s.barcode) { this.makroLoading = false; return }
        const query = s.barcode.replace(/^0+/, '')
        if (!query) { this.makroLoading = false; return }

        const timeoutPromise = new Promise((_, reject) =>
          setTimeout(() => reject(new Error('timeout')), TIMEOUT_MS)
        )

        Promise.race([
          StockService.searchMakro(query, 5),
          timeoutPromise
        ]).then(data => {
          this.makroProducts = (data.hits || []).map(hit => {
            const doc = hit.document || hit
            const images = doc.images || []
            const price = doc.displayPrice || 0
            const uf = doc.unitFactor || 1
            const orig = doc.originalPrice || 0
            return {
              id: doc.id || '',
              name: doc.title || '',
              nameEn: doc.titleEn || '',
              price,
              perUnitPrice: uf > 1 ? Math.round((price / uf) * 100) / 100 : price,
              unitFactor: uf,
              originalPrice: orig,
              discount: orig > price ? `-${Math.round(((orig - price) / orig) * 100)}%` : '',
              image: images[0] || '',
            }
          }).filter(p => p.name && p.price > 0)
        }).catch(() => {
          this.makroProducts = []
          this.makroError = true
        }).finally(() => {
          this.makroLoading = false
          this.makroSearched = true
        })
      } catch (e) {
        // If anything goes wrong even setting up the call
        this.makroProducts = []
        this.makroLoading = false
        this.makroSearched = true
        this.makroError = true
      }
    }
  }
}
</script>

<style lang="scss">
// ==================== LAYOUT & STRUCTURE ====================
.loading-overlay {
  width: 100%; height: 80%; z-index: 999;
  display: flex; align-items: center; justify-content: center;
  flex-direction: column; text-align: center;

  .loading-icon { font-size: 5rem; }
  .loading-text { padding: 0 4px; font-size: 1.25rem; font-weight: bold; }
}

.print-fab {
  width: 60px; height: 60px; position: fixed; z-index: 999;
  bottom: 30px; left: 30px; border-radius: 1em;
  line-height: 60px; vertical-align: middle; font-size: 2em;
  border: 1px solid black; text-align: center; cursor: pointer;
  background-color: #ffc107 !important;
}

// ==================== REPORT STYLES ====================
.cell-empty {
  width: 100%; border: 1px solid #aaa;
}

.truck-box {
  width: 100%; border: 1px solid #888; height: 140px;
}

.footer-label {
  font-size: 0.8em; position: absolute; top: 0; left: 13px;
}

.footer-box {
  width: 100%; text-align: center;
  border: 1px solid #999; height: 50px;
  position: relative; line-height: 60px; vertical-align: bottom;
}

.footer-box-empty {
  width: 100%; border: 1px solid #999; height: 50px;
}

// Stock group report styles
.stock-grp-name {
  position: relative; padding: 1px; border-bottom: 1px solid #999; border-left: 1px solid #999;
}

.stock-grp-sell {
  width: 200px; padding: 1px; border-bottom: 1px solid #999; color: #777; font-size: 0.9em; text-align: left;
}

.stock-grp-bar {
  text-align: center; position: relative; color: black; width: 80px;
  padding: 1px; border-bottom: 1px solid #111; border-left: 1px solid #111; border-right: 1px solid #111;
}

.stock-grp-bar-text {
  position: absolute; z-index: 990; font-size: 1.1em; left: 0; right: 0; top: 0;
}

.stock-grp-bar-bg {
  padding: 0; text-align: center; position: absolute; left: 0; top: 0; width: 100%; height: 100%;
}

.truncate-170 {
  display: inline-block; width: 170px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}

.truncate-120 {
  display: inline-block; width: 120px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}

// ==================== MODAL STYLES ====================
.unit-badge {
  padding: 4px 8px; text-align: center; font-weight: bold; min-width: 35px;
  border-radius: 0.25rem; font-size: 1em;
}

.unit-badge-x {
  padding: 4px; text-align: center; font-weight: bold; border-radius: 0.25rem; font-size: 1em;
}

.percent-bar {
  border: 1px solid black; border-radius: 0.25rem; position: relative;
}

.percent-bar-label {
  padding-left: 8px; position: absolute; z-index: 990;
}

.big-unit-text {
  font-size: 3em; line-height: 50px;
}

.scan-label {
  position: relative; top: -6px; font-size: 0.6em; line-height: 1px;
}

.unique-code-input {
  width: 100%; padding: 4px; font-size: 0.4em; text-align: left; font-weight: bold;
}

.action-badge {
  color: white; margin-left: 8px; padding: 0 8px; cursor: pointer; border-radius: 0.25em;
}

.history-num {
  display: inline-block; min-width: 18px; line-height: 18px;
  border-radius: 3em; text-align: center; color: white; font-weight: bold;
  background-color: #28a745 !important;
}

.page-dot {
  width: 25px; height: 25px; line-height: 25px; vertical-align: middle;
  border: 1px solid rgb(246, 190, 0); margin-right: 3px; cursor: pointer;
}

.express-stock-box {
  background: #ADD8E6; border: 2px solid #72BCD4;
}

.history-box {
  background: #F0E2B6; border: 2px solid rgb(246, 190, 0); position: relative;
}

.cus-legend {
  /* dot ต้องมี height จริง — div ว่างที่มีแค่ line-height จะสูง 0 ทำให้สีไม่แสดง */
  display: inline-block; width: 14px; height: 14px;
  border-radius: 50%; padding: 0; margin: 0 3px; vertical-align: middle;
}

.cus-legend-text {
  font-size: 0.9em;
}

.cus-num {
  display: inline-block; min-width: 18px; line-height: 18px;
  border-radius: 3em; text-align: center; color: white; font-weight: bold;
  background-color: #28a745 !important;
}

.day-picker {
  border: 1px solid #eee; border-radius: 0.25em; cursor: pointer;
}

.group-select-badge {
  position: absolute; left: -3px; top: -28px; font-size: 0.9em; cursor: pointer;
}

.weight-box {
  border-radius: 0.25em; border: 1px solid #eee; cursor: pointer;
}

/* ====== Product image (tab ตั้งค่า) ====== */
.product-image-box {
  border-radius: 0.25em; border: 1px solid #eee;
}
.product-image-box:not(.bg-warning) {
  border-style: dashed; border-color: #ccc;
}
/* thumbnail จัตุรัส 1:1 — ใช้ padding-top hack แทน aspect-ratio (รองรับ Safari เก่า) */
.product-image-square {
  position: relative; width: 100%; padding-top: 100%;
  border-radius: 4px; overflow: hidden; cursor: pointer; background: #fff;
}
.product-image-square img {
  position: absolute; top: 0; left: 0; width: 100%; height: 100%;
  object-fit: cover;
}
.product-image-btn {
  flex: 1; text-align: center; padding: 10px 4px;
  background: #fff; border: 1px solid #ddd; border-radius: 0.25em;
  cursor: pointer; font-size: 1.4em; line-height: 1.3; user-select: none;
  transition: background 0.12s ease, transform 0.08s ease;
}
.product-image-btn .small {
  font-size: 0.6em;
}
.product-image-btn:hover {
  background: #FFD760;
}
.product-image-btn:active {
  transform: scale(0.96);
}

/* AI find image link + result grid */
.ai-find-link {
  display: inline-block; cursor: pointer; user-select: none;
  font-size: 0.95em; font-weight: 600; color: #0d6efd;
  padding: 4px 10px; border-radius: 0.25em; border: 1px dashed #0d6efd;
}
.ai-find-link:hover { background: #eaf2ff; }
.ai-img-cell {
  position: relative; width: 100%; padding-top: 100%;
  border-radius: 4px; overflow: hidden; cursor: pointer;
  border: 1px solid #ddd; background: #f5f5f5;
  transition: border-color 0.12s ease, transform 0.08s ease;
}
.ai-img-cell img {
  position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover;
}
.ai-img-cell:hover { border-color: #0d6efd; }
.ai-img-cell:active { transform: scale(0.97); }
.ai-img-busy { pointer-events: none; opacity: 0.5; }

.weight-icon-wrap {
  position: absolute; top: 63%; left: 50%; transform: translate(-50%, -50%);
}

// ==================== MAKRO PRICE ====================
.makro-price-box {
  background: #f7f9fc; border: 1px solid #d0dbe8; border-radius: 0.4rem;
  padding: 8px 10px;
}

.makro-logo {
  background: #0055a5; color: white; font-size: 0.7em;
  padding: 1px 6px; border-radius: 3px; letter-spacing: 0.5px;
}

.makro-item {
  background: white; border: 1px solid #e8ecf0; border-radius: 0.3rem;
  padding: 6px 8px;
}

.makro-thumb {
  width: 36px; height: 36px; object-fit: contain; border-radius: 4px;
  background: #f8f8f8; flex-shrink: 0;
}

.makro-thumb-empty {
  width: 36px; height: 36px; border-radius: 4px;
  background: #eee; flex-shrink: 0;
}

.makro-price {
  font-size: 0.95em; color: #0055a5;
}

.makro-discount {
  font-size: 0.6em; color: white; background: #dc2626;
  padding: 0 4px; border-radius: 3px; font-weight: 700;
}

.makro-original {
  font-size: 0.65em; color: #999; text-decoration: line-through;
}

// ==================== COMMON UTILITY CLASSES ====================
.no-padding td { padding-top: 0 !important; padding-bottom: 0 !important; margin: 0 !important; }

.form-control:focus {
  box-shadow: 0 0 0 rgba(0,0,0,0) inset !important;
  outline: none !important;
}

input:focus::-webkit-input-placeholder { opacity: 0; }

.text-yellow { color: yellow !important; }
.text-not-count { color: #888 !important; }
.text-fade { color: #ddd; }
.sticky-top { top: 10px !important; }

.border-tab {
  border-left: 1px solid #ddd; border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd; border-bottom-left-radius: 0.25em;
  border-bottom-right-radius: 0.25em;
}

.vue-barcode-element { width: 100% !important; height: 100% !important; }
.old_count_stock { opacity: 0.5; filter: grayscale(100%); }
.grayscale { opacity: 0.8; filter: grayscale(100%); }

// Modal overrides
.peter-modal {
  .modal-header, .modal-dialog, .modal-content, .modal-footer { border: 0; }
}
.modal-backdrop { background: white !important; opacity: 1 !important; }

.noselect {
  -webkit-touch-callout: none; -webkit-user-select: none;
  -moz-user-select: none; -ms-user-select: none; user-select: none;
}

// Color utility classes
.bg-orange { background: orange !important; }
.bg-gray { background: #ddd; }
.bg-warning-x { background: #FFD760 !important; }
.bg-success-x { background: #C2EF81 !important; }
.bg-secondary-x { background: #aaa !important; }
.bg-danger-x { background: #FF8886 !important; }
.border-danger-x { border: 1px solid #FF6863 !important; }
.bg-light-green { background: #C2EF81 !important; }
.fadex { opacity: 0.15 !important; }
.fadex2 { opacity: 0.3 !important; }

// Radio buttons
.peter-radio {
  display: block !important;
  label { text-align: left !important; padding-left: 10px; }
  label.active { font-weight: bold; border: 1px solid #ddd !important; }
  input[type="radio"] { position: relative !important; margin-right: 8px !important; }
}

input.largerCheckbox { display: none; width: 28px; height: 28px; }

// Main button
.main_button {
  border: 1px solid #ddd !important; border-radius: 0.25em;
  &.active {
    background: #dc3545; font-weight: bold !important;
    color: white !important; border: 1px solid #dc3545 !important;
  }
}

// Sort indicators
.gg-select {
  position: relative; display: block; width: 22px; height: 22px;
  &::after, &::before {
    content: ''; display: block; position: absolute;
    width: 8px; height: 8px; left: 7px; transform: rotate(-45deg);
  }
  &::before { border-left: 2px solid; border-bottom: 2px solid; bottom: 4px; opacity: 0.3; }
  &::after { border-right: 2px solid; border-top: 2px solid; top: 4px; opacity: 0.3; }
}

th.sort {
  cursor: pointer; user-select: none;
  &.asc .gg-select::after { opacity: 1; }
  &.desc .gg-select::before { opacity: 1; }
}

.customer-product-row {
  transition: background-color 0.12s ease;
}
.customer-product-row:hover {
  background-color: #f0f4f8;
}

.customer-type-box {
  cursor: pointer;
  user-select: none;
  transition: filter 0.12s ease, transform 0.08s ease;
}
.customer-type-box:hover {
  filter: brightness(0.95);
}
.customer-type-box:active {
  transform: scale(0.97);
}

/* ====== Customer image upload UI ====== */
.customer-image-container {
  position: relative;
  overflow: hidden;
  border-radius: 4px;
}
.customer-image {
  width: 100%;
  display: block;
  border-radius: 4px;
}

/* State 1: bottom strip with 2 buttons (no image yet) */
.image-buttons-strip {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  gap: 4px;
  padding: 4px;
  background: rgba(0, 0, 0, 0.45);
}
.image-action-btn {
  flex: 1;
  text-align: center;
  padding: 8px 0;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 3px;
  cursor: pointer;
  font-size: 1.3em;
  line-height: 1;
  user-select: none;
  transition: background 0.12s ease, transform 0.08s ease;
}
.image-action-btn:hover {
  background: #FFD760;
}
.image-action-btn:active {
  transform: scale(0.94);
}

/* State 2: floating ⋯ trigger + popup menu (has image) */
.image-menu-trigger {
  position: absolute;
  bottom: 6px;
  right: 6px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.55);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1.3em;
  font-weight: bold;
  line-height: 1;
  user-select: none;
  transition: background 0.12s ease;
}
.image-menu-trigger:hover {
  background: rgba(0, 0, 0, 0.8);
}

.image-menu-popup {
  position: absolute;
  bottom: 42px;
  right: 6px;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 140px;
  z-index: 10;
  overflow: hidden;
}
.image-menu-item {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 0.85em;
  white-space: nowrap;
  user-select: none;
  transition: background 0.12s ease;
}
.image-menu-item:hover {
  background: #f0f4f8;
}

/* Loading overlay during upload */
.image-loading-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ====== Customer image lightbox modal ====== */
.customer-image-lightbox {
  position: relative;
  background: #000;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}
.lightbox-image {
  display: block;
  max-width: 100%;
  max-height: 80vh;
  width: auto;
  height: auto;
  object-fit: contain;
}
.lightbox-close {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  font-size: 1.2em;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  transition: background 0.12s ease;
}
.lightbox-close:hover {
  background: rgba(0, 0, 0, 0.85);
}

/* ====== Customer map modal ====== */
.map-modal-search {
  position: relative;
  padding-bottom: 10px;
  background: #fff;
  border-bottom: 1px solid #dee2e6;
}
.map-modal-search input {
  width: 100%;
}
.map-search-dropdown {
  position: absolute;
  top: calc(100% - 1px);
  left: 10px;
  right: 10px;
  background: white;
  border: 1px solid #dee2e6;
  border-top: none;
  border-radius: 0 0 4px 4px;
  max-height: 240px;
  overflow-y: auto;
  z-index: 10;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
}
.map-search-item {
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  user-select: none;
  transition: background 0.12s ease;
}
.map-search-item:last-child {
  border-bottom: none;
}
.map-search-item:hover {
  background: #f0f4f8;
}
.map-modal-container {
  position: relative;
  width: 100%;
  height: 50vh;
  min-height: 360px;
  background: #e8e8e8;
}
.map-center-pin {
  position: absolute;
  top: 50%;
  left: 50%;
  /* offset so the bottom-tip of the emoji sits at exact center */
  transform: translate(-50%, -100%);
  font-size: 36px;
  pointer-events: none;
  z-index: 5;
  filter: drop-shadow(0 2px 3px rgba(0, 0, 0, 0.4));
  user-select: none;
}
.map-hint {
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 0.8em;
  pointer-events: none;
  z-index: 5;
  white-space: nowrap;
}

/* Skeleton loading - shimmer effect */
.skeleton-box {
  display: inline-block;
  background: linear-gradient(90deg, #e8e8e8 0%, #f5f5f5 50%, #e8e8e8 100%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.4s infinite;
  border-radius: 4px;
}
@keyframes skeleton-shimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>